"use strict";

angular
  .module("app.services", [])
  .factory(
    "HttpService",
    function ($http, $q, $rootScope, $configService, $storageService) {
      /**
       * Handles a generic error
       */
      function basicErrorCallback(error, hideErrorMessage) {
        if (hideErrorMessage) {
          console.log("HttpService error callback! Returning to service..");
          return $q.reject(error.data);
        }

        /**
         * Switch on response.status to handle special errors
         */
        switch (error.status) {
          case -1:
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_CONN_REFUSED",
            });
            break;
          case 401:
            // logout the user
            $configService.logout();
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_401",
            });
            break;
          case 409:
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_409",
            });
            break;
          case 423:
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_423",
            });
            break;
          case 500:
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_500",
            });
            break;
          default:
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_500",
            });
            break;
        }

        return $q.reject(error);
      }

      /**
       * Basic success callback
       */
      function basicSuccessCallback(response) {
        /** Handle success * */
        if (!response.data.keyMessage) $q.resolve(response.data);

        /** Handle success * */
        if (response.data.success) return $q.resolve(response.data);

        /** Handle success false, applicative error * */
        if (!response.data.success) {
          // Messaggi specifici
          // 1. Cambio nome simulazione, mostrare messaggio con variabile
          if (response.data.keyMessage == "WF_SIM_NAME_NOT_UNIQUE") {
            $rootScope.$broadcast("addAlert", {
              text: response.data.keyMessage,
              otherText: $storageService.get("wfTitle"),
            });
            return $q.resolve(response.data);
          }

          // In caso di errore gestito, mostriamo messaggio
          if (response.data.keyMessage) {
            /*
        $rootScope.$broadcast("addAlert", {  commento provvisorio per provare alcune funzionalità
          text: response.data.keyMessage
        });
        */
            $rootScope.$broadcast("addAlert", {
              text: response.data.keyMessage,
              message: response.data.message,
            });
            return $q.resolve(response.data);
          }

          // Caso utente bloccato
          if (response.data.keyMessage == "ERROR_USER_BLOCKED") {
            $rootScope.goTo("/logout");
            return $q.reject(response.data);
          }

          return $q.resolve(response.data);
        }
      }

      /**
       * Basic success callback downloadFile
       */
      function basicSuccessCallbackDownload(response) {
        /** Handle success * */
        if (!response.data.keyMessage) $q.resolve(response.data);

        /** Handle success * */
        if (response.data) return $q.resolve(response);

        /** Handle success false, applicative error * */
        if (!response.data.success) {
          // Messaggi specifici
          // 1. Cambio nome simulazione, mostrare messaggio con variabile
          if (response.data.keyMessage == "WF_SIM_NAME_NOT_UNIQUE") {
            $rootScope.$broadcast("addAlert", {
              text: response.data.keyMessage,
              otherText: $storageService.get("wfTitle"),
            });
            return $q.resolve(response.data);
          }

          // In caso di errore gestito, mostriamo messaggio
          if (response.data.keyMessage) {
            $rootScope.$broadcast("addAlert", {
              text: response.data.keyMessage,
              message: response.data.message,
            });
            return $q.resolve(response.data);
          }

          return $q.resolve(response.data);
        }
      }

      /**
       * Send a basic POST
       */
      function send(path, data) {
        var hideErrorMessage =
          arguments.length > 2 && arguments[2] !== undefined ?
            arguments[2] :
            false;
        var api =
          arguments.length > 3 && arguments[3] !== undefined ?
            arguments[3] :
            true;
        var url = api ? $configService.getUrl() + path : path;

        var config = {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + $configService.initAppConfig().token || "no-token",
            "App-Name": $rootScope.portalName,
            "Practice-Id": $rootScope.practiceId
          },
        };

        return $http
          .post(url, data, config)
          .then(basicSuccessCallback, basicErrorCallback);
      }

      function sendMultipart(path, data) {
        var hideErrorMessage =
          arguments.length > 2 && arguments[2] !== undefined ?
            arguments[2] :
            false;
        var api =
          arguments.length > 3 && arguments[3] !== undefined ?
            arguments[3] :
            true;
        var url = api ? $configService.getUrl() + path : path;

        var config = {
          headers: {
            "Content-Type": undefined,
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + $configService.initAppConfig().token || "no-token",
            "App-Name": $rootScope.portalName,
            "Practice-Id": $rootScope.practiceId
          },
        };

        return $http
          .post(url, data, config)
          .then(basicSuccessCallback, basicErrorCallback);
      }

      /**
       * Send a basic GET
       */
      function get(path, data) {
        var url = $configService.getUrl() + path;
        const currentDate = new Date();
        const timestamp = currentDate.getTime();
        data &&
          Object.assign(data, {
            timestamp: timestamp,
          });
        var config = {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + $configService.initAppConfig().token || "no-token",
            "App-Name": $rootScope.portalName,
            "Practice-Id": $rootScope.practiceId
          },
          params: data,
        };

        return $http
          .get(url, config)
          .then(basicSuccessCallback, basicErrorCallback);
      }

      /**
       * Send a basic GET
       */

      /**
       * Download GET
       */
      function dooGet(path, data) {
        var url = $configService.getUrl() + path;
        const currentDate = new Date();
        const timestamp = currentDate.getTime();
        data &&
          Object.assign(data, {
            timestamp: timestamp,
          });
        return $http({
          method: "GET",
          url: url,
          params: data,
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + $configService.initAppConfig().token || "no-token",
            "App-Name": $rootScope.portalName,
            "Practice-id": $rootScope.practiceId
          },
        }).then(basicSuccessCallbackDownload, basicErrorCallback);
      }

      /**
       * Download POST
       */

      function dooPost(path, data) {
        var url = $configService.getUrl() + path;
        const currentDate = new Date();

        const timestamp = currentDate.getTime();
        data &&
          Object.assign(data, {
            timestamp: timestamp,
          });
        return $http({
          method: "POST",
          url: url,
          responseType: "arraybuffer",
          data: data,
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + $configService.initAppConfig().token || "no-token",
            "App-Name": $rootScope.portalName,
            "Practice-Id": $rootScope.practiceId
          },
        }).then(basicSuccessCallbackDownload, basicErrorCallback);
      }

      /**
       * Public interface
       */
      return {
        send: send,
        sendMultipart: sendMultipart,

        get: get,

        dooGet: dooGet,
        dooPost: dooPost
      };
    }
  )

  .factory("$storageService", function () {
    var prefix = "alba-";

    function set(id, value) {
      if (typeof value === "object") {
        value = JSON.stringify(value);
      }
      sessionStorage.setItem(prefix + id, value);
    }

    function get(id) {
      var value = sessionStorage.getItem(prefix + id);
      try {
        return JSON.parse(value);
      } catch (e) {
        console.log("storageService could not get this item: " + id);
        return value;
      }
    }

    function clean() {
      sessionStorage.clear();
    }

    return {
      /** Base * */
      get: get,

      set: set,

      clean: clean,

      /** Specialized getters and setters * */
      setAppConfig: function (appConfig) {
        set("appConfig", appConfig);
      },

      getAppConfig: function () {
        return get("appConfig") || null;
      },

      getPermissions: function () {
        return get("appConfig.permissions") || null;
      },
    };
  })

  .service("$portalService", function () {
    function resolveContextApplicationName(appContext) {
      switch (appContext) {
        case "portal-list/arf/":
          return "ILEAF_ARF";
        case "portal-list/ara/":
          return "ILEAF_ARA";
        case "portal-list/aru/":
          return "ILEAF_ARU";
      }
    }

    var isAru = function () {
      if (resolveContextApplicationName(context) == "ILEAF_ARU") {
        return true;
      }
      return false;
    };
    var isAra = function () {
      if (resolveContextApplicationName(context) == "ILEAF_ARA") {
        return true;
      }
      return false;
    };
    var isArf = function () {
      if (resolveContextApplicationName(context) == "ILEAF_ARF") {
        return true;
      }
      return false;
    };

    return {
      resolveContextApplicationName: resolveContextApplicationName,
      isAru: isAru,
      isAra: isAra,
      isArf: isArf,
    };
  })

  /**
   * Centralized configurations
   */
  .factory(
    "$configService",
    function (
      $storageService,
      PermissionFactory,
      $portalService,
      FactoryObj,
      $location,
      $rootScope
    ) {
      /** Private * */
      var fetchUrl = function () {
        return window.localStorage.getItem("apiUrl") || apiUrl;
      };

      /** Private Api * */
      var appConfig = {
        propMap: initializePropMap(),
        permissions: null,
        user: null,
        token: "no-token",
        url: fetchUrl(),
      };

      /** Private function to store the appConfig * */
      var store = function (newAppConfig) {
        if (newAppConfig) {
          $storageService.setAppConfig(newAppConfig);
        }
      };

      var isUserLogged = function () {
        return !!(appConfig && appConfig.user);
      };

      var updateUser = function (user) {
        if (user) {
          var appConfig = $storageService.getAppConfig();
          appConfig.user = user;
          store(appConfig);
        }
      };

      /***************************************************************************
       * If appConfig is into the store use that one, else default, then return it
       **************************************************************************/
      var initAppConfig = function () {
        if ($storageService.getAppConfig()) {
          appConfig = $storageService.getAppConfig();
          appConfig.url = fetchUrl();
          $storageService.setAppConfig(appConfig)
        } else {
          store({
            url: fetchUrl(),
            token: "no-token",
          });
        }
        return appConfig;
      };

      /** Public Api * */
      var initialize = function (
        appUser,
        appToken,
        appCertificate,
        fePermissionList,
        allFunctionalities,
        userType,
        envData,
        sideMenu,
        topMenu
      ) {
        // Initialize the user
        appConfig.user = appUser && appUser;
        appConfig.token = appToken && appToken;
        appConfig.certificate = appCertificate && appCertificate;
        appConfig.envData = envData && envData;

        // If there are permissions, set them
        if (
          typeof fePermissionList != "undefined" &&
          fePermissionList &&
          fePermissionList.length > 0
        ) {
          appConfig.permissions = PermissionFactory.initialize(
            fePermissionList,
            userType
          );
          console.log('*************************** LISTA PERMESSI', fePermissionList);
          
        } else {
          // otherwise wipe them up
          PermissionFactory.clean();
        }
        if (
          typeof allFunctionalities != "undefined" &&
          allFunctionalities &&
          allFunctionalities.length > 0
        ) {
          appConfig.allFunctionalities = allFunctionalities;
        }
        if (typeof sideMenu != "undefined" && sideMenu) {
          appConfig.sideMenu = sideMenu;
        }

        if (typeof topMenu != "undefined" && topMenu) {
          appConfig.topMenu = topMenu;
        }

        // Store app config
        store(appConfig);
      };

      /**
       * @param appUser
       * @param appToken
       * @param appCertificate
       *            (only ARU, else 'null')
       * @param fePermissionList
       */
      var init = function (response, token) {
        /***********************************************************************
         * E-COMMERCE LOGIN
         * Check response consistency, just check for the token
         **********************************************************************/
        if (!response && token) {
          initialize(null, token, null, null, null);
          return;
        }

        /***********************************************************************
         * CANONICAL LOGIN
         * Check response consistency, throwing a blocking exception if it fails
         **********************************************************************/
        if (!response || !response.appUser || !response.appToken) {
          console.error(
            "ConfigService init exception! Either appUser or appToken were undefined! Aborting"
          );
        }

        initialize(
          response.appUser,
          response.appToken,
          response.getCertFirmaResponse ?
            response.getCertFirmaResponse.certResponse.listCertificatoFirma[0] :
            null,
          response.allUniFePermission,
          response.allFunctionalities,
          response.appUser.type,
          response.envData,
          response.sideMenu,
          response.topMenu
        );

        //}
      };

      function logout() {
        if (FactoryObj && FactoryObj.itemWf) FactoryObj.itemWf = null;
        $storageService.clean();
        var url = appConfig.url;
        $rootScope.menuNavBar = undefined;
        appConfig = {};
        appConfig.url = url;
        appConfig.token = "no-token";
        setMenuState(false);
        $location.path("/logout");
      }

      /** Init * */
      initAppConfig();

      function getUser() {
        if (appConfig) return appConfig.user;
      }

      function getUserType() {
        if (getUser()) return getUser().type;
      }

      function getUserStatus() {
        if (getUser()) {
          return getUser().status;
        }
      }

      function isUserEnabled() {
        return (
          getUser() && getUserStatus() == getProperty("USER_STATUS_ENABLED")
        );
      }

      function isUserExpiredPassword() {
        return (
          getUser() && getUserStatus() == getProperty("USER_PASSWORD_EXPIRED")
        );
      }

      function userIsVendorNA() {
        if (getUser()) {
          return getUserType() == getProperty("USER_TYPE_VENDOR_NA");
        }
      }

      function userIsVendorNaRegistering() {
        return (
          userIsVendorNA() &&
          getUserStatus() == getProperty("USER_STATUS_NEW_USER_R")
        );
      }

      function userIsRegistering() {
        if (
          getUserStatus() == "NEW_USER_R" ||
          getUserStatus() == "RECOVERYPASSWORD" ||
          getUserStatus() == "EXPIREDPASSWORD"
        ) {
          return true;
        }
        return false;
      }

      function isUserRecovering() {
        if (getUserStatus() == "RECOVERYPASSWORD") {
          return true;
        }
        return false;
      }

      function getToken() {
        if (appConfig && appConfig.token) {
          return appConfig.token;
        }
      }

      function getUrl() {
        if (appConfig && appConfig.url) {
          return appConfig.url;
        }
      }

      function getProperty(key) {
        if (key) {
          return propMap && propMap[key];
        }
      }

      function getCertificate() {
        if (appConfig) return appConfig.certificate;
      }

      return {
        initAppConfig: initAppConfig,

        /** PropMap * */
        getPropMap: function () {
          return propMap;
        },

        getProperty: getProperty,

        isUserExpiredPassword: isUserExpiredPassword,

        getCertificate: getCertificate,

        /** User * */
        getUser: getUser,

        updateUser: updateUser,

        isUserLogged: isUserLogged,

        getUserStatus: getUserStatus,

        userIsRegistering: userIsRegistering,

        getToken: getToken,

        getUrl: getUrl,

        isUserRecovering: isUserRecovering,

        userIsVendorNaRegistering: userIsVendorNaRegistering,

        userIsVendorNA: userIsVendorNA,

        isUserEnabled: isUserEnabled,

        isNewUser: function () {
          return getUserStatus() == getProperty("USER_STATUS_NEW_USER");
        },

        /** * */

        getAppConfig: function () {
          return appConfig;
        },

        /**
         * Use this method to init configs at every refresh token
         *
         * @param responseLogin -
         *            a response like the one returned from login
         */
        init: init,

        /**
         *
         * @description Logs out the user: 1. Cleans the session storage 2.
         *              Redirects to /logout 3. Lets menu disappear
         */
        logout: logout,
      };
    }
  )

  .factory("$menuService", function ($timeout, $rootScope) {
    function show() {
      $timeout(function () {
        if ($("#menu-container")) {
          $("#menu-container").show();
        }
      });
    }

    function hide() {
      $timeout(function () {
        if ($("#menu-container")) {
          $("#menu-container").hide();
        }
      });
    }

    function openPasswordRecovery() {
      openPswRecovery();
    }

    function openPasswordRecoveryNuArc() {
      openPswRecoveryNuArc();
    }

    function closePasswordRecovery() {
      closePswRecovery();
    }

    return {
      show: show,

      hide: hide,

      openPasswordRecovery: openPasswordRecovery,

      closePasswordRecovery: closePasswordRecovery,

      openPasswordRecoveryNuArc: openPasswordRecoveryNuArc,
    };
  })

  .factory("$financialService", function (HttpService, $q) {
    function getListAppPreventive(filter) {
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/financial/getListAppPreventive",
        filter
      ).then(function (response) {
        console.log("$financialService::getListAppPreventive::then" + response);
        return $q.resolve(response);
      });
    }

    function getAllLeasingProducts() {
      return HttpService.send(
        "/simulator/financial/getAllLeasingProducts", {},

        true
      ).then(function (response) {
        console.log(
          "$financialService::getAllLeasingProducts::then" + response
        );
        return $q.resolve(response && response.listAppNsilProdotti);
      });
    }

    function getAllFacilitations(cdProd) {
      var model = {
        cdProd: cdProd,
      };
      return HttpService.send(
        "/simulator/financial/getAllFacilitations",
        model,
        true
      ).then(function (response) {
        console.log("$financialService::getAllFacilitations::then" + response);
        return $q.resolve(response && response.listAppNsilAgevolazioni);
      });
    }

    function getAllConventions() {
      return HttpService.send(
        "/simulator/financial/getAllConventions", {},

        true
      ).then(function (response) {
        console.log("$financialService::getAllConventions::then" + response);
        return $q.resolve(response && response.listAppNsilConvenzioni);
      });
    }

    function getAllPaymentModes() {
      return HttpService.send(
        "/simulator/financial/getAllPaymentModes", {},

        true
      ).then(function (response) {
        console.log("$financialService::getAllPaymentModes::then" + response);
        return $q.resolve(response && response.listAppNsilTipoPagamento);
      });
    }

    function getDelayDays(cdProd) {
      var model = {
        cdProd: cdProd,
      };
      return HttpService.send(
        "/simulator/financial/getDelayDays",
        model,
        true
      ).then(function (response) {
        console.log("$financialService::getDelayDays::then" + response);
        return $q.resolve(response && response.appNsilGiorniDilazione);
      });
    }

    function getRischioInCorso(cdProd) {
      var model = {
        partitaIva: cdProd,
      };

      return HttpService.send(
        "/simulator/financial/getRischioInCorso",
        model,
        true
      ).then(function (response) {
        console.log("GetRichioInCorso: " + response);
        return $q.resolve(response);
      });
    }

    function insertAppPreventive(metadata) {
      var model = {
        appFinancialPreventive: {
          metadata: {
            financialModel: metadata,
          },
        },
      };

      return HttpService.send(
        "/simulator/financial/insertAppPreventive",
        model,
        true
      ).then(function (response) {
        console.log("insertAppPreventive: " + response);
        return $q.resolve(response);
      });
    }

    function getQuestionario(cdProd, prevQuestionnaires) {
      var model = {
        type: cdProd,
        prevQuestionnaires: prevQuestionnaires,
      };
      return HttpService.send(
        "/simulator/financial/getQuestionario",
        model,
        true
      )
        .then(function (response) {
          console.log("getQuestionario: " + response);
          return $q.resolve(response);
        })
        .catch(function (err) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_NEXT",
          });
          return $q.reject(err);
        });
    }

    function getRatingCGS(cdProd) {
      var model = {
        partitaIva: cdProd,
      };

      return HttpService.send(
        "/simulator/financial/getRatingCGS ",
        model,
        true
      ).then(function (response) {
        console.log("getRatingCGS: ", response);
        return $q.resolve(response);
      });
    }

    function accettaPreventivo(anno, preventivo) {
      var model = {
        annoPreventivo: anno,
        numeroPreventivo: preventivo,
      };
      return HttpService.send(
        "/simulator/financial/accettaPreventivo ",
        model,
        true
      ).then(function (response) {
        console.log("Accetta Preventivo:", response);
        return $q.resolve(response);
      });
    }

    function listPractice(filter) {
      return HttpService.get(
        "/simulator/financial/listPractice",
        filter,
        false
      ).then(function (response) {
        console.log("Pratiche: " + response);
        return $q.resolve(response);
      });
    }

    function economicConditionDetail(financialModel) {
      var input = {
        viewIndex: financialModel.viewIndex,
        idWfinstance: financialModel.idWfInstance,
        financialVendor: financialModel.financialVendor,
        financialCustomer: financialModel.financialCustomer,
        leasingData: financialModel.leasingData,
      };
      return HttpService.send(
        "/simulator/financial/economicConditionDetail",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getPeriodicita(codProdotto, vendorNdg) {
      var input = {
        cdProdotto: codProdotto,
        vendorNdg: vendorNdg,
      };
      return HttpService.get("/simulator/financial/getPeriodicita", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function infoTassi(
      dataTasso,
      reteVendita,
      codiceProdotto,
      convenzioni,
      durata,
      cdAgevolazioni,
      tipoTasso,
      ndgVenditore,
      convenzionePlafond,
      listino,
      importo
    ) {
      var input = {
        dataTasso: dataTasso,
        reteVendita: reteVendita,
        codiceProdotto: codiceProdotto,
        convenzioni: convenzioni,
        durata: durata || 0,
        cdAgevolazioni: cdAgevolazioni,
        tipoTasso: tipoTasso,
        ndgVenditore: ndgVenditore,
        convenzionePlafond: convenzionePlafond,
        listino: listino,
        importo: importo
      };

      return HttpService.send("/simulator/financial/infoTasso", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function updateAgvCnvList(
      agevolazioni,
      convenzioni,
      codiceProdotto,
      reteVendita,
      riUserG,
      agvMaster,
      ndgVenditore,
      abiVenditore
    ) {
      var input = {
        agevolazioni: agevolazioni,
        convenzioni: convenzioni,
        codiceProdotto: codiceProdotto,
        reteVendita: reteVendita,
        riUserG: riUserG,
        agvMaster: agvMaster,
        ndgVenditore: ndgVenditore,
        abiVenditore: abiVenditore,
      };
      return HttpService.send("/simulator/financial/updateAgvCnvList", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deletePractice(input) {
      return HttpService.send("/simulator/financial/eliminaPratica", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function calcolaCanone(
      preventivo,
      reteVendita,
      mansioneAziendale,
      mansioni
    ) {
      var input = {
        preventivo: preventivo,
        reteVendita: reteVendita,
        mansioneAziendale: mansioneAziendale,
        mansioni: mansioni,
      };

      return HttpService.send("/simulator/financial/calcolaCanone", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function calcolaTasso(
      preventivo,
      reteVendita,
      mansioneAziendale,
      mansioni
    ) {
      var input = {
        preventivo: preventivo,
        reteVendita: reteVendita,
        mansioneAziendale: mansioneAziendale,
        mansioni: mansioni,
      };
      return HttpService.send("/simulator/financial/calcolaTasso", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getNotePreventivo(id) {
      var input = {
        id: id,
      };

      return HttpService.get("/simulator/preventive/notes", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function hoFinito(idPratica) {
      var input = {
        id: idPratica,
      };
      return HttpService.get("/simulator/hf", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q, reject(error);
        });
    }

    function getIdentificazioneSaved(idPratica) {
      var input = {
        id: idPratica,
      };

      return HttpService.send("/simulator/getIdentificazioneSaved", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getProcedureContratto(id) {
      var input = {
        idPractice: id,
      };
      return HttpService.get("/simulator/procedure/contratto", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q, reject(error);
        });
    }

    function stipula(idPratica) {
      var input = {
        id: idPratica,
      };
      return HttpService.send("/simulator/financial/stipula", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q, reject(error);
        });
    }

    function validateBeneContratto(prodotto, idProdotto) {
      var input = {
        beneContratto: prodotto,
        id: idProdotto,
      };
      return HttpService.send(
        "/simulator/financial/validateBeneContratto",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q, reject(error);
        });
    }

    function getHistoryLO(idContratto) {
      var input = {
        idContract: idContratto
      }

      return HttpService.send("/simulator/contract/getHistory", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function statoFirmaLO(idContratto) {

      var input = {
        idContract: idContratto
      }

      return HttpService.send("/simulator/contract/statoFirma", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }
    function getValoriIndici(
      dataTasso,
      reteVendita,
      codiceProdotto,
      convenzioni,
      durata,
      cdAgevolazioni,
      tipoTasso,
      ndgVenditore,
      convenzionePlafond,
      modalitaCalcoloTasso
    ) {
      var input = {
        dataTasso: dataTasso,
        reteVendita: reteVendita,
        codiceProdotto: codiceProdotto,
        convenzioni: convenzioni,
        durata: durata || 0,
        cdAgevolazioni: cdAgevolazioni,
        tipoTasso: tipoTasso,
        ndgVenditore: ndgVenditore,
        convenzionePlafond: convenzionePlafond,
        modalitaCalcoloTasso: modalitaCalcoloTasso
      };

      return HttpService.send("/simulator/financial/getValoriIndici", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getConvenzionamento(ndg) {

      var input = {
        fornitore: ndg
      }

      return HttpService.send("/simulator/getConvenzionamento", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function saveConvenzionamento(convenzione, idOP, saveOnlyTypeVendor) {

      var input = {
        convenzione: convenzione,
        idOP: idOP,
        saveOnlyTypeVendor: saveOnlyTypeVendor
      };

      return HttpService.send("/simulator/saveConvenzionamento", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function getVendorCatalog(identifier) {

      var input = {
        identifierAppVendor: identifier
      };

      return HttpService.send("/simulator/getVendorCatalog", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function uploadFakeCatalog(ndg, idOP, catalogType) {

      var input = {
        idUser: ndg,
        idOP: idOP,
        catalogType: catalogType
      };

      return HttpService.send("/simulator/uploadFakeCatalog", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function checkAttivazioneFornitore(appCustomerUser) {
      var input = {
        user: appCustomerUser,
      }

      return HttpService.send("/simulator/checkAttivazioneFornitore", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function saveAttivazioneFornitore(gestioneFornitori) {

      return HttpService.send("/simulator/saveAttivazioneFornitore", gestioneFornitori)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function eraseDocumentFromAlbagreen(documentClass, ndgCliente, uuid) {
      var input = {
        documentClass: documentClass,
        ndgCliente: ndgCliente,
        uuid: uuid
      }

      return HttpService.send("/simulator/eraseDocumentFromAlbagreen ", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function getCheckListPreistruttoria(numeroContratto, modulo) {
      var input = {
        numeroContratto: numeroContratto,
        modulo: modulo
      }

      return HttpService.send("/simulator/getCheckListPreistruttoria", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function uploadDocOnOpsAg(input) {
      return HttpService.sendMultipart("/uni/uploadDocOnOpsAg", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function insertUniOperation(uniOperation) {
      var input = {
        uniOperation: uniOperation,
      };

      return HttpService.send("/uni/insertUniOperation", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deleteChecklistPreIst(downloadKey) {
      var input = {
        downloadKey: downloadKey,
      };

      return HttpService.send("/uni/deleteChecklistPreIst", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function insertPreIstr(idContract) {
      var input = {
        idContract: idContract,
      }

      return HttpService.send("/simulator/insertPreIstr", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function checkNdgListino(ndgListino) {
      var input = {
        ndgListino: ndgListino,
      }

      return HttpService.send("/simulator/checkNdgListino", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function changeAgentLogin(gestioneFornitori) {

      return HttpService.send("/simulator/changeAgentLogin", gestioneFornitori)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    return {
      getListAppPreventive: getListAppPreventive,
      getAllLeasingProducts: getAllLeasingProducts,
      getAllFacilitations: getAllFacilitations,
      getAllConventions: getAllConventions,
      getAllPaymentModes: getAllPaymentModes,
      getDelayDays: getDelayDays,
      getRischioInCorso: getRischioInCorso,
      insertAppPreventive: insertAppPreventive,
      getQuestionario: getQuestionario,
      getRatingCGS: getRatingCGS,
      accettaPreventivo: accettaPreventivo,
      listPractice: listPractice,
      economicConditionDetail: economicConditionDetail,
      getPeriodicita: getPeriodicita,
      infoTassi: infoTassi,
      updateAgvCnvList: updateAgvCnvList,
      deletePractice: deletePractice,
      calcolaCanone: calcolaCanone,
      calcolaTasso: calcolaTasso,
      getNotePreventivo: getNotePreventivo,
      hoFinito: hoFinito,
      getIdentificazioneSaved: getIdentificazioneSaved,
      getProcedureContratto: getProcedureContratto,
      stipula: stipula,
      validateBeneContratto: validateBeneContratto,
      getHistoryLO: getHistoryLO,
      statoFirmaLO: statoFirmaLO,
      getValoriIndici: getValoriIndici,
      getConvenzionamento: getConvenzionamento,
      saveConvenzionamento: saveConvenzionamento,
      getVendorCatalog: getVendorCatalog,
      uploadFakeCatalog: uploadFakeCatalog,
      checkAttivazioneFornitore: checkAttivazioneFornitore,
      saveAttivazioneFornitore: saveAttivazioneFornitore,
      eraseDocumentFromAlbagreen: eraseDocumentFromAlbagreen,
      getCheckListPreistruttoria: getCheckListPreistruttoria,
      uploadDocOnOpsAg: uploadDocOnOpsAg,
      insertUniOperation: insertUniOperation,
      deleteChecklistPreIst: deleteChecklistPreIst,
      insertPreIstr: insertPreIstr,
      checkNdgListino: checkNdgListino,
      changeAgentLogin: changeAgentLogin

    };
  })

  .factory("$featureService", function () {
    function AralDownloadCatalog() {
      return false;
    }

    function AralSimulationRi() {
      return false;
    }

    function AralNotificationToId() {
      return true;
    }

    function ArfDigitalSign() {
      return true;
    }

    function ArfNewMenu() {
      return true;
    }

    function ArfSelectUserMonitoring() {
      return false;
    }

    function ArfPrintContractDetail() {
      return true;
    }

    function FatturzioneElettronica() {
      return true;
    }

    function NewPrivacy() {
      return true;
    }

    function AdvancedSearchHome() {
      return true;
    }
    // disabilitare le funzuionalità home ara
    function AdvancedSearchHomeFunctionAra() {
      return false;
    }

    function ArfSelectUserMonitoring() {
      return true;
    }

    function ArfPrintContractDetail() {
      return true;
    }

    function abiCabFlag() {
      return true;
    }

    function prenventiveTable() {
      return true;
    }

    return {
      AralDownloadCatalog: AralDownloadCatalog,
      AralSimulationRi: AralSimulationRi,
      AralNotificationToId: AralNotificationToId,
      ArfDigitalSign: ArfDigitalSign,
      ArfNewMenu: ArfNewMenu,
      ArfSelectUserMonitoring: ArfSelectUserMonitoring,
      ArfPrintContractDetail: ArfPrintContractDetail,
      FatturzioneElettronica: FatturzioneElettronica,
      NewPrivacy: NewPrivacy,
      abiCabFlag: abiCabFlag,
      prenventiveTable: prenventiveTable,
      AdvancedSearchHome: AdvancedSearchHome,
      AdvancedSearchHomeFunctionAra: AdvancedSearchHomeFunctionAra,
    };
  })

  .service("$sharedService", function ($location) {
    var self = this;

    self.simulation = {};

    function getSimulation() {
      return self.simulation;
    }

    function setSimulation(sim) {
      self.simulation = sim;
    }

    function clean() {
      self.simulation = {};
    }

    return {
      getSimulation: getSimulation,
      setSimulation: setSimulation,
      clean: clean,
    };
  })

  .factory("FactoryObj", function () {
    return {};
  })

  .factory("$giuridicVersion", function ($configService) {
    const newLegalForm = $configService.getAppConfig().envData.legalFormPrfActive;
    function isDittaIndividuale(formaGiuridica) {
      if (newLegalForm) {
        return formaGiuridica == "IND" ||
          formaGiuridica == "DIN" ||
          formaGiuridica == "PEF" ||
          formaGiuridica == "PRF"


      } else {
        return formaGiuridica == "IND" ||
          formaGiuridica == "DIN" ||
          formaGiuridica == "PEF"
      }
    }

    function checkIfInd(formaGiuridica) {

      if (newLegalForm) {
        return formaGiuridica == "IND" || formaGiuridica == "PRF"
      } else {
        return formaGiuridica == "IND"
      }

    }
    return {
      isDittaIndividuale: isDittaIndividuale,
      checkIfInd: checkIfInd
    };
  })

  /**
   * It handles all the application's validation rules, regex etc..
   */
  .factory("validationService", function () {
    function getDocTypeRegex(docType) {
      switch (docType) {
        case "CAE":
          return /^[A-z0-9]{1,15}$/;
        case "CAI":
          return /^[A-z]{2}[0-9]{7}$/;
        case "CIE":
          return /^[0-9]{7}[A-z]{2}$/;
        case "NCE":
          return /^[A-z]{2}[0-9]{5}[A-z]{2}$/;
        case "PAM":
          return /^[A-z]{2}[0-9]{7}[A-z]{1}$/;
        case "PAT":
          return /^[A-z0-9]{7,15}$/;
        case "UCO":
          return /^[uU][A-z0-9]{8}[A-z]{1}$/;
        case "PAS":
          return /^[A-z0-9]{7,15}$/;
        default:
          return /^[A-z0-9]+$/;
      }
    }

    var emailRegex =
      /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,50})$/;

    var passwordRegex =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[?!$+-/.,@_=])(?=\S+$).{8,16}$/;

    var passphraseRegex =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[?!$+-/.,@_=])(?=\S+$).{8,16}$/;

    var pivaRegex = /^[0-9]{11}$/;

    var cfRegex =
      /^((?:[aeiouB-DF-HJ-NP-TV-Z](?:[aeiouAEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z]|(?:[b-df-hj-np-tv-z](?:[aeiou]{2}|[aeiou]x)|[aeiou]{2}x|[b-df-hj-np-tv-z]{2}[a-z]){2}[\dlmnp-v]{2}(?:[a-ehlmpr-t](?:[04lq][1-9mnp-v]|[1256lmrs][\dlmnp-v])|[dhps][37pt][0l]|[acelmrt][37pt][01lm])(?:[a-mz][1-9mnp-v][\dlmnp-v]{2}|[a-m][0l](?:[\dlmnp-v][1-9mnp-v]|[1-9mnp-v][0l]))[a-z])$/i;

    var pivaOrCfRegex =
      /^[0-9]{9,12}|(?:[B-DF-HJ-NP-TV-Z](?:[AEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z]$/i;

    var telRegex = /^[0-9]+$/;

    var telWithPrefixRegex = /^([0-9]{5,11})$/;

    var prefixRegex =
      /^0[1-9]([0-9]{1,2})*$|^00[1-9]([0-9]{1,5})*$|^3[0-9]{2}$/;

    var mobileRegex = /^((\+|00)[1-9]([0-9]{1,5})?)?\d{3}\d{6,7}$/;

    var contractNumberRegex = /^[0-9]{0,8}$/;

    var moduleNumberRegex = /^[0-9]{1}$/;

    //var contractNumber = /^[0-9]{0,8}$/;

    var ndgRegex = /^[0-9]{8,9}$/;

    var cdDestinatarioRegex = /^[A-Za-z0-9]{7}$/;

    var cdRiferimentoAmministrativoRegex = /^.[\w\s]{0,19}$/;

    var genericRegex = /^[0-9]{5}$/;

    var ragSocRegex = /^[^<>].[^<>]*$/;

    var cciaaRegex = /^[0-9]{1,7}$/;

    var documentNumber = /.+/;

    var year = /^[0-9]{4}$/;

    var quoteNumber = /^[0-9]{0,8}$/;

    var rifAmmRegex = /^\s*(?:\S\s*){1,20}$/;

    var urlRegex =
      /^(https?:\/\/)([\w\-])+\.{1}([a-zA-Z]{2,63})([\/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)$/;

    var numberPreventiveRegex = /^[0-9]{4}$/;

    var numIscrizioneAlboRegex = /^[a-zA-z0-9]{1,10}$/;

    var capRegex = /^[0-9]{1,5}$/;

    var codConvenzione = /^[A-z0-9]{3}$/;

    var ibanRegex = /(^IT\d{2}[A-Z]{1}\d{10}[A-Z0-9]{12}$)/;



    function checkCf(cf, form, inputName) {
      if (cf) {
        if (ndgRegex.test(cf[0])) {
          if (!pivaRegex.test(cf)) {
            form[inputName].$invalid = true;
            form[inputName].$setValidity &&
              form[inputName].$setValidity("cf", false);
            form[inputName].$valid = false;
          } else {
            form[inputName].$invalid = false;
            form[inputName].$setValidity &&
              form[inputName].$setValidity("cf", true);
            form[inputName].$valid = true;
          }
        } else {
          cf = cf.toUpperCase();
          if (cf == "") return "";
          if (!cfRegex.test(cf)) {
            if (form) {
              form[inputName].$invalid = true;
              form[inputName].$setValidity &&
                form[inputName].$setValidity("cf", false);
              form[inputName].$valid = false;
              return false;
            }
          }
          var map = [
            1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19,
            21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23,
          ];
          var s = 0;
          for (var i = 0; i < 15; i++) {
            var c = cf.charCodeAt(i);
            if (c < 65) c = c - 48;
            else c = c - 55;
            if (i % 2 == 0) s += map[c];
            else s += c < 10 ? c : c - 10;
          }
          var atteso = String.fromCharCode(65 + (s % 26));
          if (atteso != cf.charAt(15)) {
            form[inputName].$invalid = true;
            form[inputName].$setValidity &&
              form[inputName].$setValidity("cf", false);
            form[inputName].$valid = false;
            return false;
          }

          form[inputName].$invalid = false;
          form[inputName].$setValidity &&
            form[inputName].$setValidity("cf", true);
          form[inputName].$valid = true;
          return true;
        }
      } else {
        if (form && inputName) {
          form[inputName].$invalid = false;
          form[inputName].$setValidity &&
            form[inputName].$setValidity("cf", true);
          form[inputName].$valid = true;
        }
        return false;
      }
    }

    function validateCf(cf) {
      if (cf) {
        if (ndgRegex.test(cf[0])) {
          if (!pivaRegex.test(cf)) {
            return;
          }
        } else {
          cf = cf.toUpperCase();
          if (cf == "") return "";

          var map = [
            1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19,
            21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23,
          ];
          var s = 0;
          for (var i = 0; i < 15; i++) {
            var c = cf.charCodeAt(i);
            if (c < 65) c = c - 48;
            else c = c - 55;
            if (i % 2 == 0) s += map[c];
            else s += c < 10 ? c : c - 10;
          }
          var atteso = String.fromCharCode(65 + (s % 26));
          if (atteso != cf.charAt(15)) {
            return false;
          }

          return true;
        }
      } else {
        return false;
      }
    }

    function checkPiva(pi) {
      if (pi == "") {
        return true;
      }

      //check carattere di controllo
      var s = 0;
      for (i = 0; i <= 9; i += 2) s += pi.charCodeAt(i) - "0".charCodeAt(0);
      for (var i = 1; i <= 9; i += 2) {
        var c = 2 * (pi.charCodeAt(i) - "0".charCodeAt(0));
        if (c > 9) c = c - 9;
        s += c;
      }
      var atteso = (10 - (s % 10)) % 10;
      if (atteso != pi.charCodeAt(10) - "0".charCodeAt(0)) {
        //return "La partita IVA non è valida:\n" +
        //"il codice di controllo non corrisponde.\n";
        return false;
      }

      return true;
    }

    function validateFieldFatturazioneElettronica(
      cdDestinatarioFatturazione,
      emailFatturazioneElettronica
    ) {
      // Bisogna inserire o il destinatario della fatturazione, oppure
      // l'email, quello che inserisce deve essere corretto.
      //04-05-2023 EVO rollbackata

      if (
        (cdDestinatarioFatturazione &&
          this.isValidCdDestinatario(cdDestinatarioFatturazione) &&
          !emailFatturazioneElettronica) ||
        (emailFatturazioneElettronica &&
          this.isValidEmail(emailFatturazioneElettronica) &&
          !cdDestinatarioFatturazione) ||
        (emailFatturazioneElettronica &&
          this.isValidEmail(emailFatturazioneElettronica) &&
          cdDestinatarioFatturazione &&
          this.isValidCdDestinatario(cdDestinatarioFatturazione))
      ) {
        return true;
      }


      if (
        !this.isValidCdDestinatario(cdDestinatarioFatturazione) &&
        !this.isValidEmail(emailFatturazioneElettronica)
      ) {
        return false;
      }
      return true;
    }

    function checkCfWithFieds(
      cf,
      name,
      surname,
      dateOfBirth,
      sesso,
      codCityOfBirth
    ) {
      if (
        !cf ||
        !name ||
        !surname ||
        !dateOfBirth ||
        !sesso ||
        !codCityOfBirth
      ) {
        return {
          value: false,
          error: "Dati mancanti, controlla i campi",
        };
      }
      var tempCf = cf;
      var isOmocodia = false;
      var indexToCheck = [6, 7, 9, 10, 12, 13, 14];
      var tableOmocodia = ['L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V'];

      Object.values(cf).forEach(function (element, index) {

        if (indexToCheck.includes(index) && isNaN(element)) {
          isOmocodia = true;
          temp = Object.values(tempCf);

          temp[index] = tableOmocodia.indexOf(element);
          tempCf = temp.join("");
        }

      })
      surname = surname.toUpperCase();
      surname = surname.replace(/[']/g, "");
      surname = surname.replace(/ /gi, "");
      surname = surname.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A");
      surname = surname.replace(/È|É|Ê|Ë/gi, "E");
      surname = surname.replace(/Ì|Í|Î|Ï/gi, "I");
      surname = surname.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O");
      surname = surname.replace(/Ù|Ú|Û|Ü/gi, "U");

      name = name.toUpperCase();
      name = name.replace(/[']/g, "");
      name = name.replace(/ /gi, "");
      name = name.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A");
      name = name.replace(/È|É|Ê|Ë/gi, "E");
      name = name.replace(/Ì|Í|Î|Ï/gi, "I");
      name = name.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O");
      name = name.replace(/Ù|Ú|Û|Ü/gi, "U");
      codCityOfBirth = codCityOfBirth.toUpperCase();
      cf = cf.toUpperCase();
      var cfCostruct = "";
      var cognome =
        surname.replace(/[AEIOU-]/gi, "") +
        surname.replace(/[^AEIOU]/gi, "") +
        "X";
      var nome = name.replace(/[AEIOU-]/gi, "");
      if (nome.length > 3) {
        nome = nome.substring(0, 1) + nome.substring(2);
      }
      var temp = name.replace(/[^AEIOU]/gi, "") + "X";
      nome = nome + temp;
      var day = dateOfBirth.substring(0, 2);
      var mounth = dateOfBirth.substring(3, 5);
      var year = dateOfBirth.substring(8, 10);
      if (sesso.toLocaleLowerCase() === "f") {
        day = parseInt(day) + 40;
      }
      var mese = ["A", "B", "C", "D", "E", "H", "L", "M", "P", "R", "S", "T"];

      cfCostruct =
        cognome.substring(0, 3) +
        nome.substring(0, 3) +
        year +
        mese[mounth - 1] +
        day +
        codCityOfBirth;
      var map = [
        1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 2,
        4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23,
      ];
      var s = 0;
      for (var i = 0; i < 15; i++) {
        var c = cfCostruct.charCodeAt(i);
        if (c < 65) c = c - 48;
        else c = c - 55;
        if (i % 2 == 0) s += map[c];
        else s += c < 10 ? c : c - 10;
      }
      var atteso = String.fromCharCode(65 + (s % 26));
      if (cognome.substring(0, 3) != cf.substring(0, 3)) {
        return {
          value: false,
          error: "Cognome diverso da quello atteso",
        };
      }
      if (nome.substring(0, 3) != cf.substring(3, 6)) {
        return {
          value: false,
          error: "Nome diverso da quello atteso",
        };
      }
      cfCostruct =
        cognome.substring(0, 3) +
        nome.substring(0, 3) +
        year +
        mese[mounth - 1] +
        day +
        codCityOfBirth +
        atteso;
      if (!isOmocodia) {
        if (cf === cfCostruct) {
          return {
            value: true,
            error: null,
          };
        } else {
          return {
            value: false,
            error: "Errore generico nei dati",
          };
        }

      } else {
        var p = 0;
        for (var i = 0; i < 15; i++) {
          var c = tempCf.charCodeAt(i);
          if (c < 65) c = c - 48;
          else c = c - 55;
          if (i % 2 == 0) p += map[c];
          else p += c < 10 ? c : c - 10;
        }
        var provvisorio = String.fromCharCode(65 + (p % 26));
        tempCf = tempCf.substring(0, 15).concat(provvisorio);
        if (tempCf === cfCostruct) {
          return {
            value: true,
            error: null,
          };
        } else {
          return {
            value: false,
            error: "Errore generico nei dati",
          };
        }

      }

    }

    function createCf(name, surname, dateOfBirth, sesso, codCityOfBirth) {
      if (!name || !surname || !dateOfBirth || !sesso || !codCityOfBirth) {
        return false;
      }
      surname = surname.toUpperCase();
      surname = surname.replace(/[']/g, "");
      surname = surname.replace(/ /gi, "");
      surname = surname.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A");
      surname = surname.replace(/È|É|Ê|Ë/gi, "E");
      surname = surname.replace(/Ì|Í|Î|Ï/gi, "I");
      surname = surname.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O");
      surname = surname.replace(/Ù|Ú|Û|Ü/gi, "U");

      name = name.toUpperCase();
      name = name.replace(/[']/g, "");
      name = name.replace(/ /gi, "");
      name = name.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A");
      name = name.replace(/È|É|Ê|Ë/gi, "E");
      name = name.replace(/Ì|Í|Î|Ï/gi, "I");
      name = name.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O");
      name = name.replace(/Ù|Ú|Û|Ü/gi, "U");
      codCityOfBirth = codCityOfBirth.toUpperCase();
      var cfCostruct = "";
      var cognome =
        surname.replace(/[AEIOU-]/gi, "") +
        surname.replace(/[^AEIOU]/gi, "") +
        "X";
      var nome = name.replace(/[AEIOU-]/gi, "");
      if (nome.length > 3) {
        nome = nome.substring(0, 1) + nome.substring(2);
      }
      var temp = name.replace(/[^AEIOU]/gi, "") + "X";
      nome = nome + temp;
      var day = dateOfBirth.substring(0, 2);
      var mounth = dateOfBirth.substring(3, 5);
      var year = dateOfBirth.substring(8, 10);
      if (sesso && sesso.toLowerCase() === "f") {
        day = parseInt(day) + 40;
      }
      var mese = ["A", "B", "C", "D", "E", "H", "L", "M", "P", "R", "S", "T"];

      cfCostruct =
        cognome.substring(0, 3) +
        nome.substring(0, 3) +
        year +
        mese[mounth - 1] +
        day +
        codCityOfBirth;
      var map = [
        1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 2,
        4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23,
      ];
      var s = 0;
      for (var i = 0; i < 15; i++) {
        var c = cfCostruct.charCodeAt(i);
        if (c < 65) c = c - 48;
        else c = c - 55;
        if (i % 2 == 0) s += map[c];
        else s += c < 10 ? c : c - 10;
      }
      var atteso = String.fromCharCode(65 + (s % 26));
      cfCostruct =
        cognome.substring(0, 3) +
        nome.substring(0, 3) +
        year +
        mese[mounth - 1] +
        day +
        codCityOfBirth +
        atteso;

      return cfCostruct;
    }
    var docTypeCaeRegex = /^[A-z0-9]{3,15}$/;
    var docTypeNceRegex = /^[A-z]{2}[0-9]{5}[A-z]{2}$/;
    var docTypeCaiRegex = /^[A-z]{2}[0-9]{7}$/;
    var docTypeCaiBolzanoTrentoRegex = /^[a-zA-z0-9]{3,15}$/;
    var docTypeCieRegex = /^[0-9]{7}[A-z]{2}$/;
    var docTypePamRegex = /^[A-z]{2}[0-9]{7}[A-z]{1}$/;
    var docTypePatRegex = /^[A-z]{1}[0-9]{1}[A-z]{1}[0-9]{6}[A-z]{1}$/;
    //var docTypePatRegex = /^[A-z]{2}[0-9]{7}[A-z]?$/;
    var docTypeUcoRegex = /^[uU][A-z0-9]{8}[A-z]{1}$/;
    var docTypePasRegex = /^[A-z0-9]{7,15}$/;
    var numCivicRegex = /^([a-zA-Z0-9 ]*[/\\/.^-]?){1,6}$/i;
    var phoneRegex = /^[3]{1}[0-9]{8,9}$/;
    var nameRegex = /[a-zA-Z]+[\s]?[']?/;
    var year = /^19[1-9]{1}[0-9]{1}|20[0-9]{2}$/;
    var currencyRequired = /^\b0*([1-9][0-9]*(\.\d{1,2})?(\,\d{1,2})?)$/;
    var currencyNotRequired = /^[0-9]*(\.\d{1,2})?(\,\d{1,2})?$/;
    var percentuallyRequired = /^[0-9]{1,2}(\.\d{0,4})?(\,\d{0,4})?$|^100$/;
    var percentuallyNotRequired = /^[0-9]{0,2}(\.\d{0,4})(\,\d{0,4})?$|^100$/;
    var currencyForImportPercentComponent =
      /^([0-9][0-9]*(\.\d{1,2})?(\,\d{1,2})?)$/;
    var tassiRegex = /^(\-?[0-9][0-9]*(\.\d{1,4})?(\,\d{1,4})?)$/;
    var permillaryRequired = /^[0-9]{1,3}(\.\d{0,4})?(\,\d{0,4})?$|^1000$/;
    var permillaryNotRequired = /^[0-9]{0,3}(\.\d{0,4})?(\,\d{0,4})?$|^1000$/;
    var importoTassi = /^([0-9][0-9]*(\.\d{1,4})?(\,\d{1,4})?)$/;
    var address = /^[a-zA-ZÀ-ú0-9\\.'\s\°\^ -/]{1,30}$/i;
    var genericPhoneRegex = /^[0-9]{7,12}$/;
    var floatingPointNumbers = /[0-9]+[,.]?[0-9]?/;
    var floatingPointNumbersWithPoint = /^\d{1,3}(\,\d{1,3})?$/;
    var alphaNumSpecialChar = /[a-zA-ZÀ-ú0-9.,:]+[ /-]*[a-zA-ZÀ-ú0-9.,:]*$/;
    var telaio = /^[a-zA-Z0-9-\.{}@()_<>*+-=!?^|]{17}$/;
    var targa = /^[a-zA-Z0-9- \.{}@()_<>*+-=!?^|]{0,12}$/;
    var otp = /^[0-9]{8}$/;
    var otpLoginRegex = /^.{8}$/;
    var cfPiva =
      /^([0-9]{11}|((?:[aeiouB-DF-HJ-NP-TV-Z](?:[aeiouAEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z]|(?:[b-df-hj-np-tv-z](?:[aeiou]{2}|[aeiou]x)|[aeiou]{2}x|[b-df-hj-np-tv-z]{2}[a-z]){2}[\dlmnp-v]{2}(?:[a-ehlmpr-t](?:[04lq][1-9mnp-v]|[1256lmrs][\dlmnp-v])|[dhps][37pt][0l]|[acelmrt][37pt][01lm])(?:[a-mz][1-9mnp-v][\dlmnp-v]{2}|[a-m][0l](?:[\dlmnp-v][1-9mnp-v]|[1-9mnp-v][0l]))[a-z]))$/i;
    var cfPivaPlus =
      /^([0-9]{11}|((?:[aeiouB-DF-HJ-NP-TV-Z](?:[aeiouAEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z]|(?:[b-df-hj-np-tv-z](?:[aeiou]{2}|[aeiou]x)|[aeiou]{2}x|[b-df-hj-np-tv-z]{2}[a-z]){2}[\dlmnp-v]{2}(?:[a-ehlmpr-t](?:[04lq][1-9mnp-v]|[1256lmrs][\dlmnp-v])|[dhps][37pt][0l]|[acelmrt][37pt][01lm])(?:[a-mz][1-9mnp-v][\dlmnp-v]{2}|[a-m][0l](?:[\dlmnp-v][1-9mnp-v]|[1-9mnp-v][0l]))[a-z])|[a-z0-9]{8,16})$/i;
    var numGaranzie = /^[A-z0-9\/]{1,20}$/;
    var ordineGaranzia = /^[0-9]{1,7}$/;
    var pivaLivignoRegex = /^[0-7]{1}\d{6}(0{2}[1-9]{1}|0{1}[1-9]{1}\d{1}|100|120|121|888|999)\d{1}$|^[9]{10}[0]{1}$/;
    var codAteco = /[0-9]{6}/;
    var passPhrase = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,15}$/;
    var pin = /^[0-9]{8}$/;
    var noAccentedCharacters = /^[\w\-\s@\.\+\*\?\$\(\)\]\[\{\}\|\\!"'&\/=:_><]+$/;

    function checkCfWithName(cf, surname, name) {
      if (!cf || !name || !surname) {
        return false;
      }
      surname = surname.toUpperCase();
      surname = surname.replace(/ /g, "");
      surname = surname.replace(/[']/g, "");
      surname = surname.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A");
      surname = surname.replace(/È|É|Ê|Ë/gi, "E");
      surname = surname.replace(/Ì|Í|Î|Ï/gi, "I");
      surname = surname.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O");
      surname = surname.replace(/Ù|Ú|Û|Ü/gi, "U");
      name = name.toUpperCase();
      name = name.replace(/ /gi, "");
      name = name.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A");
      name = name.replace(/È|É|Ê|Ë/gi, "E");
      name = name.replace(/Ì|Í|Î|Ï/gi, "I");
      name = name.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O");
      name = name.replace(/Ù|Ú|Û|Ü/gi, "U");
      cf = cf.toUpperCase();
      var cfCostruct = "";
      var cognome =
        surname.replace(/[AEIOU]/gi, "") +
        surname.replace(/[^AEIOU]/gi, "") +
        "X";
      var nome = name.replace(/[AEIOU]/gi, "");
      if (nome.length > 3) {
        nome = nome.substring(0, 1) + nome.substring(2);
      }
      var temp = name.replace(/[^AEIOU]/gi, "") + "X";
      nome = nome + temp;
      cfCostruct = cfCostruct = cognome.substring(0, 3) + nome.substring(0, 3);
      if (cf.substring(0, 6) === cfCostruct) {
        return true;
      }
      return false;
    }

    function calcAge(age) {
      var today = new Date();
      var year = age.substring(6);

      if (year.length == 2) {
        var shortYear = moment(today).format("DD/MM/YYYY").substring(8);
        if (parseInt(year) <= shortYear) {
          year = "20" + year;
        } else {
          year = "19" + year;
        }
      }

      var mounth = age.substring(3, 5);
      var day = age.substring(0, 2);

      var years = today.getFullYear() - parseInt(year);

      if (
        today.getMonth() < parseInt(mounth) ||
        (today.getMonth() == parseInt(mounth) && today.getDay() < parseInt(day))
      ) {
        years--;
      }

      return years;
    }

    return {
      /**
       * Plain regex fields
       */
      ndgRegex: ndgRegex,

      emailRegex: emailRegex,

      passwordRegex: passwordRegex,

      pivaRegex: pivaRegex,

      cfRegex: cfRegex,

      pivaOrCfRegex: pivaOrCfRegex,

      telRegex: telRegex,

      telWithPrefixRegex: telWithPrefixRegex,

      prefixRegex: prefixRegex,

      mobileRegex: mobileRegex,

      contractNumberRegex: contractNumberRegex,

      getDocTypeRegex: getDocTypeRegex,

      cdDestinatarioRegex: cdDestinatarioRegex,

      genericRegex: genericRegex,

      ragSocRegex: ragSocRegex,

      cciaaRegex: cciaaRegex,

      checkCfWithFieds: checkCfWithFieds,

      year: year,

      quoteNumber: quoteNumber,

      rifAmmRegex: rifAmmRegex,

      validateCf: validateCf,

      checkPiva: checkPiva,

      calcAge: calcAge,

      moduleNumberRegex: moduleNumberRegex,

      ibanRegex: ibanRegex,

      /**
       * Validation Methods
       */
      isValidEmail: function (emailToTest) {
        return emailRegex.test(emailToTest);
      },

      checkCf: checkCf,

      isValidCf: function (cfToTest) {
        return cfRegex.test(cfToTest);
      },

      isValidPassword: function (passwordToTest) {
        return passwordRegex.test(passwordToTest);
      },

      isValidPiva: function (pivaToTest) {
        return pivaRegex.test(pivaToTest);
      },

      isValidTel: function (telToTest) {
        return telRegex.test(telToTest);
      },

      isValidMobile: function (telToTest) {
        return mobileRegex.test(telToTest);
      },

      isValidContractNumber: function (contractNumberToTest) {
        return contractNumberRegex.test(contractNumberToTest);
      },

      isValidNdg: function (ndgNumberToTest) {
        return ndgRegex.test(ndgNumberToTest);
      },

      isValidCdDestinatario: function (cdDestinatarioToTest) {
        return cdDestinatarioRegex.test(cdDestinatarioToTest);
      },

      isValidCdRiferimentoAmministrativo: function (
        CdRiferimentoAmministrativoToTest
      ) {
        return cdRiferimentoAmministrativoRegex.test(
          CdRiferimentoAmministrativoToTest
        );
      },

      isValidCfOrPiva: function (cfOrPivaToTest) {
        return pivaOrCfRegex.test(cfOrPivaToTest);
      },

      validateFieldFatturazioneElettronica: validateFieldFatturazioneElettronica,

      isValidGenericInput: function (inputToTest) {
        return genericRegex.test(inputToTest);
      },

      isValidRifAmministrativo: function (inputRifAmm) {
        return rifAmmRegex.test(inputRifAmm);
      },

      isValidYear: function (year) {
        return year.test(year);
      },

      isValidUrl: function (url) {
        return urlRegex.test(url);
      },

      isValidCfPivaPlus: function (value) {
        return cfPivaPlus.test(value);
      },

      isModuleNumberRegex: function (value) {
        return moduleNumberRegex.test(value);
      },

      isIbanRegex: function (value) {
        return ibanRegex.test(value);
      },

      docTypeCaeRegex: docTypeCaeRegex,
      docTypeNceRegex: docTypeNceRegex,
      docTypeCaiRegex: docTypeCaiRegex,
      docTypeCaiBolzanoTrentoRegex: docTypeCaiBolzanoTrentoRegex,
      docTypeCieRegex: docTypeCieRegex,
      docTypePamRegex: docTypePamRegex,
      docTypePatRegex: docTypePatRegex,
      docTypeUcoRegex: docTypeUcoRegex,
      docTypePasRegex: docTypePasRegex,
      numCivicRegex: numCivicRegex,
      phoneRegex: phoneRegex,
      nameRegex: nameRegex,
      checkCfWithName: checkCfWithName,
      currencyRequired: currencyRequired,
      currencyNotRequired: currencyNotRequired,
      percentuallyRequired: percentuallyRequired,
      percentuallyNotRequired: percentuallyNotRequired,
      currencyForImportPercentComponent: currencyForImportPercentComponent,
      tassiRegex: tassiRegex,
      permillaryRequired: permillaryRequired,
      permillaryNotRequired: permillaryNotRequired,
      importoTassi: importoTassi,
      address: address,
      genericPhoneRegex: genericPhoneRegex,
      floatingPointNumbers: floatingPointNumbers,
      alphaNumSpecialChar: alphaNumSpecialChar,
      urlRegex: urlRegex,
      telaio: telaio,
      targa: targa,
      otp: otp,
      cfPiva: cfPiva,
      cfPivaPlus: cfPivaPlus,
      numberPreventiveRegex: numberPreventiveRegex,
      numGaranzie: numGaranzie,
      ordineGaranzia: ordineGaranzia,
      otpLoginRegex: otpLoginRegex,
      numIscrizioneAlboRegex: numIscrizioneAlboRegex,
      createCf: createCf,
      capRegex: capRegex,
      codConvenzione: codConvenzione,
      pivaLivignoRegex: pivaLivignoRegex,
      codAteco: codAteco,
      passPhrase: passPhrase,
      pin: pin,
      noAccentedCharacters: noAccentedCharacters,
      floatingPointNumbersWithPoint: floatingPointNumbersWithPoint
    };
  })

  .factory("es6Factory", function () {
    function padWithZeros(str, maxLength) {
      while (str.length < maxLength) {
        str = "0" + str;
      }
      return str;
    }

    function isNaN(o) {
      return o !== o;
    }

    function isEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }
      return JSON.stringify(obj) === JSON.stringify({});
    }

    function hasNull(target) {
      var exclude =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      for (var member in target) {
        if (exclude.indexOf(member) == -1) {
          if (
            target[member] == null ||
            target[member] == undefined ||
            target[member] === ""
          )
            return true;
        }
      }
      return false;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function compareObj(obj1, obj2) {
      var exclude =
        arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      // Loop through properties in object 1
      for (var p in obj1) {
        if (exclude.indexOf(p) != -1) continue;
        // Check property exists on both objects
        if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

        switch (typeof obj1[p]) {
          // Deep compare objects
          case "object":
            if (!compareObj(obj1[p], obj2[p])) return false;
            break;
          // Compare function code
          case "function":
            if (
              typeof obj2[p] == "undefined" ||
              (p != "compare" && obj1[p].toString() != obj2[p].toString())
            )
              return false;
            break;
          // Compare values
          default:
            if (obj1[p] != obj2[p]) return false;
        }
      }

      // Check object 2 for any extra properties
      for (var p in obj2) {
        if (typeof obj1 && obj1[p] == "undefined") return false;
      }
      return true;
    }

    function compareObjExcludingNull(obj1, obj2) {
      //remove if present element not present in model FE
      delete obj1.success;
      delete obj1.esito;
      delete obj2.success;
      delete obj2.esito;
      var exclude =
        arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      // Loop through properties in object 1
      for (var p in obj1) {
        if (
          (obj1[p] == null || obj1[p] == "null") &&
          exclude.indexOf(p) == -1
        ) {
          exclude.push(p);
        }
      }
      for (var p in obj2) {
        if (
          (obj2[p] == null || obj2[p] == "null") &&
          exclude.indexOf(p) == -1
        ) {
          exclude.push(p);
        }
      }
      for (var p in obj1) {
        if (exclude.indexOf(p) != -1) continue;
        // Check property exists on both objects
        if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

        switch (typeof obj1[p]) {
          // Deep compare objects
          case "object":
            if (!compareObj(obj1[p], obj2[p])) return false;
            break;
          // Compare function code
          case "function":
            if (
              typeof obj2[p] == "undefined" ||
              (p != "compare" && obj1[p].toString() != obj2[p].toString())
            )
              return false;
            break;
          // Compare values
          default:
            if (obj1[p] != obj2[p]) return false;
        }
      }

      // Check object 2 for any extra properties
      if (obj1 && obj2) {
        for (var p in obj2) {
          if (exclude.indexOf(p) != -1) continue;
          if (typeof obj1[p] == "undefined") return false;
        }
      }
      return true;
    }

    function compareObjWithParameter(obj1, obj2, param) {
      for (var i = 0; i < param.length; i++) {
        if (obj1[param[i]] != obj2[param[i]]) return false;
      }

      return true;
    }

    return {
      padWithZeros: padWithZeros,
      isNaN: isNaN,
      isNumeric: isNumeric,
      isEmpty: isEmpty,
      hasNull: hasNull,
      compareObj: compareObj,
      compareObjExcludingNull: compareObjExcludingNull,
      compareObjWithParameter: compareObjWithParameter,
    };
  })

  .factory("PermissionFactory", function ($storageService) {
    /**
     * A javascript object containing pairs: id => permission for routes, the id
     * is the realPath (ex. /login, /search ..) for elements, the id is the real
     * html element id
     */
    var map;

    var userType;

    var editShowPermission;

    /**
     * Private Methods
     */
    function initFromSessionStorage() {
      if ($storageService.getAppConfig().permissions) {
        map = $storageService.getAppConfig().permissions.uniFeMap;
        userType = $storageService.getAppConfig().permissions.userType;
        editShowPermission = $storageService.getAppConfig().allFunctionalities;
      }
    }

    function getWhiteList() {
      return [
        "/registerCustomer",
        "/registerVendor",
        "/login",
        "/loginFiliali",
        "/logout",
        "/classificazioneFondiBei",
        "/richiestaPreventivo",
        "/questionarioADV",
        "/pagoDopoAdv",
      ];
    }

    /**
     * Initializes the map
     */
    var initialize = function (permissionList, userRole) {
      map = {};

      // Set the user type
      userType = userRole;

      // Set Permission Map
      permissionList.forEach(function (value) {
        var objectId = value["id"];
        var objectValue = {};
        Object.keys(value).forEach(function (propName) {
          if (propName != "id") {
            objectValue[propName] = value[propName];
          }
        });
        map[objectId] = objectValue;
      });

      // Dont directly save them enymore, just return them to the
      // configService
      return {
        uniFeMap: map,
        type: userRole,
      };
    };

    /**
     * Checks whether the user has the given permission or not
     */
    var hasElementPermission = function (elementId) {
      if (!map) initFromSessionStorage();

      // se l'elemento non c'è, non è tra gli elementi visibili dall'utente
      if (typeof map[elementId] === "undefined") {
        return false;
      }
      return true;
    };

    /**
     * Checks whether the user has the given route permission or not
     */
    var hasRoutingPermission = function (route) {
      /**
       * Check for paths you dont need to be authenticated for
       */
      if (getWhiteList().includes(route)) {
        return true;
      }

      //If you are reading this, go to the db and ADD THIS ROUTE!
      if (!map[route]) {
        console.info("disable route: " + route);
        var a = map[route] && map[route].disabled; //ulteriore controllo aggiunto per non far comparire errore rotta non censita
        return true; // precedentemente return false; sostituito a true per evitare problemi in caso di rotta non censita
      }

      // If the route is disabled, return false
      if (map[route].disabled === true) return false;

      return true;
    };

    var hideAndShowElements = function () {
      // Menu items
      $(".owl-item").each(function (index, element) {
        if (!hasElementPermission(element.children[0].id)) {
          $(this).hide();
        } else {
          $(this).show();
        }
      });

      //Lat button items
      $(".zz-home-side-buttons").each(function (index, element) {
        if (!hasElementPermission($(this).id)) {
          console.info("hiding: ", $(this).id);
          $(this).hide();
        } else {
          console.info("showing: ", $(this).id);
          $(this).show();
        }
      });
    };

    var clean = function () {
      map = [];
    };

    var isPresentShowAndEditPermission = function (element) {
      if (!editShowPermission) {
        initFromSessionStorage();
      }
      var isPresent =
        editShowPermission &&
        editShowPermission.findIndex(function (elem) {
          return elem.trim().toUpperCase() == element.trim().toUpperCase();
        });
      if (isPresent >= 0) {
        return false;
      } else {
        return true;
      }
    };

    return {
      /**
       * Initializes the map
       *
       * @param permissionList
       * @param userRole
       */
      initialize: initialize,

      /**
       * Checks whether the user has the given element permission or not
       */
      hasElementPermission: hasElementPermission,

      /**
       * Checks whether the user has the given route permission or not
       */
      hasRoutingPermission: hasRoutingPermission,

      hideAndShowElements: hideAndShowElements,

      /**
       * Use this to wipe up all your permissions
       */
      clean: clean,

      /**
       * This function choise if element is showen and/or editable
       */
      isPresentShowAndEditPermission: isPresentShowAndEditPermission,
    };
  })

  .factory("$searchUserService", function (HttpService, $q, $storageService) {
    var loading = false;

    function getCustomerList(appCustomerUser) {
      var deferred = $q.defer();
      return HttpService.send(
        "/user/search/getCustomer", {
        appCustomerUser: appCustomerUser,
      },
        false
      ).then(function (response) {
        console.log(
          "$searchUserService::getUserByIdentifier::then " + response
        );
        return $q.resolve(response && response.listAppCustomer);
      });
    }

    function getAppUser(appUser, isFromVendorManagement) {
      if (!isFromVendorManagement) {
        var input = {
          appUser: appUser,
          noDealer: true,
        };
      } else {
        var input = {
          appUser: appUser,
          noDealer: false,
        };
      }
      var deferred = $q.defer();
      return HttpService.send("/user/search/getAppUser", input, false).then(
        function (response) {
          console.log("$searchUserService::getAppUser::then " + response);
          return $q.resolve(response && response.listAppUser);
        }
      );
    }

    function saveAppCustomerGfromSearch(customer) {
      loading = true;
      var deferred = $q.defer();
      return HttpService.send(
        "/user/search/saveAppCustomerGfromSearch", {
        appCustomerUser: customer,
      },
        false
      )
        .then(function (response) {
          console.log(
            "$searchUserService::saveAppCustomerGfromSearch::then" + response
          );
          return $q.resolve(response.appCustomerUser);
        })
        .finally(function () {
          loading = false;
        });
    }

    function requiredSyncCerved(identifier) {
      var deferred = $q.defer();
      return HttpService.send(
        "/user/search/requiredSyncCerved", {
        appCustomerUser: {
          identifier: identifier,
        },
      },
        false
      ).then(function (response) {
        console.log("response", response);
        console.log("$searchUserService::requiredSyncCerved::then" + response);
        $storageService.set("forceCervedUpdate", response.success);
        console.log(
          "saving key forceCervedUpdate into session storage",
          $storageService.get("forceCervedUpdate")
        );
        return $q.resolve(response.success);
      });
    }

    function forcedCervedUpdate() {
      return $storageService.get("forceCervedUpdate") || false;
    }

    function isCustomerGMailUnique(mail) {
      var deferred = $q.defer();
      return HttpService.send(
        "/user/search/customerG/unique/mail", {
        appCustomerUser: {
          email: mail,
        },
      },
        true
      ).then(function (response) {
        console.log(
          "$searchUserService::isCustomerGMailUnique::then" + response
        );
        return $q.resolve(response && response.unique);
      });
    }

    function getFinancialListUser(appCustomerUser) {
      var deferred = $q.defer();
      return HttpService.send(
        "/user/search/getFinancialListUser", {
        appCustomerUser: appCustomerUser,
      },
        false
      ).then(function (response) {
        console.log(
          "$searchUserService::getFinalcialListUser::then " + response
        );
        return $q.resolve(
          response && response.dloGetVenditorePojoOutput.results
        );
      });
    }

    function isCustomerFMailUnique(mail) {
      var deferred = $q.defer();
      return HttpService.send(
        "/user/search/customerF/unique/mail", {
        appCustomerUser: {
          email: mail,
        },
      },
        true
      ).then(function (response) {
        console.log(
          "$searchUserService::isCustomerFMailUnique::then" + response
        );
        return $q.resolve(response && response.unique);
      });
    }

    function isCustomerMailUnique(mail, cf) {
      var deferred = $q.defer();
      return HttpService.send(
        "/user/search/customer/unique/mail", {
        appCustomerUser: {
          email: mail,
          identifier: cf,
        },
      },
        true
      ).then(function (response) {
        console.log(
          "$searchUserService::isCustomerMailUnique::then" + response
        );
        return $q.resolve(response && response.unique);
      });
    }

    function getCustomerFByNsil(cf, idPratica) {
      var input = {
        appCustomerUser: {
          identifier: cf,
        },
        idPratica: idPratica
      };
      return HttpService.send("/user/search/getCustomerFByNsil", input, true)
        .then(function (response) {
          return $q.resolve(response && response.appCustomerUser);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getPfList(identifier) {
      var input = {
        appCustomerUser: {
          identifier: identifier,
        },
      };
      return HttpService.send(
        "/user/search/getListAppCustomerFByDettAnag",
        input,
        true
      )
        .then(function (response) {
          return $q.resolve(response && response.listAppCustomer);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getLinkedPersonIL(identifier, ndg) {
      var input = {
        appCustomerUser: {
          identifier: identifier,
          ndg: ndg,
        },
      };
      return HttpService.send("/user/search/getLinkedPersonIL", input, true)
        .then(function (response) {
          return $q.resolve(response && response.listAppCustomer);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getLinkedPersonDigital(identifier, ndg, idPratica) {
      var input = {
        appCustomerUser: {
          identifier: identifier,
          ndg: ndg
        },
        id: idPratica
      };
      return HttpService.send(
        "/user/search/getLinkedPersonDigital",
        input,
        true
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAppUserByNdg(identifier) {
      var input = identifier;
      return HttpService.send("/user/getAppUserByIdentifier", input, false)
        .then(function (response) {
          return $q.resolve(response && response.appUser);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAppUserFromCerved(transactionId) {
      var input = {
        idTransaction: transactionId,
      };
      return HttpService.send(
        "/user/getAppCustomerfromCervedAPIServiceByIdTransaction",
        input,
        false
      )
        .then(function (response) {
          return $q.resolve(response && response.appCustomerUser);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAllProducts() {
      return HttpService.send("/user/allProducts")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAppUserGestioneUtenze(input) {
      return HttpService.send(
        "/user/search/getAppUser/gestioneUtenze",
        input
      ).then(function (response) {
        return $q.resolve(response && response.listAppUser);
      });
    }

    function clientMoratorie(input) {
      return HttpService.send("/user/clientMoratorie", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getLinkedPersonPv(identifier, ndg) {
      var input = {
        appCustomerUser: {
          identifier: identifier,
          ndg: ndg,
        },
      };
      return HttpService.send("/user/search/getLinkedPersonPv", input, true)
        .then(function (response) {
          return $q.resolve(response && response.listAppCustomer);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    function updateAppUser(input) {

      return HttpService.send("/user/gestioneUtenze/updateAppUser", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function censimentoUser(appUser) {
      var input = {
        appUser: appUser
      }

      return HttpService.send("/user/censimentoUser", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function censimentoAnagraficoFornitore(fornitore) {
      var input = {
        input: fornitore
      }

      return HttpService.send("/simulator/censimentoAnagraficoFornitore", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function saveMail(vendorMail) {

      return HttpService.send("/user/saveMail", vendorMail)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function gestioneLegamiUtenza(ndgSubordinante, ndgSubordinato) {
      var input = {
        ndgSubordinante: ndgSubordinante,
        ndgSubordinato: ndgSubordinato
      }

      return HttpService.get("/user/gestioneLegamiUtenza", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function eliminaLegame(id, ndgSubordinante, ndgSubordinato) {
      var input = {
        id: id,
        ndgSubordinante: ndgSubordinante,
        ndgSubordinato: ndgSubordinato
      };

      return HttpService.send("/user/eliminaLegame", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function inserisciLegame(ndgSubordinante, ndgSubordinato, subordinatoPlus) {
      var input = {
        ndgSubordinante: ndgSubordinante,
        ndgSubordinato: ndgSubordinato,
        subordinatoPlus: subordinatoPlus
      };

      return HttpService.send("/user/inserisciLegame", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function updateLegame(
      id,
      ndgSubordinante,
      ndgSubordinato,
      subordinatoPlus
    ) {
      var input = {
        id: id,
        ndgSubordinante: ndgSubordinante,
        ndgSubordinato: ndgSubordinato,
        subordinatoPlus: subordinatoPlus,
      };

      return HttpService.send("/user/updateLegame", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      loading: function () {
        return this.loading;
      },

      getCustomerList: getCustomerList,

      saveAppCustomerGfromSearch: saveAppCustomerGfromSearch,

      getAppUser: getAppUser,

      requiredSyncCerved: requiredSyncCerved,

      forcedCervedUpdate: forcedCervedUpdate,

      isCustomerGMailUnique: isCustomerGMailUnique,

      isCustomerFMailUnique: isCustomerFMailUnique,

      isCustomerMailUnique: isCustomerMailUnique,

      getFinancialListUser: getFinancialListUser,

      getCustomerFByNsil: getCustomerFByNsil,

      getPfList: getPfList,

      getLinkedPersonIL: getLinkedPersonIL,

      getLinkedPersonDigital: getLinkedPersonDigital,

      getAppUserByNdg: getAppUserByNdg,

      getAppUserFromCerved: getAppUserFromCerved,

      getAllProducts: getAllProducts,

      getAppUserGestioneUtenze: getAppUserGestioneUtenze,

      clientMoratorie: clientMoratorie,

      getLinkedPersonPv: getLinkedPersonPv,

      censimentoUser: censimentoUser,

      updateAppUser: updateAppUser,

      censimentoAnagraficoFornitore: censimentoAnagraficoFornitore,

      saveMail: saveMail,

      gestioneLegamiUtenza: gestioneLegamiUtenza,

      eliminaLegame: eliminaLegame,

      inserisciLegame: inserisciLegame,

      updateLegame: updateLegame
    };
  })

  .factory("$cervedService", function (HttpService, $q) {
    var loading = false;

    function getCustomer(value, type, ndg) {
      var deferred = $q.defer();
      loading = true;

      if (type === "cf") {
        return HttpService.send(
          "/user/getAppCustomerfromCervedAPIService", {
          codiceFiscale: value,
          ndg: ndg,
        },
          true
        )
          .then(function (response) {
            if (response) {
              console.log("$cervedService::getCustomer::then");
              return $q.resolve(response);
            }
          })
          .catch(function (error) {
            console.log(
              "$cervedService::getCustomer::catch, returning to controller"
            );
            return $q.reject(error);
          })
          .finally(function () {
            loading = false;
          });
      } else {
        return HttpService.send(
          "/user/getAppCustomerfromCervedAPIService", {
          partitaIva: value,
          ndg: ndg,
        },
          true
        )
          .then(function (response) {
            if (response) {
              console.log("$cervedService::getCustomer::then");
              return $q.resolve(response);
            }
          })
          .catch(function (error) {
            console.log(
              "$cervedService::getCustomer::catch, returning to controller"
            );
            return $q.reject(error);
          })
          .finally(function () {
            loading = false;
          });
      }
    }

    function getAppUserCache() {
      loading = true;

      var input = {};

      return HttpService.send("/user/getAppUserCache", input)
        .then(function (response) {
          if (response) {
            console.log("$cervedService::getAppUserCache::then");
            return $q.resolve(response);
          }
        })
        .catch(function (error) {
          console.log(
            "$cervedService::getAppUserCache::catch, returning to controller"
          );
          return $q.reject(error);
        })
        .finally(function () {
          loading = false;
        });
    }

    return {
      loading: function () {
        return loading;
      },

      getCustomer: getCustomer,
      getAppUserCache: getAppUserCache,
    };
  })

  .factory("$simulationService", function (HttpService, $q, WorkflowDto, $rootScope) {
    function getAllSimulationsByFilter(filter) {
      var deferred = $q.defer();
      var model = {
        appSimulation: filter,
      };
      return HttpService.send(
        "/simulator/getAllSimulationsFilter",
        filter,
        false
      ).then(function (response) {
        console.log(
          "$simulationService::/simulator/getAllSimulationsFilter::then" +
          response
        );
        return $q.resolve(response);
      });
    }

    function getAllSimulations(filter) {
      var deferred = $q.defer();
      return HttpService.send("/simulator/getAllSimulations", filter).then(
        function (response) {
          console.log("$simulationService::getAllSimulations::then" + response);
          return $q.resolve(response);
        }
      );
    }

    function archiveProductCatalog(idUser) {
      var deferred = $q.defer();
      var model = {
        idUser: idUser,
      };
      return HttpService.send("/simulator/archiveProductCatalog", model).then(
        function (response) {
          console.log(
            "$simulationService::archiveProductCatalog::then" + response
          );
          return $q.resolve(response);
        }
      );
    }

    function insertSimulation(simulation) {
      var deferred = $q.defer();
      var model = {
        appSimulation: simulation,
      };
      return HttpService.send("/simulator/insertSimulation", model).then(
        function (response) {
          console.log("$simulationService::insertSimulation::then" + response);
          return $q.resolve(response);
        }
      );
    }

    function logicDeleteSimulation(input) {
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/logicDeleteAppSimulation",
        input,
        false
      ).then(function (response) {
        console.log(
          "$searchUserService::logicDeleteSimulation::then" + response
        );
        return $q.resolve(response);
      });
    }

    function getSimulationById(input) {
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/getSimulationById",
        input,
        false
      ).then(function (response) {
        console.log("$searchUserService::getSimulationById::then" + response);
        return $q.resolve(response);
      });
    }

    function checkPermissionLo(userId) {
      var deferred = $q.defer();
      var model = {
        appProduct: {
          idUser: userId,
        },
      };
      return HttpService.send("/simulator/checkPermissionLo", model).then(
        function (response) {
          console.log("$simulationService::checkPermissionLo::then" + response);
          if (response && response.success) {
            return $q.resolve(true);
          } else {
            return $q.resolve(false);
          }
        }
      );
    }

    function getMaintenanceList(vendorNdg) {
      var deferred = $q.defer();
      var dto = {
        identifierAppVendor: vendorNdg,
      };
      return HttpService.send("/simulator/getMaintenanceList", dto)
        .then(function (response) {
          console.log(
            "$simulationService::getMaintenanceList::then" + response
          );
          if (response) {
            return $q.resolve(response && response.maintenanceServices);
          }
        })
        .catch(function (err) {
          console.log(
            "$simulationService::getMaintenanceList::catch" + response
          );
          return $q.reject(err);
        });
    }

    function populateUploadCheckList(model) {
      return HttpService.send("/simulator/getChecklistUpload", model)
        .then(function (response) {
          if (response) {
            return $q.resolve(response);
          }
        })
        .catch(function (err) {
          console.log(
            "$simulationService::populateCheckListUpload::catch" + err
          );
          return $q.reject(err);
        });
    }

    function populateDownloadCheckList(model) {
      return HttpService.send("/simulator/getChecklistDownload", model)
        .then(function (response) {
          if (response) {
            return $q.resolve(response);
          }
        })
        .catch(function (err) {
          console.log(
            "$simulationService::populateCheckListDownload::catch" + err
          );
          return $q.reject(err);
        });
    }

    function updateMetadataDocuments(metadataDocuments) {
      return HttpService.send(
        "/simulator/updateMetadataDocuments",
        metadataDocuments
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function printPreventive(financialModel, type, onlyLocal) {
      var dto = WorkflowDto.build({
        type: (type && type) || "WF_DIGITAL",
        financialModel: financialModel,
      });
      Object.assign(dto, {
        onlyLocal: onlyLocal || false,
      });
      return HttpService.send("/simulator/preventive/print", dto)
        .then(function (response) {
          $rootScope.snapId = response && !!response.snapId ? response.snapId : $rootScope.snapId;
          console.log("printPreventive: ", response);
          if (response && response.success) {
            return $q.resolve(response);
          } else {
            return $q.resolve(false);
          }
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function getUrlsDocAssicurazioni(input) {
      return HttpService.send(
        "/simulator/preventive/getDocInfoAssicurazioni",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          console.log("ERROR: ", error);
          return $q.reject(error);
        })
        .finally(function () {
          console.log("");
        });
    }

    function getPrintOptions(preventivo, reteVendita, id) {
      var input = {
        preventivo: preventivo,
        reteVendita: reteVendita,
        id: id,
      };

      return HttpService.send("/simulator/preventive/printOptions", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          console.log("ERROR: ", error);
          return $q.reject(error);
        });
    }

    function populateCheckListTrasparenza(preventivo, reteVendita, id) {
      var input = {
        preventivo: preventivo,
        reteVendita: reteVendita,
        id: id
      };
      return HttpService.send("/simulator/populateChecklistTrasparenza", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          console.log("ERROR: ", error);
          return $q.reject(error);
        });
    }

    function deleteChecklistFileDigital(id, checklistType) {
      if (isNaN(id)) {
        var input = {
          downloadKey: id,
          checklistType: checklistType,
        };
      } else {
        var input = {
          id: id,
          checklistType: checklistType,
        };
      }

      return HttpService.send("/uni/deleteChecklistFileDigital", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deleteChecklistFileAdv(id, checklistType) {
      if (isNaN(id)) {
        var input = {
          downloadKey: id,
          checklistType: checklistType,
        };
      } else {
        var input = {
          id: id,
          checklistType: checklistType,
        };
      }

      return HttpService.send("/uni/deleteChecklistFileAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deleteChecklistFilePv(id, checklistType) {
      if (isNaN(id)) {
        var input = {
          downloadKey: id,
          checklistType: checklistType,
        };
      } else {
        var input = {
          id: id,
          checklistType: checklistType,
        };
      }
      return HttpService.send("/uni/deleteChecklistFilePv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function printPreventiveAsync(financialModel, type, onlyLocal) {
      var dto = WorkflowDto.build({
        type: (type && type) || "WF_DIGITAL",
        financialModel: financialModel,
      });
      Object.assign(dto, {
        onlyLocal: onlyLocal || false,
      });
      return HttpService.send("/simulator/preventive/printAsync", dto)
        .then(function (response) {
          console.log("printPreventive: ", response);
          if (response && response.success) {
            return $q.resolve(response);
          } else {
            return $q.resolve(false);
          }
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function submitDeliberaBancaAsync(financialModel, type, onlyLocal) {
      var dto = WorkflowDto.build({
        type: (type && type) || "WF_DIGITAL",
        financialModel: financialModel,
      });
      Object.assign(dto, {
        onlyLocal: onlyLocal || false,
      });
      return HttpService.send(
        "/simulator/preventive/submitDeliberaBancaAsync",
        dto
      )
        .then(function (response) {
          console.log("response for nuovo p. leas. resolution: ", response);
          if (response && response.success) {
            return $q.resolve(response);
          } else {
            return $q.resolve(false);
          }
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function sendRequestForNplResolution(financialModel, type, onlyLocal) {
      var dto = WorkflowDto.build({
        type: (type && type) || "WF_DIGITAL",
        financialModel: financialModel,
      });
      Object.assign(dto, {
        onlyLocal: onlyLocal || false,
      });
      return HttpService.send("/simulator/preventive/submitDeliberaBanca", dto)
        .then(function (response) {
          console.log("response for nuovo p. leas. resolution: ", response);
          if (response && response.success) {
            return $q.resolve(response);
          } else {
            return $q.resolve(false);
          }
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function getChecklistDownloadContract(contratto, monitor) {
      var input = {
        leasingData: {
          contratto: contratto,
        },
        monitor: monitor,
      };

      return HttpService.send("/simulator/getChecklistDownloadContract", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function sendContractToArc(financialModel) {
      return HttpService.send("/simulator/sendContractToArc", financialModel)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function removeContractToArc(id) {
      var input = {
        leasingData: {
          id: id,
        },
      };

      return HttpService.send("/simulator/removeContractToArc", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          $q.reject(error);
        });
    }

    function getLinkedPersonContract(
      idPratica,
      loadSigners,
      user,
      monitor,
      firmaDigitale,
      firmaDigitaleEsterna,
      smallTicket,
      updatedSignature
    ) {
      var input = {
        idPratica: idPratica,
        loadSigners: loadSigners,
        persons: user,
        monitor: monitor,
        firmaDigitale: firmaDigitale,
        firmaDigitaleEsterna: firmaDigitaleEsterna,
        smallTicket: smallTicket,
        updatedSignature: updatedSignature
      };

      return HttpService.send("/simulator/getLinkedPersonContract", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getChecklistUploadContract(contratto, monitor) {
      var input = {
        leasingData: {
          contratto: contratto,
        },
        monitor: monitor,
      };

      return HttpService.send("/simulator/getChecklistUploadContract", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          $q.reject(error);
        });
    }

    function getLinkedPersonPractice(model) {
      return HttpService.send("/simulator/getLinkedPersonPractice", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function checkSaeRaeAteco(sae, rae, ateco, formaGiuridica, cf, piva) {
      var input = {
        sae: sae,
        rae: rae,
        ateco: ateco,
        formaGiuridica: formaGiuridica,
        cf: cf,
        piva: piva,
      };
      return HttpService.send("/simulator/checkSaeRaeAteco", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getLinkedGaranti(model) {
      return HttpService.send("/simulator/getLinkedGaranti", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function rejectArcAssurances(id) {
      var input = {
        id: id,
      };

      return HttpService.send(
        "/simulator/financial/rifiutaAssicurazioniArc",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function printContract(id) {
      var input = {
        id: id,
      };

      return HttpService.send("/simulator/financial/printContract", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getInfoPostSignature(idDossier) {
      var input = {
        idDossier: idDossier,
      };

      return HttpService.send(
        "/simulator/financial/getInfoPostSignature",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function moduloNplInfo(idPractice, inAllestimento) {
      var input = {
        idPractice: idPractice,
        inAllestimento: inAllestimento,
      };
      return HttpService.get("/simulator/financial/moduloNplInfo", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitModuloNpl(financialMOdel) {
      return HttpService.send(
        "/simulator/financial/submitModuloNpl",
        financialMOdel
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function takeOwnership(idContract) {
      var input = {
        idContract: idContract,
      };
      return HttpService.send("/simulator/contract/takeOwnership", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function releasePractice(idContract) {
      var input = {
        idContract: idContract,
      };
      return HttpService.send("/simulator/contract/release", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getPriceListsOps(ndg) {
      var input = {
        ndg: ndg,
      };
      return HttpService.get("/simulator/priceList/fornitore", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getPriceListBands(ndg) {
      var input = {
        ndg: ndg,
      };
      return HttpService.get("/simulator/priceList/band/fornitore", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getPriceListDurations(ndg) {
      var input = {
        ndg: ndg,
      };
      return HttpService.get("/simulator/priceList/duration", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getBandDetail(ndg, durations, band) {
      var input = {
        ndg: ndg,
        durations: durations,
        fascia: band,
      };
      return HttpService.get(
        "/simulator/priceList/band/detail/fornitore",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function printCtrConvenzione(user, goodDescription) {
      var input = {
        user: user,
        descrizioneBeni: goodDescription,
      };
      return HttpService.dooPost("/simulator/printCtrConvenzione", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
          return $q.resolve(true);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function sendCtrConvenzione(user, goodDescription) {
      var input = {
        user: user,
        descrizioneBeni: goodDescription,
      };
      return HttpService.send("/simulator/sendCtrConvenzione", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAllMaintenanceList(identifierAppVendor) {
      var input = {
        identifierAppVendor: identifierAppVendor,
      };
      return HttpService.send("/simulator/getAllMaintenanceList", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getStatusConvention(identifierAppVendor) {
      var input = {
        fornitore: identifierAppVendor,
      };
      return HttpService.get("/simulator/getStatusConvenzionamento", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function setStatusConvention(
      identifierAppVendor,
      maintenanceServices,
      vendorProfile,
      conventionType
    ) {
      var input = {
        fornitore: identifierAppVendor,
        profilo: vendorProfile,
        serviziManutenzione: maintenanceServices,
        listTipoConv: conventionType,
      };
      return HttpService.send("/simulator/setStatusConvenzionamento", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function savePriceList(ndgVendor, idOp) {
      var input = {
        fornitore: ndgVendor,
        idOP: idOp
        //ndgListino: "00000000", //to remove
        //listListino: [] // to remove
      };
      return HttpService.send("/simulator/priceList/save", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function savePriceListBandDetail(listPriceLists, ndgVendor, idOP) {
      var input = {
        listListino: listPriceLists,
        fornitore: ndgVendor,
        idOP: idOP,
        ndgListino: "00000000", //to remove
      };
      return HttpService.send("/simulator/priceList/band/saveDetail", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getCatalogOpsInfo(appCustomerUser, goodsDescription) {
      var input = {
        user: appCustomerUser,
        descrizioneBeni: goodsDescription,
      };
      return HttpService.send("/simulator/getCatalogOpsInfo", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function sendRequestCatalogOps(appCustomerUser, goodsDescription, notes) {
      var input = {
        user: appCustomerUser,
        descrizioneBeni: goodsDescription,
        note: notes,
      };
      return HttpService.send("/simulator/sendRequestCatalogOps", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function uploadProductCatalogLight(appCustomerUser, goodsDescription) {
      var input = {
        appCustomerUser: appCustomerUser,
        descrizioneBeni: goodsDescription,
      };
      return HttpService.send("/simulator/uploadProductCatalogLight", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getVendorHierarchy(vendor, profile) {
      var input = {
        fornitore: vendor,
        profile: profile,
      };
      return HttpService.get("/simulator/getGerarchiaFornitori", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function setVendorHierarchy(vendors, ndgAgent, idOP, gestori) {
      var input = {
        fornitori: vendors,
        agente: ndgAgent,
        idOP: idOP,
        gestori: gestori
      };
      return HttpService.send("/simulator/setGerarchiaFornitori", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function sendActivationRequest(appCustomerUser, idOP) {
      var input = {
        user: appCustomerUser,
        idOP: idOP
      };
      return HttpService.send("/simulator/setAttivazioneFornitore ", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function setVendorDigitalSignAndPlafond(plafondParams) {
      var input = {
        convenzionePlafond: plafondParams,
      };
      return HttpService.send(
        "/simulator/setVendorDigitalSignAndPlafond ",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function checkSubmitDelBanca(financialModel, type, onlyLocal) {
      var dto = WorkflowDto.build({
        type: (type && type) || "WF_DIGITAL",
        financialModel: financialModel,
      });
      Object.assign(dto, {
        onlyLocal: onlyLocal || false,
      });
      return HttpService.send("/simulator/preventive/checkSubmitDelBanca", dto)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function preStipula(id) {
      var input = {
        id: id,
      };

      return HttpService.send("/simulator/financial/preStipula", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function stipula(id, dataStipula, dataValutaIncasso, importoIncasso, cro) {
      var input = {
        id: id,
        dataStipula: dataStipula,
        dataValutaIncasso: dataValutaIncasso,
        importoIncasso: importoIncasso,
        cro: cro,
      };

      return HttpService.send("/simulator/financial/stipula", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function preSendArc(id, firmaDigitale, firmaDigitaleEsterna, assicurazioni) {
      var input = {
        id: id,
        preventivo: {
          firmaDigitale: firmaDigitale,
          firmaDigitaleEsterna: firmaDigitaleEsterna,
		  assicurazioni: assicurazioni
        }

      };

      return HttpService.send("/simulator/financial/preSendArc", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getResa(ndgVenditore) {
      var ndgVenditore = {
        ndgVenditore: ndgVenditore,
      };
      return HttpService.get(
        "/simulator/additionalInfoAsset/resa",
        ndgVenditore
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function couplePriceListToVendor(priceListId, vendorNdg) {
      var input = {
        ndgListino: priceListId,
        fornitore: vendorNdg,
      };
      return HttpService.send("/simulator/couplePriceListToVendor", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getCustomDocsCtr(leasingId) {
      var input = {
        leasingData: {
          id: leasingId,
        },
      };

      return HttpService.send("/simulator/getCustomDocsCtr", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    function getExportExcelContracts(filter) {

      var input = {
        appContract: filter
      }
      return HttpService.dooPost("/simulator/contract/exportContractDetails/service-infos", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getExportExcelSimulations(filter) {

      var input = {
        appSimulation: filter
      }

      return HttpService.dooPost("/simulator/exportSimulationDetails/service-infos", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function exportPractice(filter) {
      return HttpService.dooGet(
        "/simulator/exportPractice",
        filter
      ).then(function (response) {
        var headers = response.headers();
        var link = angular.element("<a/>");
        var blob = new Blob([response.data]);
        var objectUrl = window.URL || window.webkitURL;
        var filename =
          headers["content-disposition"] &&
          headers["content-disposition"].split("=")[1];
        link.css({
          display: "none",
        });
        link.attr({
          href: objectUrl.createObjectURL(blob),
          target: "_blank",
          download: filename,
        });
        link[0].click();
        link.remove();
        objectUrl.revokeObjectURL(blob);
        return $q.resolve(true);
      });
    }

    function checkPracticeVendorCustomer(input) {
      return HttpService.send("/simulator/checkPracticeVendorCustomer", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function downloadDossierCerved(cf) {
      var input = {
        cf: cf
      }

      return HttpService.dooGet("/simulator/downloadDossierCerved", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function alternativeEmailContact(financialModel) {

      return HttpService.send("/simulator/alternativeEmailContact", financialModel)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function getSamlCerved() {
      var input = {}
      return HttpService.send("/uni/saml/cerved", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function getFeasibleAtecoForBeiCnv(cnv, ateco) {
      var input = {
        appSimulation: {
          metadata: {
            beiLOData: {
              cdConvenzioneBei: cnv,
              cdAtecoCliente: ateco
            }
          }
        }
      }
      return HttpService.send("/simulator/getFeasibleAtecoForBeiCnv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }


    function exportGestioneUtenze(input) {
      return HttpService.dooGet(
        "/user/exportGestioneUtenze", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
          return $q.resolve(response);
        })
    }

    function getCatalogoFromAlbagreen(input) {
      return HttpService.dooGet(
        "/simulator/getCatalogoFromAlbagreen/service-infos/", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function retriveViewInfo(idWf) {

      var input = {
        idWf: idWf
      }

      return HttpService.get("/simulator/retriveViewInfo", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function variazioneRichiestaPrev(id, nota, deletePreventivo) {
      var input = {
        id: id,
        nota: nota,
        deletePreventivo: deletePreventivo
      }

      return HttpService.send("/simulator/variazioneRichiestaPrev", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function inserimentoPrivacy(appCustomer) {


      return HttpService.send("/simulator/inserimentoPrivacy", appCustomer)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (errore) {
          return $q.reject(error);
        })
    }


    function saveContrattoConvenzionamento(firmatario, ndgFornitore, codTypeDocument, fileName, idOP, uuidDocRic, docIdFirmato, notGestFor) {

      var input = {
        firmatario: firmatario,
        ndgFornitore: ndgFornitore,
        codTypeDocument: codTypeDocument,
        fileName: fileName,
        idOP: idOP,
        uuidDocRic: uuidDocRic,
        filenameDocRic: docIdFirmato,
        notGestFor: notGestFor,
      }


      return HttpService.send("/simulator/saveContrattoConvenzionamento", input)
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function getAverageEmployeesNumber(cf) {

      var appCustomerUser = {
        cf: cf
      }

      return HttpService.send("/simulator/getAverageEmployeesNumber", appCustomerUser)
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function getCheckListContrattoConvenzionamento() {
      return HttpService.send("/simulator/getCheckListContrattoConvenzionamento", {})
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function deleteCtrConv(id) {
      if (isNaN(id)) {
        var input = {
          downloadKey: id
        };
      } else {
        var input = {
          id: id
        };
      }

      return HttpService.send("/simulator/deleteCtrConv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function stipulaLo(id, dataStipula, dataValutaIncasso, importoIncasso, cro) {
      var input = {
        idContract: id,
        dataStipula: dataStipula,
        dataValutaIncasso: dataValutaIncasso,
        importoIncasso: importoIncasso,
        cro: cro,
      };

      return HttpService.send("/simulator/contract/stipula", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function saveVerbale(ordine, dataConsegna) {

      var input = {
        ordine: ordine,
        dataConsegna: dataConsegna
      }

      return HttpService.send("/simulator/saveVerbale", input)
        .then(function (response) {
          return $q.resolve(response);

        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function contattiChecklist(id) {
      var input = {
        id: id
      }

      return HttpService.get("/simulator/contattiChecklist", input)
        .then((response) => {
          return $q.resolve(response);
        })
        .catch((error) => {
          return $q.reject(error);
        })


    }

    function saveContattiChecklist(inputMail) {

      return HttpService.send("/simulator/saveContattiChecklist", inputMail)
        .then((response) => {
          return $q.resolve(response);
        })
        .catch((error) => {
          return $q.reject(error);
        })
    }

    function updateSpesaAss(cdServizio, spesa) {

      var input = {
        cdServizio: cdServizio,
        spesa: spesa
      }

      return HttpService.send("/simulator/financial/updateSpesaAss", input)
        .then((response) => {
          return $q.resolve(response);
        })
        .catch((error) => {
          return $q.reject(error)
        })
    }


    function resetSignMode(idContract) {

      var input = {
        idContract: idContract
      }

      return HttpService.send("/simulator/contract/resetSignMode", input)
        .then(response => {
          return $q.resolve(response);
        })
        .catch(error => {
          return $q.reject(error);
        })
    }

    return {
      /**
       * @param {*}
       *            identifierAppCustomer
       * @returns listAppSimulation, totalCount
       */
      getAllSimulations: getAllSimulations,

      getSimulationById: getSimulationById,
      getAllSimulationsByFilter: getAllSimulationsByFilter,

      /**
       * @param {*}
       *            simulation
       * @returns boolean reflecting the call result
       */
      insertSimulation: insertSimulation,

      logicDeleteSimulation: logicDeleteSimulation,

      archiveProductCatalog: archiveProductCatalog,

      checkPermissionLo: checkPermissionLo,
      getMaintenanceList: getMaintenanceList,
      populateUploadCheckList: populateUploadCheckList,
      populateDownloadCheckList: populateDownloadCheckList,
      updateMetadataDocuments: updateMetadataDocuments,
      printPreventive: printPreventive,
      /**
       *  Page 30
       */
      getUrlsDocAssicurazioni: getUrlsDocAssicurazioni,
      getPrintOptions: getPrintOptions,
      populateCheckListTrasparenza: populateCheckListTrasparenza,
      deleteChecklistFileDigital: deleteChecklistFileDigital,
      deleteChecklistFileAdv: deleteChecklistFileAdv,
      deleteChecklistFilePv: deleteChecklistFilePv,
      printPreventiveAsync: printPreventiveAsync,
      sendRequestForNplResolution: sendRequestForNplResolution,
      getChecklistDownloadContract: getChecklistDownloadContract,
      sendContractToArc: sendContractToArc,
      removeContractToArc: removeContractToArc,
      getLinkedPersonContract: getLinkedPersonContract,
      getChecklistUploadContract: getChecklistUploadContract,
      checkSaeRaeAteco: checkSaeRaeAteco,
      getLinkedPersonPractice: getLinkedPersonPractice,
      getLinkedGaranti: getLinkedGaranti,
      rejectArcAssurances: rejectArcAssurances,
      printContract: printContract,
      submitDeliberaBancaAsync: submitDeliberaBancaAsync,
      getInfoPostSignature: getInfoPostSignature,
      moduloNplInfo: moduloNplInfo,
      submitModuloNpl: submitModuloNpl,
      takeOwnership: takeOwnership,
      releasePractice: releasePractice,
      getPriceListsOps: getPriceListsOps,
      getPriceListBands: getPriceListBands,
      getPriceListDurations: getPriceListDurations,
      getBandDetail: getBandDetail,
      printCtrConvenzione: printCtrConvenzione,
      sendCtrConvenzione: sendCtrConvenzione,
      getAllMaintenanceList: getAllMaintenanceList,
      getStatusConvention: getStatusConvention,
      setStatusConvention: setStatusConvention,
      savePriceList: savePriceList,
      savePriceListBandDetail: savePriceListBandDetail,
      getCatalogOpsInfo: getCatalogOpsInfo,
      sendRequestCatalogOps: sendRequestCatalogOps,
      uploadProductCatalogLight: uploadProductCatalogLight,
      getVendorHierarchy: getVendorHierarchy,
      setVendorHierarchy: setVendorHierarchy,
      sendActivationRequest: sendActivationRequest,
      checkSubmitDelBanca: checkSubmitDelBanca,
      preStipula: preStipula,
      stipula: stipula,
      preSendArc: preSendArc,
      getResa: getResa,
      couplePriceListToVendor: couplePriceListToVendor,
      getCustomDocsCtr: getCustomDocsCtr,
      setVendorDigitalSignAndPlafond: setVendorDigitalSignAndPlafond,
      getExportExcelContracts: getExportExcelContracts,
      getExportExcelSimulations: getExportExcelSimulations,
      exportPractice: exportPractice,
      checkPracticeVendorCustomer: checkPracticeVendorCustomer,
      downloadDossierCerved: downloadDossierCerved,
      alternativeEmailContact: alternativeEmailContact,
      getSamlCerved: getSamlCerved,
      getFeasibleAtecoForBeiCnv: getFeasibleAtecoForBeiCnv,
      exportGestioneUtenze: exportGestioneUtenze,
      retriveViewInfo: retriveViewInfo,
      getCatalogoFromAlbagreen: getCatalogoFromAlbagreen,
      variazioneRichiestaPrev: variazioneRichiestaPrev,
      inserimentoPrivacy: inserimentoPrivacy,
      saveContrattoConvenzionamento: saveContrattoConvenzionamento,
      getAverageEmployeesNumber: getAverageEmployeesNumber,
      getCheckListContrattoConvenzionamento: getCheckListContrattoConvenzionamento,
      deleteCtrConv: deleteCtrConv,
      stipulaLo: stipulaLo,
      saveVerbale: saveVerbale,
      contattiChecklist: contattiChecklist,
      saveContattiChecklist: saveContattiChecklist,
      updateSpesaAss: updateSpesaAss,
      resetSignMode: resetSignMode
    };
  })

  .factory(
    "$digitalSignatureService",
    function (HttpService, $q, $configService) {
      function enrollmentStart(input) {
        var deferred = $q.defer();
        return HttpService.send("/simulator/contract/start", input).then(
          function (response) {
            if (response) {
              console.log("$digitalSignatureService::start::then" + response);
              return $q.resolve(response);
            }
          }
        );
      }

      function enrollmentAcceptconditions(input) {
        // input = {clauses: []}
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/enrollmentAcceptconditions",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::enrollmentAcceptconditions::then" +
              response
            );
            return $q.resolve(response);
          }
        });
      }

      function validateCertificate(filter) {
        var deferred = $q.defer();
        var model = {
          appContract: filter,
        };
        return HttpService.send(
          "/simulator/contract/getCertificateContract",
          model,
          false
        ).then(function (response) {
          console.log(
            "$contractService::contract/getCertificateContract::then" + response
          );
          return $q.resolve(response);
        });
      }

      function enrollmentCreatecertificate(input) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/enrollmentCreatecertificate",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::enrollmentCreatecertificate::then" +
              response
            );
            return $q.resolve(response);
          }
        });
      }

      function processInformations(input) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/processInformations",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::processInformations::then" + response
            );
            return $q.resolve(response);
          }
        });
      }

      function enrollmentPreparesignature(input) {
        // var input = {id: TASKID};
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/preparesignature",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::preparesignature::then" + response
            );
            return $q.resolve(response);
          }
        });
      }

      function remotesignPreparesignature(input) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/remotesignPreparesignature",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::remotesignPreparesignature::then" +
              response
            );
            return $q.resolve(response);
          }
        });
      }

      function enrollmentSigncontracts(input) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/signcontracts",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::signcontracts::then" + response
            );
            return $q.resolve(response);
          }
        });
      }

      function getDocumentList(input) {
        var deferred = $q.defer();
        // https://copalbaleasingcl.infocert.it/rest10/remotesign/'+taskId+'/start
        return HttpService.send(
          "/simulator/contract/getDocumentList",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::getDocumentList::then" + response
            );
            return $q.resolve(response);
          }
        });
      }

      function digitalSignatureStart(token) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/digitalSignatureStart",
          token
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::digitalSignatureStart::then" + response
            );
            return $q.resolve(response);
            // response.documents
          }
        });
      }

      function getNewTokenInfocert(idContract, idDossier) {
        var deferred = $q.defer();
        var input = {
          idContract: idContract,
          idDossier: idDossier,
        };
        return HttpService.send(
          "/simulator/contract/getNewTokenInfocert",
          input
        ).then(function (response) {
          if (response) {
            console.log("$digitalSignatureService::getToken::then" + response);
            return $q.resolve(response);
            // response.taskId
          }
        });
      }

      function signContracts(contract) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/signcontracts",
          contract
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::signcontracts::then" + response
            );
            return $q.resolve(response);
          }
        });
      }

      function updateContract(idContract, dossierId) {
        var input = {
          idContract: idContract,
          idDossier: dossierId,
        };
        return HttpService.send(
          "/simulator/contract/updateAppContractSignedStatus",
          input
        ).then(function (response) {
          if (response) {
            return $q.resolve(response);
            // response.taskId
          }
        });
      }

      function soapCertificaNumeroTelefono(input) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/soapCertificaNumeroTelefono",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::soapCertificaNumeroTelefono::then" +
              response
            );
            return $q.resolve(response);
          }
        });
      }

      function soapVerificaCertificatoNumTel(input) {
        var deferred = $q.defer();
        return HttpService.send(
          "/simulator/contract/soapVerificaCertificatoNumTel",
          input
        ).then(function (response) {
          if (response) {
            console.log(
              "$digitalSignatureService::soapVerificaCertificatoNumTel::then" +
              response
            );
            return $q.resolve(response);
          }
        });
      }

      function userAllowedDigitalSignature(ndg) {
        var deferred = $q.defer();
        var dto = {
          ndg: ndg,
        };
        return HttpService.send("/user/userAllowedDigitalSignature", dto).then(
          function (response) {
            if (response) {
              console.log(
                "$digitalSignatureService::userAllowedDigitalSignature::then" +
                response
              );
              return $q.resolve(response);
            }
          }
        );
      }

      function isUserAllowedToDigitalSignature() {
        return !!$configService.getUser().userAllowedToDigitalSignature;
      }

      function changeSignContractMetadata(newStatus, contract) {
        var deferred = $q.defer();
        contract.status = newStatus;
        var model = {
          appContract: contract,
        };
        return HttpService.send(
          "/simulator/contract/changeSignContractMetadata",
          model
        ).then(function (response) {
          if (response) {
            console.log(
              "$contractService::changeSignContractMetadata::then" + response
            );
            return $q.resolve(response && response.updateContractOk);
          }
        });
      }

      function isZipDocumentiFornitoreEmpty(contract) {
        gettingDetails = true;
        return HttpService.send(
          "/simulator/contract/isZipDocumentiFornitoreEmpty",
          contract
        )
          .then(function (response) {
            console.log("isZipDocumentiFornitoreEmpty returned! ", response);
            return $q.resolve(response);
            // if (response.success) {
            // 	return $q.resolve(response);
            // }
          })
          .finally(function () {
            gettingDetails = false;
          });
      }

      return {
        enrollmentStart: enrollmentStart,

        enrollmentAcceptconditions: enrollmentAcceptconditions,

        enrollmentCreatecertificate: enrollmentCreatecertificate,

        processInformations: processInformations,

        enrollmentPreparesignature: enrollmentPreparesignature,

        remotesignPreparesignature: remotesignPreparesignature,

        enrollmentSigncontracts: enrollmentSigncontracts,

        signContracts: signContracts,

        updateContract: updateContract,

        getNewTokenInfocert: getNewTokenInfocert,

        digitalSignatureStart: digitalSignatureStart,

        getDocumentList: getDocumentList,

        soapCertificaNumeroTelefono: soapCertificaNumeroTelefono,

        soapVerificaCertificatoNumTel: soapVerificaCertificatoNumTel,

        //Called in LO to see if a vendor is able to use digital sign with signers
        userAllowedDigitalSignature: userAllowedDigitalSignature,

        validateCertificate: validateCertificate,

        changeSignContractMetadata: changeSignContractMetadata,

        isZipDocumentiFornitoreEmpty: isZipDocumentiFornitoreEmpty,
        //It evaluates (ARF or ARU) the property userAllowedToDigitalSignature from login service
        isUserAllowedToDigitalSignature: isUserAllowedToDigitalSignature,
      };
    }
  )

  .factory("$contractService", function (HttpService, $q) {
    function getAppContractByIdContract(idContract) {
      var input = {
        idContract: idContract,
      };
      // modulo, codice, nome file
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/contract/getAppContractByIdContract",
        input,
        false
      ).then(function (response) {
        if (response) {
          console.log(
            "$contractService::getAppContractByIdContract::then" + response
          );
          return $q.resolve(response);
        }
      });
    }

    function getAllContractsByFilter(filter) {
      var deferred = $q.defer();
      var model = {
        appContract: filter,
      };
      return HttpService.send(
        "/simulator/contract/getAllTotalContractsFilter",
        model,
        false
      ).then(function (response) {
        console.log(
          "$contractService::contract/getAllTotalContractsFilter::then" +
          response
        );
        return $q.resolve(response);
      });
    }

    function regenerateContract(idContract) {
      var input = {
        idContract: idContract,
      };
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/contract/regenerateContract",
        input,
        false
      ).then(function (response) {
        if (response) {
          console.log("$contractService::regenerateContract::then" + response);
          return $q.resolve(response);
        }
      });
    }

    function deleteDocument(item) {
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/contract/eraseDocumentsFromAlbagreen",
        item
      ).then(function (response) {
        if (response) {
          console.log(
            "$contractService::eraseDocumentsFromAlbagreen::then" + response
          );
          return $q.resolve(response);
        }
      });
    }

    function getAllContracts(filter) {
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/contract/getAllContracts",
        filter
      ).then(function (response) {
        if (response && response.appContractList) {
          console.log("$contractService::getAllContracts::then" + response);
          return $q.resolve(response);
        }
      });
    }

    function getAllTotalContracts(filter) {
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/contract/getAllTotalContracts",
        filter
      ).then(function (response) {
        if (response && response.allAppContractList) {
          console.log(
            "$contractService::getAllTotalContracts::then" + response
          );
          return $q.resolve(response);
        }
      });
    }

    function getTitolaricerved(cf) {
      var input = {
        cfCliente: cf,
      };
      var deferred = $q.defer();
      return HttpService.send(
        "/simulator/contract/getTitolaricerved",
        input
      ).then(function (response) {
        if (response && response.listTitolariCerved) {
          console.log("$contractService::getTitolaricerved::then" + response);
          return $q.resolve(response && response.listTitolariCerved);
        }
      });
    }

    function updateContractStatus(newStatus, contract) {
      var deferred = $q.defer();
      contract.status = newStatus;
      var model = {
        appContract: contract,
      };
      return HttpService.send(
        "/simulator/contract/updateAppContractStatus",
        model
      ).then(function (response) {
        if (response && response.updateContractOk) {
          console.log(
            "$contractService::updateContractStatus::then" + response
          );
          return $q.resolve(response && response.updateContractOk);
        }
      });
    }

    function updateContractMetadata(contract) {
      var deferred = $q.defer();
      var model = {
        appContract: contract,
      };
      return HttpService.send(
        "/simulator/contract/updateAppContractMetadata",
        model
      ).then(function (response) {
        if (response) {
          console.log(
            "$contractService::updateAppContractMetadata::then" + response
          );
          return $q.resolve(response && response.updateContractOk);
        }
      });
    }

    function addUsers(contract) {
      var deferred = $q.defer();
      var model = {
        appContract: contract,
      };
      return HttpService.send(
        "/simulator/contract/continueToDigitalSignature",
        model
      ).then(function (response) {
        if (response) {
          console.log("$contractService::addUsers::then" + response);
          return $q.resolve(response);
        }
      });
    }

    var fetching = false;

    function getAllSignedContracts(filter) {
      var deferred = $q.defer();
      var model = filter ? {
        appContract: filter,
      } : {};
      fetching = true;
      return HttpService.send(
        "/simulator/contract/getAppContractSignedbyIdentifier",
        model
      )
        .then(function (response) {
          if (response.success) {
            response && response.listAppContractSigned;
            return $q.resolve(response.listAppContractSigned);
          } else {
            return $q.resolve([]);
          }
        })
        .finally(function () {
          fetching = false;
        });
    }

    function finalUploadOtherDocs(contractId, moduleId) {
      var deferred = $q.defer();
      var model = {
        appContract: {
          numeroContratto: contractId,
          modulo: moduleId,
        },
      };
      return HttpService.send(
        "/simulator/contract/finalUploadOtherDocs",
        model
      ).then(function (response) {
        return response && $q.resolve(response);
      });
    }

    var gettingDetails = false;

    function getDetail(idContract) {
      var deferred = $q.defer();
      var model = {
        idContract: idContract,
      };
      gettingDetails = true;
      return HttpService.send(
        "/simulator/contract/contractSignedDetails",
        model
      )
        .then(function (response) {
          console.log("getDetail returned! ", response);
          if (response.success) {
            response && response.listSignedDocFile;
            return $q.resolve(response.listSignedDocFile);
          } else {
            return $q.resolve([]);
          }
        })
        .finally(function () {
          gettingDetails = false;
        });
    }

    function downloadDocumentDetailContract(idContract) {
      var deferred = $q.defer();
      var model = {
        idContract: idContract,
      };
      return HttpService.send("/simulator/NUOVO/SERVIZIO", model).then(
        function (response) {
          console.log("getDetail returned! ", response);
          if (response.success) {
            response && response.listSignedDocFile;
            return $q.resolve(response && response.pdfField);
          }
        }
      );
    }

    function getDossierUrl(dossierId) {
      var input = {
        idDossier: dossierId,
      };

      return HttpService.send("/simulator/contract/getDossierUrl", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function updateSignedDossier(idDossier) {
      var input = {
        idDossier: idDossier,
      };

      return HttpService.send("/simulator/contract/updateSignedDossier", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function changeSignContractMetadata(newStatus, contract) {
      var deferred = $q.defer();
      contract.status = newStatus;
      var model = {
        appContract: contract,
      };
      return HttpService.send(
        "/simulator/contract/changeSignContractMetadata",
        model
      ).then(function (response) {
        if (response) {
          console.log(
            "$contractService::changeSignContractMetadata::then" + response
          );
          return $q.resolve(response);
        }
      });
    }

    function validateCertificate(filter) {
      var deferred = $q.defer();
      var model = {
        appContract: filter,
      };
      return HttpService.send(
        "/simulator/contract/getCertificateContract",
        model,
        false
      ).then(function (response) {
        console.log(
          "$contractService::contract/getCertificateContract::then" + response
        );
        return $q.resolve(response);
      });
    }

    function contractSignedDocs(contract) {
      return HttpService.send(
        "/simulator/contract/contractSignedDocs",
        contract
      )
        .then(function (response) {
          if (response.success) {
            response && response.listSignedDocFile;
            return $q.resolve(response.listSignedDocFile);
          } else {
            return $q.resolve([]);
          }
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getCtrAssDistanza(contract) {
      return HttpService.send(
        "/simulator/financial/getCtrAssDistanza",
        contract
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAmountPractice(id) {
      var deferred = $q.defer();
      var model = {
        id: id,
      };
      return HttpService.send(
        "/simulator/contract/getAmountPractice",
        model
      )
        .then(function (response) {
          console.log("getAmountPractice returned! ", response);
          if (response.success) {
            response && response.amount;
            return $q.resolve(response.amount);
          } else {
            return $q.resolve([]);
          }
        })
        .finally(function () {
        });

    }

    function insertAppDelega(delega, directDelegationCensus) {
      var model = {
        delega: delega,
        directDelegationCensus: directDelegationCensus
      }

      return HttpService.send(
        "/simulator/contract/insertDelega",
        model,
        true
      ).then(function (response) {
        console.log("insertAppDelega: " + response);
        return $q.resolve(response);
      });
    }

    function getAppDelega(numeroContratto) {
      var input = {
        delega: {
          numeroContratto: numeroContratto,
        }
      };

      return HttpService.send("/simulator/contract/getAppDelega", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAppDelegaByIdSim(numeroOridne) {
      var input = {
        delega: {
          numeroOridne: numeroOridne,
          numeroContratto: null
        }
      };

      return HttpService.send("/simulator/contract/getAppDelega", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    function updateAppDelega(delega) {
      var model = {
        delega: delega
      }

      return HttpService.send(
        "/simulator/contract/updateDelega",
        model,
        true
      ).then(function (response) {
        console.log("updateDelega: " + response);
        return $q.resolve(response);
      });
    }

    function deleteAppDelega(delega) {
      var model = {
        delega: delega
      }

      return HttpService.send(
        "/simulator/contract/deleteDelega",
        model,
        true
      ).then(function (response) {
        console.log("updateDelega: " + response);
        return $q.resolve(response);
      });
    }

    function getSignedArchive(filter) {
      var model = filter
        ? {
          appContract: filter,
        }
        : {};
      fetching = true;
      return HttpService.send("/simulator/contract/getSignedArchive", model)
        .then(function (response) {
          if (response.success) {
            response && response.listAppContractSigned;
            return $q.resolve(response.listAppContractSigned);
          } else {
            return $q.resolve([]);
          }
        })
        .finally(function () {
          fetching = false;
        });
    }

    function customerNaturaAdvDigital(id) {

      var input = {
        id: id,
      }

      return HttpService.send("/simulator/customerNaturaAdvDigital", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    return {
      /**
       * @param {*}
       *            filter
       * @returns listAppContracts, totalCount
       */

      getAppContractByIdContract: getAppContractByIdContract,

      getAllContracts: getAllContracts,

      getAllTotalContracts: getAllTotalContracts,

      updateContractStatus: updateContractStatus,

      updateContractMetadata: updateContractMetadata,

      addUsers: addUsers,

      deleteDocument: deleteDocument,

      finalUploadOtherDocs: finalUploadOtherDocs,

      getAllSignedContracts: getAllSignedContracts,

      getAllContractsByFilter: getAllContractsByFilter,

      updateSignedDossier: updateSignedDossier,

      getSignedArchive: getSignedArchive,

      /**
       * Fetching getAllSignedContracts
       */
      fetching: function () {
        return fetching;
      },

      /**
       * Getting contract's details
       */
      gettingDetails: function () {
        return gettingDetails;
      },

      /**
       * @description Prepares the target contract to be called with
       *              getAppContractById, to call on a 69 status contract
       * @param <String>
       *            idContract
       * @returns <boolean> contractRegeneratedOk
       */
      regenerateContract: regenerateContract,

      getDetail: getDetail,

      downloadDocumentDetailContract: downloadDocumentDetailContract,

      getDossierUrl: getDossierUrl,

      changeSignContractMetadata: changeSignContractMetadata,

      validateCertificate: validateCertificate,
      contractSignedDocs: contractSignedDocs,
      getTitolaricerved: getTitolaricerved,
      getCtrAssDistanza: getCtrAssDistanza,
      getAmountPractice: getAmountPractice,

      insertAppDelega: insertAppDelega,
      getAppDelega: getAppDelega,
      updateAppDelega: updateAppDelega,
      deleteAppDelega: deleteAppDelega,
      getAppDelegaByIdSim: getAppDelegaByIdSim,
      customerNaturaAdvDigital: customerNaturaAdvDigital
    };
  })

  .factory(
    "$userService",
    function (
      HttpService,
      $q,
      $storageService,
      $configService,
      $localStorage,
      PermissionFactory,
      $rootScope
    ) {
      function restorePassword(appPasswordUser) {
        var deferred = $q.defer();
        return HttpService.send(
          "/user/auth/restorePassword",
          appPasswordUser
        ).then(function (response) {
          if (response.success) {
            console.log("$userService::restorePassword::then" + response);

            $configService.init(response);

            return $q.resolve(response);
          } else {
            return $q.reject(response && response.errorMessage);
          }
        });
      }

      function updatePassword(appPasswordUser) {
        var deferred = $q.defer();
        return HttpService.send(
          "/user/auth/updatePassword",
          appPasswordUser
        ).then(function (response) {
          if (response.success) {
            $configService.init;
            console.log("$userService::updatePassword::then" + response);
            return $q.resolve(response);
          } else {
            return $q.reject(response && response.errorMessage);
          }
        });
      }

      function insertAppPassword(appPasswordUser) {
        return HttpService.send(
          "/user/insertAppPassword",
          appPasswordUser
        ).then(function (response) {
          if (response) {
            $configService.init(response);
            console.log("$userService::insertAppPassword::then" + response);
            return $q.resolve(response);
          }
        });
      }

      function getAppUserByIdentifier(ndg) {
        return HttpService.send("/user/getAppUserByIdentifier", ndg).then(
          function (response) {
            if (response) {
              console.log(
                "$userService::getAppUserByIdentifier::then" + response
              );
              return $q.resolve(response);
            }
          }
        );
      }

      function updateAppUser(user) {
        return HttpService.send("/user/updateAppUser", user).then(function (
          response
        ) {
          if (response) {
            console.log("$userService::updateAppUser::then" + response);
            return $q.resolve(response);
          }
        });
      }

      function updateAppUserSecondaryCredential(user) {
        var deferred = $q.defer();
        return HttpService.send(
          "/user/updateAppUserSecondaryCredencial",
          user
        ).then(function (response) {
          if (response) {
            console.log("$userService::updateAppUser::then" + response);
            return $q.resolve(response);
          }
        });
      }

      function recoveryPassword(user, token, manageUser) {
        var deferred = $q.defer();
        var input = {
          identifier: user,
          tokenRecaptcha: token,
          manageUser: manageUser
        };
        return HttpService.send("/user/auth/recoveryPassword", input).then(
          function (response) {
            if (response) {
              console.log("$userService::recoveryPassword::then" + response);

              return $q.resolve(response);
            }
          }
        );
      }

      function login(appUser) {
        var deferred = $q.defer();
        var portal = appUser.portal;
        return HttpService.send("/user/auth/login", appUser)
          .then(function (response) {
            if (response.success) {
              if (response.redirectToAra) {
                return $q.resolve(response);
              } else {
                // If aru, sets the certificate too
                if (portal != "ARA" || !portal) {
                  $localStorage.userNowLogged = true;
                  localStorage.setItem('canPostpone', false);
                  $configService.init(response);
                  setMenuState(true);
                }
                $rootScope.comuniMap = response.comuniIstat;
                localStorage.setItem('comuni', JSON.stringify($rootScope.comuniMap));
                $rootScope.mapComuniSoppressi = response.comuniNsil;
                localStorage.setItem('comuniNsil', JSON.stringify($rootScope.mapComuniSoppressi));
                $rootScope.nazioniEstere = response.nazioni;
                localStorage.setItem('nazioni', JSON.stringify($rootScope.nazioniEstere));
                $rootScope.wizardMap = response.wizardConfig;
                localStorage.setItem('wizard', JSON.stringify($rootScope.wizardMap));
                return $q.resolve(response);

              }

            } else {
              console.log("login::catch rejecting to controller");
              return $q.resolve(response);
            }
          })
          .catch(function (error) {
            return $q.reject(error);
          })
          .finally(function () {
            // Adjust visible elements based on permission
            PermissionFactory.hideAndShowElements();
          });
      }

      function switchPortal() {
        return HttpService.send("/user/auth/switch", {})
          .then(function (response) {
            if (response.success) {
              // If aru, sets the certificate too
              $localStorage.userNowLogged = true;
              $configService.init(response);
              setMenuState(true);

              return $q.resolve(response);
            } else {
              console.log("login::catch rejecting to controller");
              return $q.resolve(response);
            }
          })

          .catch(function (error) {
            return $q.reject(error);
          })
          .finally(function () {
            // Adjust visible elements based on permission
            PermissionFactory.hideAndShowElements();
          });
      }

      function insertAppUser(appUser) {
        var input = {
          appUser: appUser,
        };
        var deferred = $q.defer();
        return HttpService.send("/user/insertAppUser", input).then(function (
          response
        ) {
          if (response) {
            $rootScope.comuniMap = response.comuniIstat;
            localStorage.setItem('comuni', JSON.stringify($rootScope.comuniMap));
            $rootScope.mapComuniSoppressi = response.comuniNsil;
            localStorage.setItem('comuniNsil', JSON.stringify($rootScope.mapComuniSoppressi));
            $rootScope.nazioniEstere = response.nazioni;
            localStorage.setItem('nazioni', JSON.stringify($rootScope.nazioniEstere));
            $rootScope.wizardMap = response.wizardConfig;
            localStorage.setItem('wizard', JSON.stringify($rootScope.wizardMap));
            $configService.init(response);
            console.log("$userService::insertAppUser::then" + response);
            return $q.resolve(response);
          }
        });
      }

      function disableAppUserAndChildren(appUser) {
        var deferred = $q.defer();
        return HttpService.send("/user/blockAppUserAndChildren", appUser).then(
          function (response) {
            if (response) {
              console.log(
                "$userService::disableAppUserAndChildren::then" + response
              );
              return $q.resolve(response);
            }
          }
        );
      }

      function registerVendorA(appUser) {
        var deferred = $q.defer();
        return HttpService.send("/user/registerVendorA", appUser).then(
          function (response) {
            if (response) {
              $configService.init(response);
              return $q.resolve(response);
            }
          }
        );
      }

      function checkExistsCustomerAndPiva(input) {
        var deferred = $q.defer();
        return HttpService.send("/user/checkExistsCustomerAndPiva", input).then(
          function (response) {
            if (response) {
              $configService.init(response);
              console.log(
                "$userService::checkExistsCustomerAndPiva::then" + response
              );
              return $q.resolve(response);
            }
          }
        );
      }

      function updateTelephone(inputTel) {
        var deferred = $q.defer();
        var model = {
          appUser: {
            tel: inputTel,
          },
        };
        return HttpService.send("/user/updateTelephone", model).then(function (
          response
        ) {
          if (response) {
            console.log("$userService::updateTelephone::then" + response);
            return $q.resolve(response);
          }
        });
      }

      function updateEmail(inputEmail) {
        var deferred = $q.defer();
        var model = {
          appUser: {
            email: inputEmail,
          },
        };
        return HttpService.send("/user/updateEmail", model).then(function (
          response
        ) {
          if (response && response.success) {
            console.log("$userService::updateEmail::then" + response);
            return $q.resolve(response && response.success);
          }
        });
      }

      function getInfoAnagrafiche() {
        var model = {};
        return HttpService.get("/user/getInfoAnagrafiche", model).then(
          function (response) {
            if (response) {
              console.log("$userService::getInfoAnagrafiche::then" + response);
              return $q.resolve(response);
            }
          }
        );
      }

      function getAppUser() {
        var deferred = $q.defer();
        var model = {};
        return HttpService.send("/user/getAppUser", model).then(function (
          response
        ) {
          if (response && response.appUser) {
            console.log("$userService::getAppUser::then" + response);
            return $q.resolve(response.appUser);
          }
        });
      }

      function hasValidCertificate() {
        if (!!$storageService.get("nextCertificatiFirmaPojo")) {
          return $storageService
            .get("nextCertificatiFirmaPojo")
            .getCertFirmaResponse.certResponse.listCertificatoFirma.some(
              function (cert) {
                cert.status == "VALIDO";
              }
            );
        }
      }

      function getFullChildren() {
        var deferred = $q.defer();
        var model = {
          fullSearch: true,
        };
        return HttpService.send("/user/getChildren", model).then(function (
          response
        ) {
          if (response) {
            console.log("$userService::getFullChildren::then" + response);
            return $q.resolve(response && response.listAppUser);
          }
        });
      }

      function deleteChild(childIdentifier) {
        var deferred = $q.defer();
        var model = {
          appUser: {
            identifier: childIdentifier,
          },
        };
        return HttpService.send("/user/deleteAppUser", model).then(function (
          response
        ) {
          if (response) {
            console.log("$userService::deleteAppUser::then" + response);
            return $q.resolve(response && response.success);
          }
        });
      }

      function createSecondaryCredential(newUser) {
        var deferred = $q.defer();
        var model = {
          appUser: {
            piva: newUser.piva,
            type: newUser.type,
            email: newUser.email,
            name: newUser.name,
            surname: newUser.surname,
            tel: newUser.tel,
            listProfileAssigned: newUser.listProfileAssigned,
          },
        };
        return HttpService.send("/user/createSecondaryCredential", model).then(
          function (response) {
            if (response) {
              console.log(
                "$userService::createSecondaryCredential::then" + response
              );
              return $q.resolve(response && response.success);
            }
          }
        );
      }

      function blockAppUserAndChildren(appUserIdentifier) {
        var deferred = $q.defer();
        var model = {
          appUser: {
            identifier: appUserIdentifier,
          },
        };
        return HttpService.send(
          "/user/blockAppUserAndChildren",
          appUserIdentifier
        ).then(function (response) {
          if (response) {
            console.log(
              "$userService::blockAppUserAndChildren::then" + response
            );
            return $q.resolve(response && response.success);
          }
        });
      }

      function enableAppUser(appUserIdentifier) {
        var deferred = $q.defer();
        var model = {
          appUser: {
            identifier: appUserIdentifier,
          },
        };
        return HttpService.send("/user/enableAppUser", model).then(function (
          response
        ) {
          if (response) {
            console.log("$userService::enableAppUser::then" + response);
            return $q.resolve(response && response.success);
          }
        });
      }

      function isUserAllowed(cf, piva, transactionId, survey, token) {
        var model = {
          surveyPojo: survey,
          appUser: {
            identifier: cf,
            piva: piva,
          },
          appIlTransaction: {
            id: transactionId,
          },
          tokenRecaptcha: token,
        };

        return HttpService.send("/user/isUserAllowed", model, true)
          .then(function (response) {
            if (!response.success) {
              return $q.reject(response);
            }
            if (
              response &&
              response.appUser &&
              (response.appUser.status == "NEW_USER_R" ||
                response.appUser.status == "NEW_USER")
            ) {
              $localStorage.userNowLogged = true;
              $configService.init(response);
              setMenuState(true);
            }
            console.log("$userService::isUserAllowed::then " + response);
            return $q.resolve(response && response.appUser);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getDealerUser() {
        var deferred = $q.defer();
        return HttpService.send("/user/search/getDealerUser", {}, false).then(
          function (response) {
            console.log("$searchUserService::getDealerUser::then " + response);
            return $q.resolve(response && response.appUser);
          }
        );
      }

      function getListUserAssignableProfile() {
        return HttpService.send("/user/getListUserAssignableProfile", {}, false)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (errro) {
            return $q.reject(error);
          });
      }

      function selectNewModalita(modalitaSelezionata) {
        var input = {
          tipoConsegna: modalitaSelezionata,
        };
        return HttpService.send("/user/updateConsegnaDocPeriodica", input, true)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
          .finally(function () {
            console.info("selectNewModalita returned!");
          });
      }

      function getQVA(input) {
        return HttpService.get("/user/qva", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("ERROR: ", error);
            return $q.reject(error);
          });
      }

      function getQvaData(input) {
        return HttpService.get("/user/getQvaData", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("ERROR: ", error);
            return $q.reject(error);
          });
      }

      function sendQva(domande, idWfInstance, codQuestionario) {
        var input = {
          domande: domande,
          idWfInstance: idWfInstance,
          codQuestionario: codQuestionario,
        };

        return HttpService.send("/user/qva/validate", input, true)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("ERROR: ", error);
            return $q.reject(error);
          })
          .finally(function () {
            console.log("questionario mandato");
          });
      }

      function sendQvaCruscotto(
        domande,
        codQuestionario,
        prodotto,
        numeroContratto,
        modulo
      ) {
        var input = {
          domande: domande,
          codQuestionario: codQuestionario,
          prodotto: prodotto,
          contratto: numeroContratto,
          modulo: modulo,
        };

        return HttpService.send("/user/qva/validate", input, true)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("ERROR: ", error);
            return $q.reject(error);
          })
          .finally(function () {
            console.log("questionario mandato");
          });
      }

      function submitQva(contratto, qva, notifyOnly) {
        var input = {
          contract: contratto,
          qva: qva,
        };
        if (notifyOnly) {
          Object.assign(input, {
            notifyOnly: notifyOnly,
          });
        }

        return HttpService.send("/user/submitQva", input, true)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("ERROR: ", error);
            return $q.reject(error);
          })
          .finally(function () {
            console.log("submit fatto");
          });
      }

      function loginSSO(appUser) {
        var deferred = $q.defer();

        return HttpService.send("/user/auth/login-sso-public", appUser)
          .then(function (response) {
            if (response.success) {
              setMenuState(true);

              return $q.resolve(response);
            } else {
              console.log("login::catch rejecting to controller");
              return $q.reject(response.keyMessage);
            }
          })

          .catch(function (error) {
            console.error(error);
          });
      }

      function getRelatedVendors() {
        var deferred = $q.defer();

        return HttpService.get("/user/vendor/relatedVendors")
          .then(function (response) {
            if (response.success) {
              return $q.resolve(response);
            } else {
              console.log("login::catch rejecting to controller");
              return $q.reject(response.keyMessage);
            }
          })

          .catch(function (error) {
            console.error(error);
          });
      }

      function checkAggiornaAnagrafica(riUserG) {
        return HttpService.send("/user/checkAggiornaAnagrafica", riUserG)
          .then(function (response) {
            if (response.success) {
              return $q.resolve(response);
            } else {
              console.log("login::catch rejecting to controller");
              return $q.reject(response.keyMessage);
            }
          })

          .catch(function (error) {
            console.log(error);
          });
      }

      function updateDealerUserEmail(email) {
        var input = {
          email: email,
        };

        return HttpService.send("/user/search/updateDealerUserEmail", input)
          .then(function (response) {
            if (response.success) {
              return $q.resolve(response);
            } else {
              console.log("updateDelaerEmail::catch rejecting to controller");
              return $q.reject(response.keyMessage);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }

      function checkMultiUser() {
        return HttpService.get("/user/isMultiUser", {})
          .then(function (response) {
            if (response) {
              return $q.resolve(response);
            } else {
              console.log("login::catch rejecting to controller");
              return $q.reject(response.keyMessage);
            }
          })

          .catch(function (error) {
            console.log(error);
          });
      }

      function subscriptionRequest(userIdentifier, token) {
        var input = {
          identifier: userIdentifier,
          tokenRecaptcha: token,
        };

        return HttpService.send("/user/auth/subscriptionRequest", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function superLogin(identifier) {
        var input = {
          appUser: {
            identifier: identifier,
          },
        };

        return HttpService.send("/user/auth/superlogin", input)
          .then(function (response) {
            if (!response.success) {
              return $q.resolve(response);
            }
            $configService.init(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getCertificatoFirma() {
        return HttpService.send("/user/getCertificatoFirma", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $.reject(error);
          });
      }

      function filterQccOptions(riUserG) {
        var input = {
          metadata: {
            riUserG: riUserG,
          },
        };

        return HttpService.send("/user/filterQccOptions", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function relProviders(ndgVenditore) {
        var model = {
          ndgVenditore: ndgVenditore,
        };
        return HttpService.get("/user/vendor/relProviders", model)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function otpLogin(session, mode, otp) {
        var input = {
          sessionId: session,
          mode: mode,
          otp: otp,
        };

        return HttpService.send("/user/auth/otpLogin", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function resendOtp(identifier, sessionId) {
        var input = {
          identifier: identifier,
          sessionId: sessionId,
        };

        return HttpService.send("/user/auth/resendOtp", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkAggiornaAnagraficaOps(inputServices) {
        var input = {
          appContract: inputServices
        }
        return HttpService.send('/user/checkAggiornaAnagraficaOps', input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function clientArcInfo(identifier) {
        var input = {
          identifier: identifier
        }
        return HttpService.get("/user/cliente/arc/info", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function getUserUpdatedByIdentifier(identifier) {
        return HttpService.send("/user/getUserUpdatedByIdentifier", identifier).then(
          function (response) {
            if (response) {
              return $q.resolve(response);
            }
          }
        );
      }

      function getModalitaInvioDocPer(financialCustomer) {
        return HttpService.send("/user/getModalitaInvioDocPer", financialCustomer)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getDealerAssociateCustomerIl(identifier) {
        var input = {
          appUser: { identifier: identifier }
        }

        return HttpService.send("/user/search/getDealerAssociateCustomerIl", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function updateAppUserGeneral(appUser) {
        var input = {
          appUser: appUser
        };

        return HttpService.send("/user/updateAppUserGeneral", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log(error);
          });
      }

      function productConfigurationsRichPrev() {

        return HttpService.get("/user/productConfigurationsRichPrev")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error)
          })
      }

      function isCustomerSubjectToCensus(appCustomerUser) {
        var input = {
          appCustomerUser: appCustomerUser
        }

        return HttpService.send("/user/search/isCustomerSubjectToCensus", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error)
          })
      }

      function logout() {

        return HttpService.send("/user/auth/logout", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function confirmDealer() {
        return HttpService.send("/user/confirmDealer", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function checkOtp(otp, channel, transactionOtp, otpMail, transactionOtpMail) {

        var input = {
          otp: otp,
          otpTransactionId: transactionOtp,
          channel: channel,
          otpPec: otpMail,
          otpPecTransactionId: transactionOtpMail
        }

        return HttpService.send("/user/checkOtp", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error)
          })

      }

      function sendOtpPec() {


        return HttpService.send("/user/sendOtpPec", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error)
          })

      }

      function loginImpersonifica(identifier, ndgImpersonator, identifierImpersonator, typeImpersonator, subTypeImpersonator) {
        var input = {
          identifier: identifier,
          ndgImpersonator: ndgImpersonator,
          identifierImpersonator: identifierImpersonator,
          typeImpersonator: typeImpersonator,
          subTypeImpersonator: subTypeImpersonator
        }

        return HttpService.send("/user/auth/login-impersonifica", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function getTitAdv(id) {
        var input = {
          id: id
        }
        return HttpService.send("/user/search/lo/getTitAdv", input)
          .then(response => {
            return $q.resolve(response)
          })
          .catch(error => {
            return $q.reject(error);
          })
      }

      return {
        restorePassword: restorePassword,

        updatePassword: updatePassword,

        insertAppPassword: insertAppPassword,

        getAppUserByIdentifier: getAppUserByIdentifier,

        recoveryPassword: recoveryPassword,

        updateAppUser: updateAppUser,

        updateAppUserSecondaryCredential: updateAppUserSecondaryCredential,

        login: login,

        disableAppUserAndChildren: disableAppUserAndChildren,

        insertAppUser: insertAppUser,

        registerVendorA: registerVendorA,

        checkExistsCustomerAndPiva: checkExistsCustomerAndPiva,

        updateTelephone: updateTelephone,

        updateEmail: updateEmail,

        getAppUser: getAppUser,

        hasValidCertificate: hasValidCertificate,

        getUserUpdatedByIdentifier: getUserUpdatedByIdentifier,

        // Secondary Users
        createSecondaryCredential: createSecondaryCredential,

        getFullChildren: getFullChildren,

        deleteChild: deleteChild,

        blockAppUserAndChildren: blockAppUserAndChildren,

        enableAppUser: enableAppUser,

        isUserAllowed: isUserAllowed,

        getDealerUser: getDealerUser,

        getListUserAssignableProfile: getListUserAssignableProfile,

        selectNewModalita: selectNewModalita,

        getQVA: getQVA,

        sendQva: sendQva,

        loginSSO: loginSSO,

        getRelatedVendors: getRelatedVendors,

        checkAggiornaAnagrafica: checkAggiornaAnagrafica,

        updateDealerUserEmail: updateDealerUserEmail,

        switchPortal: switchPortal,

        checkMultiUser: checkMultiUser,

        subscriptionRequest: subscriptionRequest,

        superLogin: superLogin,

        getCertificatoFirma: getCertificatoFirma,

        filterQccOptions: filterQccOptions,

        getInfoAnagrafiche: getInfoAnagrafiche,

        sendQvaCruscotto: sendQvaCruscotto,

        submitQva: submitQva,

        getQvaData: getQvaData,

        relProviders: relProviders,

        otpLogin: otpLogin,

        resendOtp: resendOtp,

        checkAggiornaAnagraficaOps: checkAggiornaAnagraficaOps,

        clientArcInfo: clientArcInfo,

        getModalitaInvioDocPer: getModalitaInvioDocPer,

        getDealerAssociateCustomerIl: getDealerAssociateCustomerIl,

        updateAppUserGeneral: updateAppUserGeneral,

        productConfigurationsRichPrev: productConfigurationsRichPrev,

        isCustomerSubjectToCensus: isCustomerSubjectToCensus,

        logout: logout,

        confirmDealer: confirmDealer,

        checkOtp: checkOtp,

        sendOtpPec: sendOtpPec,

        loginImpersonifica: loginImpersonifica,

        getTitAdv: getTitAdv
      };
    }
  )

  .service("$nsilService", function (HttpService, $q, es6Factory, Sede) {
    var prefix = "/uni/nsil/";

    var getAddress = function (identifier) {
      var model = {
        identifier: identifier,
      };
      return HttpService.get(prefix + "address", model, false)
        .then(function (response) {
          if (response && response.success) {
            console.log("$typeDomainService::getAddress::then" + response);

            //Filter unique addreses
            var nsilAddresses =
              response &&
              response.nsilAddresses
                .slice()
                .reduce(function (result, nextAddress) {
                  //Se l'oggetto c'è
                  var present = result.find(function (elem) {
                    return es6Factory.compareObj(elem, nextAddress);
                  });

                  result = !present ? result.concat(nextAddress) : result;

                  return result;
                }, []);

            var sedi =
              nsilAddresses &&
              nsilAddresses.map(function (address) {
                return Sede.build(address);
              });

            return $q.resolve(sedi || []);
          }
        })
        .catch(function (err) {
          console.log("$typeDomainService::getAddress::catch" + err);
        });
    };

    return {
      getAddress: getAddress,
    };
  })

  /**
   * Use this to retrieve domain values from DB
   */
  .service("$typeDomainService", function (HttpService, $q, $configService) {
    function getAllLegalStatuses() {
      var deferred = $q.defer();
      var model = {};
      return HttpService.send("/uni/nsil/getAllLegalStatus", model, false).then(
        function (response) {
          if (response && response.success) {
            console.log(
              "$typeDomainService::getAllLegalStatuses::then" + response
            );
            return $q.resolve(response.listAppNsilLglStatus);
          }
        }
      );
    }

    function getListIban(ndg, digital) {
      //if digital is true ndg = riUserG
      if (digital) {
        var model = {
          appNsilIban: {
            ndg: ndg.ndg,
            cf: ndg.cf,
          },
        };
      } else {
        var model = {
          appNsilIban: {
            ndg: ndg,
            cf: $configService.getUser().identifier,
          },
        };
      }

      return HttpService.send("/uni/nsil/getListIban", model, false).then(
        function (response) {
          if (response.success) {
            return $q.resolve(response && response.listAppNsilIban);
          } else {
            return $q.reject(response);
          }
        }
      );
    }

    function getListIbanPostVendita() {
      var model = {
        appNsilIban: {
          ndg: $configService.getUser().ndg,
          cf: $configService.getUser().identifier,
        },
      };

      return HttpService.send("/uni/nsil/getListIban", model, false).then(
        function (response) {
          if (response.success) {
            return $q.resolve(response && response.listAppNsilIban);
          } else {
            return $q.reject(response);
          }
        }
      );
    }

    function getSaeByLegalStatus(formaGiuridica) {
      var model = {
        appNsilLglStatus: {
          id: formaGiuridica,
        },
      };
      return HttpService.send(
        "/uni/nsil/getSaeByLegalStatus",
        model,
        false
      ).then(function (response) {
        if (response) {
          console.log(
            "$typeDomainService::getSaeByLegalStatus::then" + response
          );
          return $q.resolve(response && response.listAppNsilSae);
        }
      });
    }

    function getRaeBySae(sae) {
      var deferred = $q.defer();
      var model = {
        appNsilSae: {
          id: sae,
        },
      };
      return HttpService.send("/uni/nsil/getRaeBySae", model, false).then(
        function (response) {
          if (response) {
            console.log("$typeDomainService::getRaeBySae::then" + response);
            return $q.resolve(response && response.listAppNsilRae);
          }
        }
      );
    }

    function getDomainSet(tableName, columnName) {
      var deferred = $q.defer();
      var model = {
        table: tableName,
        column: columnName,
      };
      return HttpService.send(
        "/uni/typedomain/getDomainSet",
        model,
        false
      ).then(function (response) {
        if (response) {
          console.log("$typeDomainService::getDomainSet::then" + response);
          return $q.resolve(response);
        }
      });
    }

    function getRoles() {
      var deferred = $q.defer();
      var model = {
        table: "RI_DROPDOWN_DOMAINS",
        column: "ROLE",
      };
      return HttpService.send("/uni/typedomain/getDomainSet", model, false)
        .then(function (response) {
          if (response) {
            console.log("$typeDomainService::getDomainSet::then" + response);
            var ruoli = response.domainList
              .filter(function (el) {
                return el.description.split("|").indexOf("ADV") != -1;
              })
              .map(function (roleItem) {
                return roleItem.value;
              });

            return $q.resolve(ruoli);
          }
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function ocrIdentityDocument(input) {
      return HttpService.send("/uni/upload/ocrIdentityDocument", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deleteFile(type, idObject, codiceDocNsil, fileName, idFolder) {
      var input = {
        type: type, //tipo di cancellazione es. IL – PERSONAL_DOCUMENT
        idObject: idObject, // cf  oppure idWfInstance
        codiceDocNsil: codiceDocNsil, //es: 052
        fileName: fileName, //nome del file
        idFolder: idFolder || null,
      };

      return HttpService.send("/uni/deleteFile", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getStatusList() {
      return HttpService.send("/simulator/financial/getStatusList")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getReports(internal) {
      var input = {
        internal: internal
      }
      return HttpService.send("/uni/report", input)
        .then(function (response) {
          if (response) {
            console.log("$typeDomainService::report::then" + response);
            return $q.resolve(response);
          }
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getDomainSetUncached(tableName, columnName) {
      var model = {
        table: tableName,
        column: columnName,
      };

      return HttpService.send("/uni/typedomain/getDomainSetUncached", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function getCodTypeNote(id) {
      var input = {
        id: id,
      };

      return HttpService.send("/uni/nsil/getCodTypeNote", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function insertNote(id, tipoNota, nota) {
      var input =
      {
        id: id,
        tipoNota: tipoNota,
        nota: nota
      }

      return HttpService.send("/uni/nsil/insertNote", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }
    /**
     * Public interface
     */
    return {
      getDomainSet: getDomainSet,
      getRaeBySae: getRaeBySae,
      getSaeByLegalStatus: getSaeByLegalStatus,
      getAllLegalStatuses: getAllLegalStatuses,
      getListIban: getListIban,
      getRoles: getRoles,
      ocrIdentityDocument: ocrIdentityDocument,
      deleteFile: deleteFile,
      getListIbanPostVendita: getListIbanPostVendita,
      getStatusList: getStatusList,
      getReports: getReports,
      getDomainSetUncached: getDomainSetUncached,
      getCodTypeNote: getCodTypeNote,
      insertNote: insertNote
    };
  })

  /**
   * Use it to safely open or close a modal from everywhere
   */
  .service("$modalService", function ($timeout) {
    function openModal(modalId) {
      jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("disable");
      $("#footerInstant").css("z-index", "-1");
      $('.financial-leasing__footer').css("z-index", "-1");
      $("#" + modalId).modal({
        backdrop: false,
      });
      // $timeout(function () {

      //   jQuery(".mCSB_draggerRail").css("height", "0%")
      // }, 3000)
    }

    function closeModal(modalId) {
      $("#" + modalId).modal("hide");
      $("body").removeClass("modal-open");
      $("modal-backdrop fade in").remove();
      $(".modal-backdrop").remove();
      jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("update");
      $(".financial-leasing__footer").css("z-index", "2");
    }

    return {
      openModal: openModal,

      closeModal: closeModal,
    };
  })

  .service("verifyUniqueService", function (HttpService, $http, $q) {
    var verifyingStatus = false;

    function verifyAppUniqueItem(input) {
      verifyingStatus = true;

      return HttpService.send(
        "/uni/unique/verifyAppUniqueItem",
        input,
        true
      ).then(function (response) {
        if (response) {
          if (response.success) {
            verifyingStatus = false;
          }
          return $q.resolve(response);
        }
      });
    }

    function verifyDocument(input) {
      verifyingStatus = true;

      return HttpService.send("/uni/nsil/getDocument", input, true).then(
        function (response) {
          if (response) {
            if (response.success) {
              verifyingStatus = false;
            }
            return $q.resolve(response);
          }
        }
      );
    }

    function getGeneric() {
      return HttpService.send("/uni/unique/getGeneric", {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      verifyAppUniqueItem: verifyAppUniqueItem,
      verifyingStatus: function () {
        return verifyingStatus;
      },
      verifyDocument: verifyDocument,
      getGeneric: getGeneric,
    };
  })

  .factory(
    "$workflowService",
    function (HttpService, $q, WorkflowDto, FinancialModel, $configService, $rootScope) {
      var loading = false;

      function getMetadata(response) {
        var snapshot =
          response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
        var metadata = JSON.parse(snapshot.metadata);
        return metadata;
      }

      function getMetadataFromList(response) {
        var snapshot = response.pop();
        var metadata = JSON.parse(snapshot.metadata);
        return metadata;
      }

      function insertInstance(type) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: {
            idAppVendor: $configService.getUser().identifier,
          },
        });

        return HttpService.send("/uni/workflow/insertInstance", dto).then(
          function (response) {
            if (response.success) {
              console.log("$workflowService::insertInstance::then" + response);
              $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;

              // Extract the new model
              var metadata = getMetadata(response);
              var model = FinancialModel.build(metadata.dynamicInputPojo);
              // Update view index and idWfInstance
              var newFinancialModel = Object.assign(
                model, {
                viewIndex: 0,
              }, {
                idWfInstance: response.workflowSoapPojo.wfInstance.id,
              }
              );

              // Resolve the result
              return $q.resolve(newFinancialModel);
            } else {
              console.log(
                "$workflowService::insertInstance::then:: success false!" +
                response
              );
            }
          }
        );
      }

      function nextStep(financialModel, type, onlyLocal, taskFiliale) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
          taskFiliale: taskFiliale || false,
        });
        return HttpService.send("/uni/workflow/nextStep", dto).then(function (
          response
        ) {
          if (response) {
            $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
            var snapshot =
              response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
            var metadata = JSON.parse(snapshot.metadata);

            // Update view index
            metadata.dynamicInputPojo.viewIndex =
              parseInt(metadata.dynamicInputPojo.viewIndex) + 1;

            // Rebuild the model looking at the new viewIndex (++1)
            var model = FinancialModel.build(metadata.dynamicInputPojo);
            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }
            Object.assign(model, {
              taskFiliale: response.taskFiliale,
            });
            return $q.resolve(model);
          } else {
            console.log(
              "$workflowService::nextStep::then:: success false!" + response
            );
          }
        });
      }

      function backStep(financialModel, type, onlyLocal, taskFiliale) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
          taskFiliale: taskFiliale || false,
        });

        return HttpService.send("/uni/workflow/backToPreviousStep", dto).then(
          function (response) {
            if (response.success) {
              console.log(
                "$workflowService::backToPreviousStep::then" + response
              );

              $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
              var snapshot =
                response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
              var metadata = JSON.parse(snapshot.metadata);
              var newFinancialMetadata = Object.assign(
                metadata.dynamicInputPojo, {
                viewIndex: parseInt(metadata.dynamicInputPojo.viewIndex) - 1,
              }, {
                idWfInstance: snapshot.idWfInstance,
              }
              );
              // var newFinancialModel = FinancialModel.build(
              //   newFinancialMetadata
              // ).adapt();
              if (response.frontEndOptions) {
                Object.assign(newFinancialMetadata, {
                  frontEndOptions: response.frontEndOptions,
                });
              }
              Object.assign(newFinancialMetadata, {
                taskFiliale: response.taskFiliale,
              });

              return $q.resolve(newFinancialMetadata);
            } else {
              console.log(
                "$workflowService::backToPreviousStep::then:: success false!" +
                response
              );
            }
          }
        );
      }

      function getAllSuspendedInstances(filter, type) {
        var dto = {
          workflowSoapPojo: {
            advWfInstance: filter,
            type: (type && type) || "WF_LEASING",
          },
        };
        return HttpService.send(
          "/uni/workflow/getAllInstances",
          dto,
          false
        ).then(function (response) {
          return $q.resolve(response);
        });
      }

      function resumeInstance(idWfInstance, type, controllo) {
        // var dto = { workflowSoapPojo: { idWfInstance: idWfInstance } };
        var dto = WorkflowDto.build({
          idWfInstance: idWfInstance,
          type: (type && type) || "WF_LEASING",
        });

        var obj = {
          frontEndOptions: {
            actionType: controllo,
          },
        };

        controllo && Object.assign(dto, obj);

        return HttpService.send("/uni/workflow/resumeInstance", dto, true).then(
          function (response) {
            $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
            var metadata = getMetadata(response);
            // Rebuild the model looking at the new viewIndex (++1)
            var model = FinancialModel.build(metadata.dynamicInputPojo);
            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }

            return $q.resolve(model);
          }
        );
      }

      function suspendInstance(financialModel, type, onlyLocal, taskFiliale) {
        var dto = WorkflowDto.build({
          financialModel: financialModel,
          type: (type && type) || "WF_LEASING",
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
          taskFiliale: taskFiliale || false,
          snapId: $rootScope.snapId || null
        });

        return HttpService.send("/uni/workflow/draftInstance", dto).then(
          function (response) {
            if (response) {
              $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
              if (response.success == true) {
                return $q.resolve(response.success);
              } else {
                return $q.reject(response.success);
              }
            }
          }
        );
      }

      function releasePractice(idPratica) {
        var input = {
          idPratica: idPratica,
        };
        return HttpService.send("/simulator/financial/releasePractice", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function duplicaPratica(idPratica) {
        var input = {
          idWfInstance: idPratica,
        };
        return HttpService.send("/simulator/preventive/copy/workflow", input)
          .then(function (response) {
            $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
            var metadata = getMetadata(response);
            var model = FinancialModel.build(metadata.dynamicInputPojo);
            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }

            return $q.resolve(model);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitDeroga(financialModel, type) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        return HttpService.send("/simulator/preventive/submitDeroga", dto)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function monitorPratica(idPratica) {
        var input = {
          idWf: idPratica,
        };
        return HttpService.get("/uni/workflow/getHistory", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getFromHistory(idWf, viewIndex) {
        var input = {
          idWf: idWf,
          viewIndex: viewIndex,
        };

        return HttpService.get("/uni/workflow/getFromHistory", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function resumeTaskFiliale(idWfInstance, type, controllo) {
        // var dto = { workflowSoapPojo: { idWfInstance: idWfInstance } };
        var dto = WorkflowDto.build({
          idWfInstance: idWfInstance,
          type: (type && type) || "WF_LEASING",
        });

        return HttpService.send(
          "/uni/workflow/resumeTaskFiliale",
          dto,
          true
        ).then(function (response) {
          $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
          var metadata = getMetadata(response);
          // Rebuild the model looking at the new viewIndex (++1)
          var model = FinancialModel.build(metadata.dynamicInputPojo);

          if (response.frontEndOptions) {
            Object.assign(model, {
              frontEndOptions: response.frontEndOptions,
              taskFiliale: response.taskFiliale,
            });
          }

          Object.assign(model, {
            taskFiliale: response.taskFiliale,
          });

          return $q.resolve(model);
        });
      }

      function duplicaAutorizza(idPratica) {
        var input = {
          idWfInstance: idPratica,
        };
        return HttpService.send("/simulator/preventive/duplicaAutorizza", input)
          .then(function (response) {
            $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
            var metadata = getMetadata(response);
            var model = FinancialModel.build(metadata.dynamicInputPojo);
            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }

            return $q.resolve(model);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkConcurrence(idWfInstance) {
        var input = {
          snapId: $rootScope.snapId,
          workflowSoapPojo: {
            applicationName: "LEASING",
            type: "WF_DIGITAL",
            wfInstance: {
              id: idWfInstance
            }
          }
        }
        return HttpService.send("/uni/workflow/checkConcurrence", input)
          .then(function (response) {
            return $q.resolve(response)
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function getFromHistoryOps(idWfInstance, viewIndex) {
        var input = {
          idWf: idWfInstance,
          viewIndex: viewIndex
        }
        return HttpService.get("/uni/workflow/getFromHistoryOps", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function goToStepDigital(financialModel, type, onlyLocal, taskFiliale, targetViewIndex) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
          taskFiliale: taskFiliale || false,
          targetViewIndex: targetViewIndex || null
        });
        return HttpService.send("/uni/workflow/goToStepDigital", dto).then(function (
          response
        ) {
          if (response) {
            $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
            var snapshot =
              response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
            var metadata = JSON.parse(snapshot.metadata);

            // Update view index
            metadata.dynamicInputPojo.viewIndex =
              parseInt(metadata.dynamicInputPojo.viewIndex) - 1;

            // Rebuild the model looking at the new viewIndex (++1)
            var model = FinancialModel.build(metadata.dynamicInputPojo);
            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }
            Object.assign(model, {
              taskFiliale: response.taskFiliale,
            });
            return $q.resolve(model);
          } else {
            console.log(
              "$workflowService::nextStep::then:: success false!" + response
            );
          }
        });
      }

      function resumeViewDocsDigital(idWfInstance, type, controllo) {
        // var dto = { workflowSoapPojo: { idWfInstance: idWfInstance } };
        var dto = WorkflowDto.build({
          idWfInstance: idWfInstance,
          type: (type && type) || "WF_LEASING",
        });

        var obj = {
          frontEndOptions: {
            actionType: controllo,
          },
        };

        controllo && Object.assign(dto, obj);

        return HttpService.send("/uni/workflow/resumeViewDocsDigital", dto, true).then(
          function (response) {
            $rootScope.snapId = response.workflowSoapPojo.wfInstance.listWfSnapshot[0].id;
            var metadata = getMetadata(response);
            // Rebuild the model looking at the new viewIndex (++1)
            var model = FinancialModel.build(metadata.dynamicInputPojo);
            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }

            return $q.resolve(model);
          }
        );
      }

      return {
        /**
         * @param dynamicWfObj
         * @return {idWfInstance: Integer, financialModel: FinancialModel}
         */
        insertInstance: insertInstance,

        /**
         * Call this to go forward
         */
        nextStep: nextStep,

        /**
         * Call this to go back
         */
        backStep: backStep,

        /**
         * @param filter
         */
        getAllSuspendedInstances: getAllSuspendedInstances,

        /**
         * @param idWfInstance
         */
        resumeInstance: resumeInstance,

        suspendInstance: suspendInstance,
        duplicaPratica: duplicaPratica,
        submitDeroga: submitDeroga,
        monitorPratica: monitorPratica,
        getFromHistory: getFromHistory,
        releasePractice: releasePractice,
        resumeTaskFiliale: resumeTaskFiliale,
        duplicaAutorizza: duplicaAutorizza,
        checkConcurrence: checkConcurrence,
        getFromHistoryOps: getFromHistoryOps,
        goToStepDigital: goToStepDigital,
        resumeViewDocsDigital: resumeViewDocsDigital
      };
    }
  )

  .factory("$monitoringService", function (HttpService, $http, $q) {
    var loadingChart = false;

    function getChartData(series, vendorIdentifier, periodicity) {
      loadingChart = true;
      var deferred = $q.defer();
      if (vendorIdentifier == 0) vendorIdentifier = null;
      var model = {
        listRequest: series,
        identifierVendor: vendorIdentifier,
        periodicity: periodicity,
      };
      return HttpService.send("/uni/kpi/getAllKpi", model).then(function (
        response
      ) {
        if (response) {
          loadingChart = false;
          console.log("$monitoringService::getStaticData::then" + response);
          return $q.resolve(response);
        }
      });
    }

    function getVendors() {
      var deferred = $q.defer();
      var model = {};
      return HttpService.send("/user/getAllAppVendorUser", model).then(
        function (response) {
          if (response) {
            console.log("$monitoringService::getVendors::then" + response);
            return $q.resolve(response);
          }
        }
      );
    }

    function getVendorsAgent(dashboardAra) {
      var deferred = $q.defer();
      var model = {
        dashboardAra: dashboardAra
      }
      return HttpService.send("/user/getAllAppVendorAgent", model).then(
        function (response) {
          if (response) {
            console.log("$monitoringService::getVendorsAgent::then" + response);
            return $q.resolve(response);
          }
        }
      );
    }

    function getDashboardSection2(input) {
      var deferred = $q.defer();
      var model = input;
      return HttpService.send("/uni/kpi/getDashboardSection2", model).then(
        function (response) {
          if (response) {
            console.log("$monitoringService::getDashboardSection2::then" + response);
            return $q.resolve(response);
          }
        }
      );
    }

    function getDashboardValueBox(input) {
      var deferred = $q.defer();
      var model = input;
      return HttpService.send("/uni/kpi/getDashboardValueBox", model).then(
        function (response) {
          if (response) {
            console.log("$monitoringService::getDashboardValueBox::then" + response);
            return $q.resolve(response);
          }
        }
      );
    }

    function getDashboardValueTable(input) {
      var deferred = $q.defer();
      var model = input;
      return HttpService.send("/uni/kpi/getDashboardValueTable", model).then(
        function (response) {
          if (response) {
            console.log("$monitoringService::getDashboardValueTable::then" + response);
            return $q.resolve(response);
          }
        }
      );
    }






    function getExportExcelPracticeError(filter) {

      var input = {
        filter: filter
      }
      return HttpService.dooPost("/uni/kpi/exportContractDetailsError/service-infos", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      /**
       * fetch all vendors
       */
      getVendors: getVendors,
      getExportExcelPracticeError: getExportExcelPracticeError,

      loadingChart: function () {
        return loadingChart;
      },

      /**
       * fetch data for charts
       */
      getChartData: getChartData,

      getVendorsAgent: getVendorsAgent,
      getDashboardSection2: getDashboardSection2,
      getDashboardValueBox: getDashboardValueBox,
      getDashboardValueTable: getDashboardValueTable,

    };
  })

  .factory("$agentService", function (HttpService, $q) {
    function getVendorsOfAgent(ndg) {
      //	function getVendorsOfAgent() {
      var deferred = $q.defer();
      var model = {};
      return (
        HttpService.send(
          "/user/getAllAppUserForVendorAgentEnteSegnalatore",
          ndg
        )
          //	return HttpService.send('/user/getAllAppVendorUser', model)
          .then(function (response) {
            if (response) {
              console.log("$agentService::getVendorsOfAgent::then" + response);
              return $q.resolve(response);
            }
          })
      );
    }

    function getEnteSegnalatore(ndg) {
      //	function getEnteSegnalatore() {
      var deferred = $q.defer();
      var model = {};
      return (
        HttpService.send("/user/getEnteSegnalatoreByFornitore", ndg)
          //	return HttpService.send('/user/getAllAppVendorUser', model)
          .then(function (response) {
            if (response) {
              console.log("$agentService::getEnteSegnalatore::then" + response);
              return $q.resolve(response);
            }
          })
      );
    }

    return {
      getVendorsOfAgent: getVendorsOfAgent,
      getEnteSegnalatore: getEnteSegnalatore,
    };
  })

  .factory("$avanzamentoLavorazioneAlbaService", function (HttpService, $q) {
    function getAllStatiAvanzamentoLavorazioneAlba(filter) {
      var deferred = $q.defer();
      var model = {
        idContract: filter,
      };
      return HttpService.send(
        "/simulator/avanzamentoLavorazioneAlba/getAllStati",
        model
      ).then(function (response) {
        console.log(response);
        if (response) {
          console.log(
            "$contractService::getAllStatiAvanzamentoLavorazioneAlba::then" +
            response
          );
          return $q.resolve(response);
        }
      });
    }

    return {
      getAllStatiAvanzamentoLavorazioneAlba: getAllStatiAvanzamentoLavorazioneAlba,
    };
  })

  .factory("$orderService", function (HttpService, $q) {
    function getConfermaOrdineAcquisto(updatedOrder) {
      var deferred = $q.defer();
      var model = {
        numeroOrdine: updatedOrder.idOrder,
        numeroContratto: updatedOrder.idContract,
        messaggioAvviso: "",
        codiceAgevolativo: "",
      };
      return HttpService.send("/order/confermaOrdineAcquisto", model)
        .then(function (response) {
          if (response) {
            return $q.resolve(response);
          }
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function searchOrder(filter) {
      var input = {
        appOrder: filter,
      };
      return HttpService.send("/order/searchOrder", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      getConfermaOrdineAcquisto: getConfermaOrdineAcquisto,
      searchOrder: searchOrder,
    };
  })

  .factory("$appLogPresaVisioneService", function (HttpService, $q) {
    function insertOrUpdateLog(
      idAppConfermaOrdine,
      ndgProvider,
      presavisione,
      frase
    ) {
      var deferred = $q.defer();
      var model = {
        idAppConfermaOrdine: idAppConfermaOrdine,
        ndgProvider: ndgProvider,
        presavisione: presavisione,
        frase: frase,
      };
      return HttpService.send(
        "/simulator/appLogPresavisione/insertOrUpdateLog",
        model
      ).then(function (response) {
        console.log(response);
        if (response) {
          return $q.resolve(response);
        }
      });
    }

    function insertOrUpdateLogList(
      listAppLogPresaVisione
    ) {
      var deferred = $q.defer();
      var model = {
        listAppLogPresaVisione: listAppLogPresaVisione,
      };
      return HttpService.send(
        "/simulator/appLogPresavisione/insertOrUpdateLogList",
        model
      ).then(function (response) {
        console.log(response);
        if (response) {
          return $q.resolve(response);
        }
      });
    }

    return {
      insertOrUpdateLog: insertOrUpdateLog,
      insertOrUpdateLogList: insertOrUpdateLogList
    };
  })

  .factory("$notificationService", function ($q, HttpService, $configService) {
    var notifications = {};

    notifications.all = [];
    notifications.left = [];
    notifications.right = [];

    function countNewNotifications() {
      var notificationCount = notifications.all.reduce(function (n, obj) {
        if (!!obj)
          return n + (obj.read == false && obj.type != 3 && obj.type != 1);
        else return n;
      }, 0);
      notifications.newNotifications = notificationCount;
      return notificationCount;
    }

    function countCarouselPages(itemsPerPage) {
      if (notifications.all.length) {
        var items = [];
        var numNotifications = notifications.all.length;

        // for (var i = numNotifications; i > -(itemsPerPage - 1) && i != 0; i
        // -= itemsPerPage) {
        for (var i = numNotifications; i > 0 && i != 0; i -= itemsPerPage) {
          items.push(i);
        }
        return items;
      } else {
        return false;
      }
    }

    function byDate(a, b) {
      if (a.insertDate > b.insertDate) {
        return -1;
      }
      if (a.insertDate < b.insertDate) {
        return 1;
      }
      return 0;
    }

    function getNotificationsByUser() {
      var deferred = $q.defer();
      return HttpService.send(
        "/uni/notification/getNotificationsByUser", {},
        false
      ).then(function (response) {
        console.log("getNotifications::then " + response);
        return $q.resolve(response.notificationList);
      });
    }

    function getNotificationOverlay() {
      var deferred = $q.defer();
      return HttpService.send(
        "/uni/notification/getNotificationOverlay", {},
        false
      ).then(function (response) {
        console.log("getNotifications::then " + response);
        return $q.resolve(response.appNotification);
      });
    }

    function getNotificationsByBo(input) {
      var deferred = $q.defer();
      return HttpService.send(
        "/uni/notification/getNotificationsByBo",
        input,
        false
      ).then(function (response) {
        console.log("getNotifications::then " + response);
        return $q.resolve(response.notificationList);
      });
    }

    function getUserNotifications() {
      var deferred = $q.defer();

      return getNotificationsByUser().then(function (resultList) {
        notifications.all = resultList && resultList.sort(byDate);
        notifications.left = [];
        notifications.right = [];
        for (var i = 0; i < notifications.all.length; i++) {
          if (i % 2 == 0) {
            notifications.left.push(notifications.all[i]);
          } else {
            notifications.right.push(notifications.all[i]);
          }
        }
        console.log("notifications: ", notifications);
        countNewNotifications();

        return $q.resolve(notifications.all);
      });
    }

    function getBoNotifications() {
      var deferred = $q.defer();

      return getNotificationsByBo().then(function (resultList) {
        notifications.all = resultList.sort(byDate);
        console.log("notifications: ", notifications);
        return $q.resolve(notifications.all);
      });
    }

    function readNotification(idNotification) {
      var deferred = $q.defer();
      return HttpService.send(
        "/uni/notification/readNotification", {
        appNotification: {
          id: idNotification,
        },
      },
        false
      ).then(function (response) {
        getUserNotifications();
        return $q.resolve(response.notificationReadOk);
      });
    }

    function readNotificationOverlay(idNotification) {
      var deferred = $q.defer();
      return HttpService.send(
        "/uni/notification/readNotificationOverlay", {
        appNotification: {
          id: idNotification,
        },
      },
        false
      ).then(function (response) {
        // getUserNotifications();
        return $q.resolve(response.notificationReadOk);
      });
    }

    function deleteNotification(idNotification) {
      var deferred = $q.defer();
      return HttpService.send(
        "/uni/notification/deletedNotification", {
        appNotification: {
          id: idNotification,
        },
      },
        false
      ).then(function (response) {
        // getBoNotifications();
        console.log(response, "response service");
        return $q.resolve(response.notificationReadOk);
      });
    }

    function insertNotification(notification) {
      var deferred = $q.defer();
      return HttpService.send(
        "/uni/notification/insertNotification",
        notification,
        false
      ).then(function (response) {
        //getBoNotifications();
        console.log(this);
        return $q.resolve(response);
      });
    }

    function getNotificationPdfUrl(notificationId, fileName) {
      return (
        $configService.getAppConfig().url +
        "/uni/notification/download/service-infos/" +
        encodeURIComponent(notificationId) +
        "/" +
        encodeURIComponent(fileName) +
        "/" +
        "?token=" +
        $configService.getAppConfig().token
      );
    }

    function getExtNotificationDataById(id, piva) {
      var input = {
        id: id,
        piva: piva,
      };

      return HttpService.send(
        "/uni/notification/getExtNotificationDataById",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getCascadingDropDown(functionId, codLevel1, codLevel2, codLevel3) {
      var input = {
        codLevel1: codLevel1,
        codLevel2: codLevel2,
        codLevel3: codLevel3,
        functionId: functionId,
      };

      return HttpService.send("/uni/getCascadingDropDown", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitQuestBei(
      id,
      function_id,
      ndg,
      ragSoc,
      indirizzo,
      cf,
      piva,
      rb1,
      rb2,
      rb3,
      rb4,
      numDipendenti,
      ateco,
      rb5,
      periodo,
      rb6,
      importo,
      quotaImportoGreen,
      macroSettore,
      settore,
      categoriaSottoprogetto,
      valoreIndicato,
      descrizione,
      preventivo,
      anno,
      indirizzoCompleto,
      comune,
      provincia,
      cap,
      stato,
      convenzione,
      daCorreggere,
      emailSaz,
      questionario,
      cdPrd,
      agevolazione1,
      agevolazione2,
      numeroContratto,
      modulo,
      tipoModulo,
      internal,
      emailCli
    ) {
      var input = {
        id: id,
        functionId: function_id,
        ndg: ndg,
        ragSoc: ragSoc,
        indirizzo: indirizzo,
        cf: cf,
        piva: piva,
        rb1: rb1,
        rb2: rb2,
        rb3: rb3,
        rb4: rb4,
        numDipendenti: numDipendenti,
        ateco: ateco,
        rb5: rb5,
        periodo: periodo,
        rb6: rb6,
        importo: importo,
        quotaImportoGreen: quotaImportoGreen,
        macroSettore: macroSettore,
        settore: settore,
        categoriaSottoprogetto: categoriaSottoprogetto,
        valoreIndicato: valoreIndicato,
        descrizione: descrizione,
        preventivo: preventivo,
        anno: anno,
        indirizzoCompleto: indirizzoCompleto,
        comune: comune,
        provincia: provincia,
        cap: cap,
        stato: stato,
        convenzione: convenzione,
        daCorreggere: daCorreggere,
        emailSaz: emailSaz,
        questionario: questionario,
        cdPrd: cdPrd,
        agevolazione1: agevolazione1,
        agevolazione2: agevolazione2,
        numeroContratto: numeroContratto,
        modulo: modulo,
        tipoModulo: tipoModulo,
        internal: internal,
        emailCli: emailCli
      };

      return HttpService.send("/uni/submitQuestBei", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitQuestBeiDigital(
      id,
      function_id,
      ndg,
      ragSoc,
      indirizzo,
      cf,
      piva,
      rb1,
      rb2,
      rb3,
      rb4,
      numDipendenti,
      ateco,
      rb5,
      periodo,
      rb6,
      importo,
      quotaImportoGreen,
      macroSettore,
      settore,
      categoriaSottoprogetto,
      valoreIndicato,
      descrizione,
      preventivo,
      anno,
      indirizzoCompleto,
      comune,
      provincia,
      cap,
      stato,
      convenzione,
      daCorreggere,
      emailSaz,
      questionario,
      cdPrd,
      agevolazione1,
      agevolazione2,
      numeroContratto,
      modulo,
      tipoModulo,
      internal,
      emailCli,
      idPracticeDigital
    ) {
      var input = {
        id: id,
        functionId: function_id,
        ndg: ndg,
        ragSoc: ragSoc,
        indirizzo: indirizzo,
        cf: cf,
        piva: piva,
        rb1: rb1,
        rb2: rb2,
        rb3: rb3,
        rb4: rb4,
        numDipendenti: numDipendenti,
        ateco: ateco,
        rb5: rb5,
        periodo: periodo,
        rb6: rb6,
        importo: importo,
        quotaImportoGreen: quotaImportoGreen,
        macroSettore: macroSettore || {},
        settore: settore || {},
        categoriaSottoprogetto: categoriaSottoprogetto || {},
        valoreIndicato: valoreIndicato,
        descrizione: descrizione,
        preventivo: preventivo,
        anno: anno,
        indirizzoCompleto: indirizzoCompleto,
        comune: comune,
        provincia: provincia,
        cap: cap,
        stato: stato,
        convenzione: convenzione,
        daCorreggere: daCorreggere,
        emailSaz: emailSaz,
        questionario: questionario,
        cdPrd: cdPrd,
        agevolazione1: agevolazione1,
        agevolazione2: agevolazione2,
        numeroContratto: numeroContratto,
        modulo: modulo,
        tipoModulo: tipoModulo,
        internal: internal,
        emailCli: emailCli,
        idPracticeDigital: idPracticeDigital
      };

      return HttpService.send("/uni/submitQuestBeiDigital", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function updateQuestBeiStatus(
      id,
      function_id,
      ndg,
      ragSoc,
      indirizzo,
      cf,
      piva,
      rb1,
      rb2,
      rb3,
      rb4,
      numDipendenti,
      ateco,
      rb5,
      periodo,
      rb6,
      importo,
      quotaImportoGreen,
      macroSettore,
      settore,
      categoriaSottoprogetto,
      valoreIndicato,
      descrizione,
      preventivo,
      anno,
      indirizzoCompleto,
      comune,
      provincia,
      cap,
      stato,
      convenzione,
      daCorreggere,
      emailSaz,
      questionario,
      cdPrd,
      agevolazione1,
      agevolazione2,
      numeroContratto,
      modulo,
      tipoModulo,
      internal,
      emailCli
    ) {
      var input = {
        id: id,
        functionId: function_id,
        ndg: ndg,
        ragSoc: ragSoc,
        indirizzo: indirizzo,
        cf: cf,
        piva: piva,
        rb1: rb1,
        rb2: rb2,
        rb3: rb3,
        rb4: rb4,
        numDipendenti: numDipendenti,
        ateco: ateco,
        rb5: rb5,
        periodo: periodo,
        rb6: rb6,
        importo: importo,
        quotaImportoGreen: quotaImportoGreen,
        macroSettore: macroSettore,
        settore: settore,
        categoriaSottoprogetto: categoriaSottoprogetto,
        valoreIndicato: valoreIndicato,
        descrizione: descrizione,
        preventivo: preventivo,
        anno: anno,
        indirizzoCompleto: indirizzoCompleto,
        comune: comune,
        provincia: provincia,
        cap: cap,
        stato: stato,
        convenzione: convenzione,
        daCorreggere: daCorreggere,
        emailSaz: emailSaz,
        questionario: questionario,
        cdPrd: cdPrd,
        agevolazione1: agevolazione1,
        agevolazione2: agevolazione2,
        numeroContratto: numeroContratto,
        modulo: modulo,
        tipoModulo: tipoModulo,
        internal: internal,
        emailCli: emailCli
      };

      return HttpService.send("/uni/updateQuestBeiStatus", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function notifyEvent(documento, idPratica) {
      var input = {
        id: idPratica,
        event: "DOWNLOAD_CTR",
        metadata: documento,
      };

      return HttpService.send("/uni/notification/notifyEvent", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      // type 1 = standard, 2 = checkbox, 3 = pdf, 4 = btn
      notifications: notifications,

      // agnostic, use it from everywhere
      getNotificationsByUser: getNotificationsByUser,

      getNotificationsByBo: getNotificationsByBo,

      getNotificationOverlay: getNotificationOverlay,

      // agnostic, use it from everywhere
      readNotification: readNotification,

      readNotificationOverlay: readNotificationOverlay,

      insertNotification: insertNotification,

      deleteNotification: deleteNotification,

      getUserNotifications: getUserNotifications,

      getBoNotifications: getBoNotifications,

      countCarouselPages: countCarouselPages,

      getNotificationPdfUrl: getNotificationPdfUrl,

      getExtNotificationDataById: getExtNotificationDataById,

      getCascadingDropDown: getCascadingDropDown,

      submitQuestBei: submitQuestBei,

      submitQuestBeiDigital: submitQuestBeiDigital,

      updateQuestBeiStatus: updateQuestBeiStatus,

      notifyEvent: notifyEvent,
    };
  })

  .factory("$privacyService", function (HttpService, $q) {
    function getPrivacyData(appCustomerUser) {
      var deferred = $q.defer();
      var input = {
        appCustomerUser: appCustomerUser,
      };
      return HttpService.send("/user/search/getPrivacyData", input, false).then(
        function (response) {
          return $q.resolve(response);
        }
      );
    }

    function setPrivacyData(privacy) {
      return HttpService.send("/user/setPrivacyData", privacy)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getPrivacyDataDigital(cf, piva, formaGiuridica, ndg) {
      var deferred = $q.defer();
      var input = {
        cf: cf,
        piva: piva,
        formaGiuridica: formaGiuridica,
        ndg: ndg
      };
      return HttpService.send("/user/getPrivacyData", input).then(function (
        response
      ) {
        return $q.resolve(response);
      });
    }

    function getPrivacyDataProfilo() {
      return HttpService.get("/user/getPrivacyDataProfilo", {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function setPrivacyDataProfilo(privacy) {
      return HttpService.send("/user/setPrivacyDataProfilo", privacy)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      getPrivacyData: getPrivacyData,
      setPrivacyData: setPrivacyData,
      getPrivacyDataDigital: getPrivacyDataDigital,
      getPrivacyDataProfilo: getPrivacyDataProfilo,
      setPrivacyDataProfilo: setPrivacyDataProfilo
    };
  })

  .factory("$instantService", function (HttpService, $q) {
    function getProductDetail(idUser, idBene, transactionId, catalogType) {
      var input = {
        appProduct: {
          idUser: idUser,
          idBene: idBene,
          transactionId: transactionId,
          catalogType: catalogType || "IL",
        },
      };

      return HttpService.send("/simulator/getProductDetail", input, true).then(
        function (response) {
          return $q.resolve(response);
        }
      );
    }

    function getPrecontractualTransparency() {
      var input = {};
      return HttpService.send(
        "/simulator/il/getPrecontractualTransparency",
        input,
        true
      ).then(function (response) {
        return $q.resolve(response);
      });
    }

    function checkTransaction(id) {
      var model = {
        appIlTransaction: {
          id: id,
        },
      };
      return HttpService.send("/simulator/il/checkTransaction", model, false)
        .then(function (response) {
          return $q.resolve(response && response.appIlTransaction);
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function newCalculatorRend(
      listAppProduct,
      leasingPrice,
      appPriceList,
      identifierAppVendor
    ) {
      var input = {
        listAppProduct: listAppProduct,
        leasingPrice: leasingPrice,
        appPriceList: appPriceList,
        identifierAppVendor: identifierAppVendor,
        maintenance: 0,
      };

      console.log("inputCalculatorRent: ", input);
      return HttpService.send("/simulator/newCalculatorRent", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function getListIlTransaction(input) {
      return HttpService.send("/simulator/il/getListIlTransaction", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getListaCategoria(pIva, legalForm) {
      var input = {
        piva: pIva,
        legalForm: legalForm,
      };
      return HttpService.send("/user/getListaCategoria", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getListIlTransactionByIdentifierAppVendor(input) {
      console.log(
        "sono nella getListIlTransactionByIdentifierAppVendor con input : " +
        input
      );
      return HttpService.send(
        "/simulator/il/getListIlTransactionByIdentifierAppVendor",
        input
      )
        .then(function (response) {
          if (response.success) {
            console.log(
              "getListIlTransactionByIdentifierAppVendor response :" + response
            );
          } else {
            console.log(
              "errore getListIlTransactionByIdentifierAppVendor : " + response
            );
          }
          return $q.resolve(response);
        })

        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getPrivacyData(codFiscale, formaGiuridica) {
      var input = {
        appCustomerUser: {
          metadata: {
            riUserG: {
              cf: codFiscale,
              formaGiuridica: formaGiuridica,
            },
          },
        },
      };

      return HttpService.send("/user/search/getPrivacyData", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function validateApiKey(apiKey) {
      var dto = {
        key: apiKey,
      };

      return HttpService.send("/user/auth/validateApiKey", dto)
        .then(function (response) {
          if (response && response.success) {
            return $q.resolve(response && response.token);
          } else {
            return $q.reject(response);
          }
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getChart(idTransaction) {
      var input = {
        idTransaction: idTransaction,
      };
      return HttpService.send("/simulator/il/getChart", input)
        .then(function (response) {
          if (response && response.success) {
            return $q.resolve(response);
          } else {
            return $q.reject(error);
          }
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function startMobileCapture(input) {
      return HttpService.send("/uni/startMobileCapture", input, true)
        .then(function (response) {
          console.log(response);
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function listenMobileCapture(input) {
      return HttpService.send("/uni/listenMobileCapture", input)
        .then(function (response) {
          console.log(response);
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function updatePersonalActivity(idTransaction, ocrIdentityDocument) {
      var input = {
        idTransaction: idTransaction,
        ocrResponse: ocrIdentityDocument,
      };
      return HttpService.send("/simulator/il/updatePersonalActivity", input)
        .then(function (response) {
          if (response && response.success) {
            return $q.resolve(response);
          } else {
            return $q.reject(response);
          }
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getErrorMessageContractByIdTransaction(idWfInstance) {
      var input = {
        workflowSoapPojo: {
          wfInstance: {
            id: idWfInstance,
          },
        },
      };

      return HttpService.send(
        "/simulator/il/getErrorMessageContractByIdTransaction",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          $q.reject(error);
        });
    }

    function sendDocumentCorrectToWf(listDocumentAndNote, idWfInstant, type) {
      var input = {
        retryUpload: listDocumentAndNote,
        idWfInstant: idWfInstant,
        typeWf: type,
      };
      return HttpService.send("/simulator/il/sendDocumentToWf", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function callbackMobileCapture(input) {
      return HttpService.send("/uni/callbackMobileCapture", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deleteSubjectSelection(input) {
      return HttpService.send("/simulator/il/deleteSubjectSelection", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function setPrivacyData(privacy) {
      return HttpService.send("/user/setPrivacyData", privacy)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      getProductDetail: getProductDetail,
      getPrecontractualTransparency: getPrecontractualTransparency,
      checkTransaction: checkTransaction,
      newCalculatorRend: newCalculatorRend,
      getListIlTransaction: getListIlTransaction,
      getListaCategoria: getListaCategoria,
      getPrivacyData: getPrivacyData,
      validateApiKey: validateApiKey,
      getChart: getChart,
      startMobileCapture: startMobileCapture,
      listenMobileCapture: listenMobileCapture,
      getListIlTransactionByIdentifierAppVendor: getListIlTransactionByIdentifierAppVendor,
      updatePersonalActivity: updatePersonalActivity,
      getErrorMessageContractByIdTransaction: getErrorMessageContractByIdTransaction,
      sendDocumentCorrectToWf: sendDocumentCorrectToWf,
      callbackMobileCapture: callbackMobileCapture,
      deleteSubjectSelection: deleteSubjectSelection,
      setPrivacyData: setPrivacyData,
    };
  })

  .factory(
    "$instantLeasingService",
    function (
      HttpService,
      $q,
      WorkflowDto,
      InstantModel,
      $configService,
      Certificate,
      Pf,
      User,
      AppIlTransation
    ) {
      var loading = false;

      var self = this;

      self.details = {};
      self.responseCheckRichiestaIL = {};

      function getMetadata(response) {
        var snapshot =
          response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
        var metadata = JSON.parse(snapshot.metadata);
        return metadata;
      }

      function insertInstance() {
        var dto = WorkflowDto.build({
          type: "WF_INSTANT",
          instantModel: {
            idAppVendor: $configService.getUser().identifier,
          },
        });

        return HttpService.send("/uni/workflow/insertInstance", dto).then(
          function (response) {
            if (response.success) {
              console.log("$workflowService::insertInstance::then" + response);

              // Extract the new model
              var metadata = getMetadata(response);

              var model = InstantModel.build(
                Object.assign(metadata.dynamicInputPojo, {
                  idWfInstance: response.workflowSoapPojo.wfInstance.id,
                })
              );

              // Resolve the result
              return $q.resolve(model);
            } else {
              console.log(
                "$workflowService::insertInstance::then:: success false! ",
                response
              );
            }
          }
        );
      }

      function nextStep(instantModel, saveInstance) {
        var dto = WorkflowDto.build({
          type: "WF_INSTANT",
          instantModel: instantModel,
        });
        return HttpService.send("/uni/workflow/nextStep", dto).then(function (
          response
        ) {
          if (response && !saveInstance) {
            var snapshot =
              response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
            var metadata = JSON.parse(snapshot.metadata);

            //Se viewIndex == 0, prendo forma giuridica
            if (metadata.dynamicInputPojo.viewIndex == 0) {
              metadata.dynamicInputPojo.legalForm =
                metadata.globalPojoJson.userCervedFormaGiuridica;
            }

            if (metadata.dynamicInputPojo.viewIndex < 4) {
              // Update view index
              metadata.dynamicInputPojo.viewIndex =
                metadata.dynamicInputPojo.viewIndex + 1;
            }

            // Rebuild the model looking at the new viewIndex (++1)
            var model = InstantModel.build(metadata.dynamicInputPojo).adapt();

            return $q.resolve(model);
          } else {
            console.log(
              "$workflowService::nextStep::then:: success false! ",
              response
            );
          }
        });
      }

      function backStep(instantModel) {
        var dto = WorkflowDto.build({
          type: "WF_INSTANT",
          instantModel: instantModel,
        });

        return HttpService.send("/uni/workflow/backToPreviousStep", dto).then(
          function (response) {
            if (response.success) {
              console.log(
                "$workflowService::backToPreviousStep::then" + response
              );

              var snapshot =
                response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
              var metadata = JSON.parse(snapshot.metadata);
              var newInstantMetadata = Object.assign(
                metadata.dynamicInputPojo, {
                viewIndex: metadata.dynamicInputPojo.viewIndex - 1,
              }, {
                idWfInstance: snapshot.idWfInstance,
              }
              );

              var newInstantModel =
                InstantModel.build(newInstantMetadata).adapt();

              return $q.resolve(newInstantModel);
            } else {
              console.log(
                "$workflowService::backToPreviousStep::then:: success false!" +
                response
              );
            }
          }
        );
      }

      function getAllSuspendedInstances(filter) {
        var dto = {
          workflowSoapPojo: {
            advWfInstance: filter,
            type: "WF_INSTANT",
          },
        };
        return HttpService.send(
          "/uni/workflow/getAllInstances",
          dto,
          false
        ).then(function (response) {
          return $q.resolve(response);
        });
      }

      function resumeInstance(idWfInstance) {
        // var dto = { workflowSoapPojo: { idWfInstance: idWfInstance } };
        var dto = WorkflowDto.build({
          idWfInstance: idWfInstance,
          type: "WF_INSTANT",
        });

        return HttpService.send("/uni/workflow/resumeInstance", dto, true).then(
          function (response) {
            var metadata = getMetadata(response);
            // Rebuild the model looking at the new viewIndex (++1)
            var model = InstantModel.build(metadata.globalPojoJson);

            return $q.resolve(model);
          }
        );
      }

      function suspendInstance(instantModel) {
        var dto = WorkflowDto.build({
          instantModel: instantModel,
          type: "WF_INSTANT",
        });

        return HttpService.send("/uni/workflow/draftInstance", dto).then(
          function (response) {
            if (response) {
              if (response.success == true) {
                return $q.resolve(response.success);
              } else {
                return $q.reject(response.success);
              }
            }
          }
        );
      }

      function getPracticeDetail(idWfInstance) {
        // var dto = { workflowSoapPojo: { idWfInstance: idWfInstance } };
        var dto = WorkflowDto.build({
          idWfInstance: idWfInstance,
        });

        return HttpService.send("/simulator/il/getPracticeDetail", dto, true)
          .then(function (response) {
            if (!response.success) {
              return $q.reject(response.success);
            }
            var metadata = getMetadata(response);

            //Rebuild the model looking at the new viewIndex (++1)
            var instantModel = InstantModel.build(metadata.globalPojoJson);

            var certData = response.listCertFirmaResponse;

            var ordered = certData
              .map(function (elem) {
                return elem.certResponse.listCertificatoFirma;
              })
              .sort(function (a, b) {
                if (a.status == "VALIDO" && b.status == "ASSENTE") {
                  return -1;
                }
                return 1;
              })
              .sort(function (a, b) {
                if (a.emissionDate < b.emissionDate) {
                  return -1;
                }
                return 1;
              });

            var map = {};
            ordered.forEach(function (certPersonList) {
              map[certPersonList[0].codiceFiscale] = Certificate.build(
                certPersonList[0]
              );
            });

            //popolo l'instant model con i dati dei certificati
            instantModel.financialCustomer.metadata.riUserF.listaPf =
              instantModel.financialCustomer.metadata.riUserF.listaPf.map(
                function (pf) {
                  return Pf.build(
                    Object.assign(pf, {
                      certificate: map[pf.cf],
                    })
                  );
                }
              );

            return $q.resolve(instantModel);
          })
          .catch(function (error) {
            $q.reject(error);
          });
      }

      function getPersonalActivitiesIl(idUser) {
        var dto = {
          idUser: idUser,
        };
        return HttpService.send("/simulator/il/getPersonalActivitiesIl", dto)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitRequest(instantModel) {
        // var dto = { workflowSoapPojo: { idWfInstance: idWfInstance } };
        var dto = WorkflowDto.build({
          type: "WF_INSTANT",
          instantModel: instantModel,
        });

        return HttpService.send("/simulator/il/submitRequestIL", dto, true)
          .then(function (response) {
            var metadata = getMetadata(response);

            var model = InstantModel.build(metadata.dynamicInputPojo);

            return $q.resolve(model);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function checkRichiestaIL(instantModel, appIlTransaction) {
        var riUserF = InstantModel.build(instantModel).getRiUserF();
        var cfTitolari = riUserF.getCfTitolari();
        var cfFirmatari = riUserF.getCfFirmatari();

        var user = $configService.getUser();
        user.cfTitolari = cfTitolari;
        user.cfFirmatari = cfFirmatari;

        var dto = {
          appIlTransaction: AppIlTransation.build(appIlTransaction),
          appUser: User.build(user),
        };

        return HttpService.send("/simulator/il/checkRichiestaIL", dto, true)
          .then(function (response) {
            var details = response && response.details;

            self.details = details;
            self.responseCheckRichiestaIL = response;
            if (!details.showPopup) {
              return $q.resolve("false");
            }

            if (
              details.worldcheck &&
              details.titolari &&
              (details.firmatari == "MANUAL" || details.firmatari == "OK")
            ) {
              return $q.resolve("pop1");
            } else {
              return $q.resolve("pop2");
            }
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function undoTransaction(id) {
        var dto = {
          appIlTransaction: {
            id: id,
            idEvent: "E15",
          },
        };

        return HttpService.send("/simulator/il/updateTransaction", dto, true)
          .then(function (response) {
            return $q.resolve(response && response.success);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function inviteAssociate(transaction, listaPf) {
        var dto = {
          appIlTransaction: transaction,
          persons: listaPf,
        };

        return HttpService.send("/simulator/il/inviteAssociate", dto, true)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function recoverFaq() {
        return HttpService.send("/simulator/il/recoverFaq", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      return {
        /**
         * @param dynamicWfObj
         * @return {idWfInstance: Integer, instantModel: InstantModel}
         */
        insertInstance: insertInstance,

        /**
         * Call this to go forward
         */
        nextStep: nextStep,

        /**
         * Call this to go back
         */
        backStep: backStep,

        /**
         * @param filter
         */
        getAllSuspendedInstances: getAllSuspendedInstances,

        /**
         * @param idWfInstance
         */
        resumeInstance: resumeInstance,

        suspendInstance: suspendInstance,

        getPracticeDetail: getPracticeDetail,

        getPersonalActivitiesIl: getPersonalActivitiesIl,

        submitRequest: submitRequest,

        checkRichiestaIL: checkRichiestaIL,

        undoTransaction: undoTransaction,

        inviteAssociate: inviteAssociate,

        recoverFaq: recoverFaq,

        getDetails: function () {
          return self.details;
        },
        getAllInfoFromCheckRichiestaIL: function () {
          return self.responseCheckRichiestaIL;
        },
      };
    }
  )

  .factory("$uniService", function ($q, HttpService, $configService, $rootScope) {
    function certificaNumeroTelefono(numeroTelefono, channel) {
      var input = {
        startMobileNumberCertification: {
          mobileNumber: numeroTelefono,
        },
        channel: channel,
      };

      return HttpService.send("/uni/certificaNumeroTelefono", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function verificaCertificatoNumTel(otp, channel, otpTransactionId) {
      var input = {
        otpTransactionId: otpTransactionId,
        channel: channel,
        otp: otp,
      };

      return HttpService.send("/uni/verificaCertificatoNumTel", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function getUrlsDoc(input) {
      return HttpService.send("/uni/getUrlFileDownload", input, true)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          console.log("ERROR: ", error);
          return $q.reject(error);
        })
        .finally(function () {
          console.log("");
        });
    }

    function getDropDown(input) {
      return HttpService.send("/uni/getDropDown", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function advSearchSubject(input) {
      return HttpService.send("/uni/adv/searchSubject", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function startQuestionario(advPractice, monitorPractice) {
      var input = {
        advPracticeId: advPractice.idAdv,
        ndg: advPractice.cdAna,
        nrCtrLoc: advPractice.nrCtrLoc,
        prModCtr: advPractice.prModCtr,
        cdCnv: advPractice.cdCnv,
        advType: advPractice.advType,
        dataSottoscrizione: advPractice.dataSottoscrizione,
        idAdvPrec: advPractice.idAdvPrec,
        cdStAdv: advPractice.cdStAdv,
        smallTicket: advPractice.smallTicket,
        identifier: advPractice.identifier,
        processLo: advPractice.processLo,
        idSimulation: advPractice.idSimulation,
        operationType: advPractice.operationType,
        monitorPractice: monitorPractice
      };

      return HttpService.send("/uni/adv/startQuestionario", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deleteADV(advPractice) {
      var input = {
        advPracticeId: advPractice.idAdv,
		idNsil: advPractice.idNsil,
		idAppQuestAdv: advPractice.idAppQuestAdv,
        ndg: advPractice.cdAna,
        nrCtrLoc: advPractice.nrCtrLoc,
        prModCtr: advPractice.prModCtr,
        cdCnv: advPractice.cdCnv,
        advType: advPractice.advType,
        cdStAdv: advPractice.cdStAdv,
        motivoAnnullamento: advPractice.motivoAnnullamento,
      };

      return HttpService.send("/uni/adv/delete", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitADV(input) {
      return HttpService.send("/uni/adv/submit", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitADVLO(input) {
      return HttpService.send("/uni/adv/submitLo", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getQuestAdvById(advPracticeId, cf) {
      var input = {
        advPracticeId: advPracticeId,
        cf: cf
      };
      return HttpService.send("/uni/adv/getQuestAdvById", input)
        .then(function (response) {
          $rootScope.comuniMap = response.comuniIstat;
          localStorage.setItem('comuni', JSON.stringify($rootScope.comuniMap));
          $rootScope.mapComuniSoppressi = response.comuniNsil;
          localStorage.setItem('comuniNsil', JSON.stringify($rootScope.mapComuniSoppressi));
          $rootScope.nazioniEstere = response.nazioni;
          localStorage.setItem('nazioni', JSON.stringify($rootScope.nazioniEstere));
          $rootScope.wizardMap = response.wizardConfig;
          localStorage.setItem('wizard', JSON.stringify($rootScope.wizardMap));
          $configService.init(null, response.token);
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitQuestADV(input) {
      return HttpService.send("/uni/adv/submitQuest", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function validateRequestAdv(input) {
      return HttpService.send("/uni/adv/validateRequestAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function uploadDocOnAdv(input) {
      return HttpService.sendMultipart("/uni/uploadDocOnAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getDocCatalog() {
      return HttpService.get("/uni/getDocCatalog", {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function draftQuestAdv(input) {
      return HttpService.send("/uni/adv/draftQuestAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function startQuestionarioPublic(activity) {
      var input = {
        activity: activity
      };

      return HttpService.send("/uni/adv/startQuestionarioPublic", input)
        .then(function (response) {
          $rootScope.comuniMap = response.comuniIstat;
          localStorage.setItem('comuni', JSON.stringify($rootScope.comuniMap));
          $rootScope.mapComuniSoppressi = response.comuniNsil;
          localStorage.setItem('comuniNsil', JSON.stringify($rootScope.mapComuniSoppressi));
          $rootScope.nazioniEstere = response.nazioni;
          localStorage.setItem('nazioni', JSON.stringify($rootScope.nazioniEstere));
          $rootScope.wizardMap = response.wizardConfig;
          localStorage.setItem('wizard', JSON.stringify($rootScope.wizardMap));
          $configService.init(null, response.token);
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function checkCliOps(ndgInput) {
      var input = {
        ndg: ndgInput
      }

      return HttpService.send("/uni/nsil/checkCliOps", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          $q.reject(error);
        })
    }

    function startQuestionarioDigital(idPratica, monitorPractice) {
      var input = {
        idPratica: idPratica,
        monitorPractice: monitorPractice
      };

      return HttpService.send("/uni/adv/startQuestionarioDigital", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitQuestADVDigital(input) {
      return HttpService.send("/uni/adv/submitDigital", input)

        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getIdentificatoriAdvNote(numero, modulo, id) {
      var input = {
        numero: numero,
        modulo: modulo,
        id: id
      }
      return HttpService.get("/uni/getIdentificatoriAdvNote", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }
    function sendBeiCtr(numeroContratto, modulo, internal, emailCli) {
      var input = {
        numeroContratto: numeroContratto,
        modulo: modulo,
        internal: internal,
        emailCli: emailCli
      }

      return HttpService.send("/uni/sendBeiCtr", input)
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function streetype() {

      return HttpService.get("/uni/streetype", {})
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function getEmailCliForBei(numeroContratto, modulo) {
      var input = {
        numeroContratto: numeroContratto,
        modulo: modulo
      }

      return HttpService.send("/uni/getEmailCliForBei", input)
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function getAtecoInnovativi() {

      return HttpService.send("/uni/typedomain/getAtecoInnovativi", {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }


    function startQuestionarioArc() {
      return HttpService.send("/uni/adv/startQuestionarioArc", {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitQuestAdvArc(input) {
      return HttpService.send("/uni/adv/submitArc", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function sendLink(inputRest) {

      var input = {
        contratto: inputRest.contratto,
        modulo: inputRest.modulo,
        ndgSogg: inputRest.ndgSogg,
        emailDest: inputRest.emailDest,
        emailOpAlba: inputRest.emailOpAlba,
        note: inputRest.note
      }

      return HttpService.send("/uni/adv/sendLink", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function printAdv(input) {

      return HttpService.dooPost("/uni/adv/print", input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
          return $q.resolve(true);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function saveDocumentAdv(input) {

      return HttpService.sendMultipart("/uni/adv/saveDocumentAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function deleteDocsPfAdv(idPratica, cfSoggetto, idEstero) {

      var input = {
        idPratica: idPratica,
        cfSoggetto: cfSoggetto,
        idEstero: idEstero
      }

      return HttpService.send("/uni/deleteDocsPfAdv", input)
        .then(response => {
          return $q.resolve(response);
        })
        .catch(error => {
          return $q.reject(error);
        })

    }

    function getEvents(idAdv) {
      var input = {
        idAdv: idAdv
      }
      return HttpService.send("/uni/adv/getEvents", input)
        .then(response => {
          return $q.resolve(response)
        })
        .catch(error => {
          return $q.reject(error);
        })

    }

    function exportAdv(input) {return HttpService.send("/uni/adv/export", input)
    .then(function (response) {
      var base64String = response.advDaLink; 
      
      var byteCharacters = atob(base64String);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);

      var blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      var objectUrl = window.URL || window.webkitURL;
      var url = objectUrl.createObjectURL(blob);
      
      var link = angular.element("<a/>");
      link.css({ display: "none" });
      link.attr({
        href: url,
        target: "_blank",
        download: "Report_ADV_da_Link.xlsx", 
      });

      angular.element(document.body).append(link);
      link[0].click();
      
      link.remove();
      objectUrl.revokeObjectURL(url);

      return $q.resolve(true);
    })
    .catch(function (error) {
      console.error("Errore export:", error);
      return $q.reject(error);
    });
}



    return {
      certificaNumeroTelefono: certificaNumeroTelefono,
      verificaCertificatoNumTel: verificaCertificatoNumTel,
      getUrlsDoc: getUrlsDoc,
      getDropDown: getDropDown,
      advSearchSubject: advSearchSubject,
      startQuestionario: startQuestionario,
      submitADV: submitADV,
      getQuestAdvById: getQuestAdvById,
      submitQuestADV: submitQuestADV,
      validateRequestAdv: validateRequestAdv,
      deleteADV: deleteADV,
      uploadDocOnAdv: uploadDocOnAdv,
      getDocCatalog: getDocCatalog,
      draftQuestAdv: draftQuestAdv,
      startQuestionarioPublic: startQuestionarioPublic,
      checkCliOps: checkCliOps,
      startQuestionarioDigital: startQuestionarioDigital,
      submitQuestADVDigital: submitQuestADVDigital,
      getIdentificatoriAdvNote: getIdentificatoriAdvNote,
      sendBeiCtr: sendBeiCtr,
      streetype: streetype,
      getEmailCliForBei: getEmailCliForBei,
      startQuestionarioArc: startQuestionarioArc,
      submitQuestAdvArc: submitQuestAdvArc,
      submitADVLO: submitADVLO,
      sendLink: sendLink,
      printAdv: printAdv,
      saveDocumentAdv: saveDocumentAdv,
      getAtecoInnovativi: getAtecoInnovativi,
      deleteDocsPfAdv: deleteDocsPfAdv,
      getEvents: getEvents,
      exportAdv: exportAdv
    };
  })

  .factory("$transactionFactory", function () {
    var transactionFactory;
    var transactionFactoryFilters;

    function set(input) {
      transactionFactory = input;
    }

    function get() {
      return transactionFactory;
    }

    function clear() {
      transactionFactory = null;
    }

    function setFilters(input) {
      transactionFactoryFilters = input;
    }

    function getFilters() {
      return transactionFactoryFilters;
    }

    function clearFilters() {
      transactionFactoryFilters = null;
    }

    return {
      set: set,
      get: get,
      clear: clear,
      setFilters: setFilters,
      getFilters: getFilters,
      clearFilters: clearFilters,
    };
  })

  .factory("$carouslService", function ($q) {
    var documento = [{
      tipoDocumento: "CAI",
      index: 0,
    },
    {
      tipoDocumento: "CIE",
      index: 1,
    },
    {
      tipoDocumento: "NCE",
      index: 2,
    },
    {
      tipoDocumento: "CAE",
      index: 9,
    },
    {
      tipoDocumento: "PAS",
      index: 3,
    },
    {
      tipoDocumento: "PAT",
      index: 4,
    },
    ];

    function getInfos(carouselClass, eventName) {
      $("." + carouselClass).on(
        eventName,
        function (event, slick, currentSlide, nextSlide) {
          var infos = {
            event: event,
            slick: slick,
            currentSlide: currentSlide,
            nextSlide: nextSlide,
          };

          return infos;
        }
      );
    }

    function getDocumentType(index) {
      var temp = documento.filter(function (elem) {
        return elem.index === index;
      });
      return temp[0].tipoDocumento;
    }

    function getIndexByValue(value) {
      var temp = documento.filter(function (elem) {
        return elem.tipoDocumento === value;
      });
      return temp[0].index;
    }

    return {
      getInfos: getInfos,
      getDocumentType: getDocumentType,
      getIndexByValue: getIndexByValue,
    };
  })

  .factory("$download", function ($q, HttpService, $configService, $rootScope) {
    function downloadFile(idObject, type, codiceDocNsil, fileName) {
      var id = idObject;
      var typeDownload = type;
      var codTypeDocument = codiceDocNsil || "";
      var fileName = fileName;
      var token = $configService.initAppConfig().token || "no-token";

      return HttpService.get(
        "/uni/download/service-infos/" +
        id +
        "/" +
        codTypeDocument +
        "/" +
        fileName +
        "/" +
        typeDownload +
        "/?token=" +
        token
      )
        .then(function (response) {
          var type = "application/x-download";
          if (input.fileName.includes(".pdf")) {
            type = "application/pdf";
          }
          if (
            input.fileName.includes(".jpg") ||
            input.fileName.includes(".jpeg")
          ) {
            type = "image/jpeg";
          }

          if (input.fileName.includes(".png")) {
            type = "image/png";
          }
          var file = new Blob(
            [response], {
            type: "image/jpeg",
          },
            input.fileName
          );
          return $q.resolve(file);
        })
        .catch(function (err) {
          return $q.reject(err);
        });
    }

    function getGenericDownload(url, input) {
      return HttpService.dooGet(url, input)
        .then(function (response) {
          var headers = response.headers();
          var link = angular.element("<a/>");
          var blob = new Blob([response.data]);
          var objectUrl = window.URL || window.webkitURL;
          var filename =
            headers["content-disposition"] &&
            headers["content-disposition"].split("=")[1];
			// Se filename NON esiste ➜ probabile errore ➜ provo a leggere JSON
			if (filename === undefined) {
	
			  return blob.text().then(function (text) {
			    try {
			      var json = JSON.parse(text);
	
			      // Estraggo dinamicamente il keyMessage
			      var keyMessage = json.keyMessage || "ERROR_QUERY";
	
			      // Mostro il messaggio
			      $rootScope.$broadcast("addAlert", {
			        text: keyMessage,
			      });
	
			      return $q.reject(keyMessage);
	
			    } catch (e) {
			      // Non è JSON ➜ errore generico
			      $rootScope.$broadcast("addAlert", {
			        text: "ERROR_500",
			      });
			      return $q.reject("ERROR_500");
			    }
			  });
			}
          link.css({
            display: "none",
          });
          link.attr({
            href: objectUrl.createObjectURL(blob),
            target: "_blank",
            download: filename,
          });
          link[0].click();
          link.remove();
          objectUrl.revokeObjectURL(blob);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    return {
      downloadFile: downloadFile,
      getGenericDownload: getGenericDownload,
    };
  })

  .factory("$componentUtility", function () {
    function bindingChanged(changed, value) {
      return (
        typeof changed[value] != "undefined" &&
        changed[value].currentValue != "undefined"
      );
    }

    function bindingChangedFirstTime(changed, value) {
      return (
        bindingChanged(changed, value) &&
        Object.keys(changed.identifier.previousValue).length === 0 &&
        typeof changed.identifier.previousValue === "object"
      );
    }

    return {
      /**
       * Use this utility method to know if a binding changed
       */
      bindingChanged: bindingChanged,

      /**
       * User this method to know the first time the changes value changes
       */
      bindingChangedFirstTime: bindingChangedFirstTime,
    };
  })

  .factory(
    "$financialApiService",
    function (
      HttpService,
      $q,
      WorkflowDto,
      FinancialVendor,
      $filter,
      RichiestePostVendita,
      $configService,
      PermissionFactory,
      $rootScope
    ) {
      function getVendor(vendor) {
        if (vendor.cf || vendor.piva) {
          var identifier = vendor.cf ? vendor.cf : vendor.piva;
          var identifierType = vendor.cf ?
            $filter("translate")("CUSTOMER_SELECTION_CF") :
            $filter("translate")("CUSTOMER_SELECTION_PIVA");
        }
        var input = {
          identifier: identifier,
          identifierType: identifierType,
          ragSoc: vendor.ragioneSociale,
          ndg: vendor.ndg,
        };

        return HttpService.get("/user/vendor", input, false).then(function (
          list
        ) {
          return $q.resolve(list);
        });
      }

      function getBanks(bank) {
        return HttpService.get("/user/vendor/bank", bank, false).then(function (
          response
        ) {
          console.log("getBanks: ", response);
          return $q.resolve(response);
        });
      }

      function getCustomerByFilter(customer, searchPf) {
        var input = {
          appCustomerUser: {
            piva: customer.piva,
            cf: customer.cf,
            ragSoc: customer.ragSoc,
            ndg: customer.ndg,
          },
          searchPf: searchPf,
        };

        return HttpService.send("/user/search/getCustomerByFilter", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getRelatedPersonByNsil(customer, searchPf) {
        var input = {
          appCustomerUser: {
            piva: customer.piva,
            cf: customer.cf,
            ragSoc: customer.ragSoc,
            ndg: customer.ndg,
          },
          searchPf: searchPf,
        };

        return HttpService.send("/user/search/getRelatedPersonByNsil", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getPlafond(ndg) {
        var appCustomerUser = {
          ndg: ndg,
        };
        return HttpService.get("/user/plafond", appCustomerUser, false).then(
          function (response) {
            console.log("getPlafond: ", response);
            return $q.resolve(response);
          }
        );
      }

      function getFacilitations(product, conventionCode) {
        if (!conventionCode) {
          conventionCode = null;
        }

        return HttpService.get(
          "/user/facilitation/" + conventionCode + "/",
          product,
          false
        ).then(function (response) {
          console.log("getFacilitations: ", response);
          return $q.resolve(response);
        });
      }

      function getConventions(convection) {
        return HttpService.get("/user/convenction", convection, false).then(
          function (response) {
            console.log("getConventions: ", response);
            return $q.resolve(response);
          }
        );
      }

      function getlistOfCarBrands(codProduct) {
        var input = {
          cdProdotto: codProduct,
        };
        return HttpService.get(
          "/simulator/financial/listOfCarBrands",
          input,
          false
        ).then(function (response) {
          return $q.resolve(response);
        });
      }

      function getPaymentModes(product) {
        return HttpService.get("/user/paymentMode", product, false).then(
          function (response) {
            console.log("getPaymentModes: ", response);
            return $q.resolve(response);
          }
        );
      }

      function insertCustomer(identifier) {
        var input = {
          appCustomerUser: {
            identifier: identifier,
          },
        };
        return HttpService.send("/user/search/insertCustomer", input)
          .then(function (response) {
            console.log("insertCustomer: ", response);
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getMyProduct(input) {
        return HttpService.send("/user/myProducts", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function productConfigurations(
        financialVendor,
        financialCustomer,
        leasingData
      ) {
        var input = {
          financialVendor: financialVendor,
          financialCustomer: financialCustomer,
          leasingData: leasingData,
        };
        return HttpService.send("/user/productConfigurations", input, true)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getSearchRiUserG(customer) {
        var input = {
          appCustomerUser: {
            piva: customer.piva,
            cf: customer.cf,
            ragSoc: customer.ragSoc,
            ndg: customer.ndg,
            identifierType: customer.identifierType,
            identifier: customer.identifier,
          },
        };

        return HttpService.send("/user/search/searchUserG", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getSearchNsilUserG(customer) {
        var input = {
          appCustomerUser: {
            piva: customer.piva,
            cf: customer.cf,
            ragSoc: customer.ragSoc,
            ndg: customer.ndg,
            identifierType: customer.identifierType,
            identifier: customer.identifier,
          },
        };

        return HttpService.send("/user/search/searchNsilUserG", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function vendorDetail(vendor) {
        var input = {
          ndg: vendor.ndg,
          ragSoc: vendor.ragioneSociale,
          identifier: vendor.piva,
        };

        return HttpService.get("/user/vendor/detail", input, false)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getInsertAppPracticeDigital(financialModel) {
        return HttpService.send(
          "/simulator/financial/insertAppPracticeDigital",
          financialModel
        )
          .then(function (response) {
            console.log("getInsertAppPracticeDigital: ", response);
            if (response && response.success) {
              return $q.resolve(response);
            } else {
              return $q.resolve(false);
            }
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getSaveAppCustomer(financialCustomer) {
        financialCustomer.metadata.riUserG.sedeLegale.stato = null;
        financialCustomer.metadata.riUserG.sedeConsegna.stato = null;
        financialCustomer.metadata.riUserG.sedeFatturazione.stato = null;

        return HttpService.send(
          "/user/search/saveAppCustomer",
          financialCustomer
        )
          .then(function (response) {
            console.log("getSaveAppCustomer: ", response);
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function uploadPreventiveDigital(financialModel, type, onlyLocal) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });

        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });

        return HttpService.send("/simulator/preventive/upload", dto)
          .then(function (response) {
            if (response) {

              var snapshot = response.workflowSoapPojo.dynObj;
              var metadata = JSON.parse(snapshot);
              var model = response;

              // Rebuild the model looking at the new viewIndex (++1)

              Object.assign(model, {
                financialModel: metadata,
              });

              return $q.resolve(model);
            }
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getAllClientManager(
        ndgClient,
        ragioneSocialeClient,
        ndgVend,
        reteVend
      ) {
        var input = {
          ndg: ndgClient,
          ragioneSociale: ragioneSocialeClient,
          ndgVenditore: ndgVend,
          reteVenditore: reteVend,
        };

        return HttpService.get("/user/getAllClientManagerList", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            $q.reject(error);
          });
      }

      function submitRichiestaPreventivo(financialModel) {
        return HttpService.send(
          "/simulator/financial/submitRichiestaPreventivo",
          financialModel
        )
          .then(function (response) {
            console.log("getInsertAppPracticeDigital: ", response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getRischioInCorso(idWfInstance) {
        var model = {
          idWfInstance: idWfInstance,
        };

        return HttpService.send("/simulator/financial/getRischioInCorso", model)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function triggerStampaNsil(anno, preventivo, codDocumento) {
        var input = {
          anno: anno,
          preventivo: preventivo,
          codDocumento: codDocumento,
        };

        return HttpService.send(
          "/simulator/preventive/triggerStampaNsil",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getRatingCgs(questionarioNuovoPrestoleasing, cf, abi) {
        var input = {
          questionarioNuovoPrestoleasing: questionarioNuovoPrestoleasing,
          cf: cf,
          abi: abi,
        };
        return HttpService.send("/user/getRatingCgs", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getQuestionarioNpl(cdProdotto, cdConvenzionePrm) {
        var input = {
          cdProdotto: cdProdotto,
          cdConvenzionePrm: cdConvenzionePrm,
        };
        return HttpService.get("/simulator/financial/getQuestionarioNpl", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getExtNotificationDataById(id, piva) {
        var input = {
          id: id,
          piva: piva,
        };

        return HttpService.send(
          "/uni/notification/getExtNotificationDataById",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getCascadingDropDown(
        functionId,
        codLevel1,
        codLevel2,
        codLevel3
      ) {
        var input = {
          codLevel1: codLevel1,
          codLevel2: codLevel2,
          codLevel3: codLevel3,
          functionId: functionId,
        };

        return HttpService.send("/uni/getCascadingDropDown", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function indiciPrelocazione() {
        return HttpService.get("/simulator/financial/indiciPrelocazione")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getBaseValidations(
        codiceProdotto,
        listino,
        convenzioni,
        convenzionePlafond,
        isTariffaPlafond,
        duplicaAutorizza,
        copiedFrom,
        agevolazioni
      ) {
        var input = {
          codiceProdotto: codiceProdotto,
          listino: listino,
          convenzioni: convenzioni,
          convenzionePlafond: convenzionePlafond,
          isTariffaPlafond: isTariffaPlafond,
          duplicaAutorizza: duplicaAutorizza,
          copiedFrom: copiedFrom,
          agevolazioni: agevolazioni
        };
        return HttpService.send(
          "/simulator/financial/getBaseValidations",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            $q.reject(error);
          });
      }

      function checkDeroga(financialModel) {
        return HttpService.send(
          "/simulator/preventive/checkDeroga",
          financialModel
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkSovrapposizioni(financialModel) {
        return HttpService.send(
          "/simulator/preventive/checkSovrapposizioni",
          financialModel
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getDocAttesiForPerson(
        pf,
        digitale,
        firmaDigitaleEsterna,
        idPratica
      ) {
        var input = {
          person: pf,
          digitale: digitale,
          firmaDigitaleEsterna: firmaDigitaleEsterna,
          idPratica: idPratica,
        };

        return HttpService.send("/uni/getDocAttesiForPerson", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function startMobileCaptureDigital(
        persons,
        phoneVendor,
        mobile,
        practiceId,
        identifierCustomer,
        identifierVendor,
        documentsConfig,
        postVendita
      ) {
        if (postVendita) {
          var input = {
            persons: persons,
            mobile: mobile,
            practiceId: practiceId,
            identifierCustomer: identifierCustomer,
            documentsConfig: documentsConfig,
          };
        } else {
          var input = {
            persons: persons,
            vendorPhone: phoneVendor,
            mobile: mobile,
            practiceId: practiceId,
            identifierCustomer: identifierCustomer,
            identifierVendor: identifierVendor,
            documentsConfig: documentsConfig,
          };
        }

        return HttpService.send("/uni/startMobileCaptureDigital", input)
          .then(function (response) {
            console.log(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function startMobileCaptureAdv(
        persons,
        phoneVendor,
        mobile,
        practiceId,
        identifierCustomer,
        identifierVendor,
        documentsConfig,
        postVendita
      ) {
        var input = {
          persons: persons,
          vendorPhone: phoneVendor,
          mobile: mobile,
          practiceId: practiceId,
          identifierCustomer: identifierCustomer,
          identifierVendor: identifierVendor,
          documentsConfig: documentsConfig,
        };

        return HttpService.send("/uni/startMobileCaptureAdv", input)
          .then(function (response) {
            console.log(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function startMobileCaptureAdv(
        persons,
        phoneVendor,
        mobile,
        practiceId,
        identifierCustomer,
        identifierVendor,
        documentsConfig
      ) {
        var input = {
          persons: persons,
          vendorPhone: phoneVendor,
          mobile: mobile,
          practiceId: practiceId,
          identifierCustomer: identifierCustomer,
          identifierVendor: identifierVendor,
          documentsConfig: documentsConfig,
        };

        return HttpService.send("/uni/startMobileCaptureAdv", input)
          .then(function (response) {
            console.log(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function updatePersonalActivityDigital(
        idTransaction,
        ocrIdentityDocument,
        isM17
      ) {
        var input = {
          idTransaction: idTransaction,
          ocrResponse: ocrIdentityDocument,
          isM17: isM17
        };

        return HttpService.send(
          "/simulator/il/updatePersonalActivityDigital",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function validationsByProducts() {
        var input = [];
        return HttpService.send(
          "/simulator/financial/validationsByProducts",
          input
        )
          .then(function (response) {
            console.log("validationsByProducts: ", response);
            if (response) {
              return $q.resolve(response);
            }
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function sendAccept(financialModel, type, onlyLocal) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        return HttpService.send("/simulator/preventive/accept", dto)
          .then(function (response) {
            if (response && response.success) {
              return $q.resolve(response);
            } else {
              return $q.resolve(response);
            }
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function submitRichiestaPlafond(financialModel, type, onlyLocal) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        return HttpService.send(
          "/simulator/preventive/submitRichiestaPlafond",
          dto
        )
          .then(function (response) {
            console.log("sendAccept: ", response);
            if (response && response.success) {
              return $q.resolve(response);
            } else {
              return $q.resolve(false);
            }
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getCurrentDetail() {
        return HttpService.get("/user/vendor/currentDetail")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function vendorGetDetail(vendor) {
        return HttpService.send("/user/vendor/getdetail", vendor, false)
          .then(function (response) {
            console.log("vendorGetDetail: ", response);
            if (!response) {
              return $q.resolve(false);
            } else {
              return $q.resolve(response);
            }
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getPrivacyEnrollment() {
        return HttpService.send("/user/search/getPrivacyEnrollment", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkRichiestaDigital(financialModel) {
        return HttpService.send(
          "/simulator/il/checkRichiestaDigital",
          financialModel
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function generateChecklistDocs(financialModel, type) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });

        return HttpService.send(
          "/simulator/preventive/generateChecklistDocs",
          dto
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function searchSubject(identifier, type, rbValue, isRichiestaPreventivo) {
        var input = {};
        if (rbValue == 'rbCF') {
          input = {
            identifier: identifier,
            type: type,
            isRichiestaPreventivo: isRichiestaPreventivo
          };
        } else if (rbValue == 'rbPiva') {
          input = {
            piva: identifier,
            type: type,
            isRichiestaPreventivo: isRichiestaPreventivo
          };
        } else {
          input = {
            ndg: identifier,
            type: type,
            isRichiestaPreventivo: isRichiestaPreventivo
          };
        }

        return HttpService.send("/user/search/subject", input)
          .then(function (response) {
            console.log("searchSubject: ", response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("searchSubject error: ", error);
            return $q.reject(error);
          });
      }

      function providerPaymentModes(
        idProduct,
        reteVendita,
        raggrConvenzione,
        usato,
        vendorNdg,
        agevolazioni,
        cdModSelected
      ) {
        var input = {
          idProduct: idProduct,
          reteVendita: reteVendita,
          cdRaggrConvenzione: raggrConvenzione,
          usato: usato,
          vendorNdg: vendorNdg,
          agevolazioni: agevolazioni,
          cdModSelected: cdModSelected,
        };
        return HttpService.send("/user/providerPaymentModes", input)
          .then(function (response) {
            if (response) {
              return $q.resolve(response);
            }
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getAllAbi() {
        return HttpService.get("/user/getAllAbi")
          .then(function (response) {
            console.log("getAllAbi: ", response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("getAllAbi error: ", error);
            return $q.reject(error);
          });
      }

      function submitLoadContract(financialModel, type, onlyLocal, showPopup) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        Object.assign(dto, {
          showPopup: showPopup || null,
        });
        return HttpService.send(
          "/simulator/preventive/submitLoadContract ",
          dto
        )
          .then(function (response) {
            console.log("submitLoadContract: ", response);
            if (response && response.success) {
              return $q.resolve(response);
            } else {
              return $q.resolve(false);
            }
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function getAssicurazioni(financialModel) {
        return HttpService.send(
          "/simulator/financial/getAssicurazioni",
          financialModel
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function completeChecklist(financialModel, type, onlyLocal) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        return HttpService.send("/simulator/preventive/completeChecklist", dto)
          .then(function (response) {
            if (response.success) {
              var snapshot =
                response.workflowSoapPojo &&
                response.workflowSoapPojo.wfInstance &&
                response.workflowSoapPojo.wfInstance.listWfSnapshot &&
                response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
              var metadata = snapshot && JSON.parse(snapshot.metadata);
              Object.assign(response, {
                financialModel: metadata.dynamicInputPojo,
              });
            }
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkAssicurazioni(codici, assicurazioni) {
        var CheckAssicurazioniInputPojo = {
          codici: codici,
          assicurazioni: assicurazioni,
        };

        return HttpService.send(
          "/simulator/financial/checkAssicurazioni",
          CheckAssicurazioniInputPojo
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function filterQccOptions(financialCustomer) {
        return HttpService.send("/user/filterQccOptions", financialCustomer)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getAllCab(abi, location) {
        var input = {
          abi: abi,
          location: location,
        };
        return HttpService.send("/user/getAllCab", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function poteriDeroga(financialModel) {
        return HttpService.send(
          "/simulator/preventive/currentPoteriDeroga",
          financialModel
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function retrieveCdu(
        cdProdotto,
        cdServizio,
        idBene,
        vendorNdg,
        cdConvenzionePrm
      ) {
        var input = {
          cdProdotto: cdProdotto,
          cdServizio: cdServizio,
          idBene: idBene,
          vendorNdg: vendorNdg,
          cdConvenzionePrm: cdConvenzionePrm,
        };
        return HttpService.get("/simulator/financial/cdu", input)
          .then(function (response) {
            console.log("financial/cdu: ", response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("financial/cdu error: ", error);
            return $q.reject(error);
          });
      }

      function uploadDocOnDigital(input) {
        return HttpService.sendMultipart("/uni/uploadDocOnDigital", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);

          });
      }

      function uploadDocOnRichPrev(input) {
        return HttpService.sendMultipart("/uni/uploadDocOnRichPrev", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function uploadDocOnPv(input) {
        return HttpService.sendMultipart("/uni/uploadDocOnPv", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function uploadDocOnBacheca(input) {
        return HttpService.sendMultipart("/uni/uploadDocOnBacheca", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function currentDetail() {
        return HttpService.get("/user/vendor/currentDetail")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function progressBar() {
        return HttpService.send("/uni/workflow/progressBar", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getGuarantee(vendorNdg) {
        var input = {
          vendorNdg: vendorNdg,
        };

        return HttpService.get("/user/guarantee", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getGuaranteeDetails(durata, codiceGaranzia, preventivo) {
        var input = {
          durata: durata,
          codiceGaranzia: codiceGaranzia,
          preventivo: preventivo,
        };
        return HttpService.send("/user/guaranteeDetails", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function splitPdf(input) {
        return HttpService.sendMultipart("/uni/splitPdf", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getWizardConfig() {
        return HttpService.send("/simulator/getWizardConfig", {})
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getAssegnatari() {
        return HttpService.get("/user/getAssegnatari")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function takePractice(praticheSelezionate) {
        var input = {
          praticheSelezionate: praticheSelezionate,
        };

        return HttpService.send("/simulator/financial/takePractice", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function multiAssignToUser(ndg, utenzaRete, praticheSelezionate) {
        var input = {
          operatore: {
            ndg: ndg,
            utenzaRete: utenzaRete,
          },
          praticheSelezionate: praticheSelezionate,
        };

        return HttpService.send("/simulator/financial/multiAssignToUser", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function confirmContractChecklist(financialModel, type, onlyLocal) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });

        return HttpService.send("/simulator/confirmContractChecklist", dto)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function searchFaq(question) {
        var input = {
          question: question,
        };

        return HttpService.get("/arc/searchFaq", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkOwnership(financialModel, type, onlyLocal, taskFiliale) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
          taskFiliale: taskFiliale || false,
        });
        return HttpService.send("/simulator/preventive/checkOwnership", dto)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getPrintedDocs(financialMode) {
        return HttpService.send("/simulator/getPrintedDocs", financialMode)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getUploadedDocs(financialMode) {
        return HttpService.send("/simulator/getUploadedDocs", financialMode)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getIdentityDocument(ndgUser, typeDoc) {
        var input = {
          ndg: ndgUser,
          type: typeDoc,
        };
        return HttpService.send("/uni/nsil/getIdentityDocument", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getIva() {
        return HttpService.get("/simulator/getIVA")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getDelega() {
        return HttpService.get("/user/getDelega")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function setDelega(ndg, dataDa, dataA, name, surname) {
        var input = {
          assigneeNdg: ndg,
          dateFrom: dataDa,
          dateTo: dataA,
          name: name,
          surname: surname,
        };

        return HttpService.send("/user/setDelega", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function removeDelega() {
        return HttpService.send("/user/removeDelega")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getListini(financialModel) {
        return HttpService.send("/user/getListini", financialModel)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function richiestePostVendita(filter) {
        return HttpService.get("/arc/richiestePostvendita", filter)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function dettaglioRichiestaPv(id) {
        var input = {
          id: id,
        };

        return HttpService.get("/arc/dettaglioRichiestaPv", input)
          .then(function (response) {
            var model = RichiestePostVendita.build(response);
            return $q.resolve(model);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkIban(iban) {
        var input = {
          iban: iban,
        };

        return HttpService.get("/uni/checkIban", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function searchAddress(ndg) {
        var input = {
          identifier: ndg,
        };

        return HttpService.get("/uni/nsil/address", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getAlertForUser() {
        return HttpService.send("/uni/notification/getAlertForUser")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getDeleghe() {
        return HttpService.get("/user/getDeleghe")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function switchAraUser(
        email,
        userId,
        surname,
        name,
        userType,
        userSubtype
      ) {
        var input = {
          email: email,
          userId: userId,
          surname: surname,
          name: name,
          userType: userType,
          userSubtype: userSubtype,
        };

        return HttpService.send("/user/auth/switchAraUser", input)
          .then(function (response) {
            $configService.init(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
          .finally(function () {
            // Adjust visible elements based on permission
            PermissionFactory.hideAndShowElements();
          });
      }

      function getElencoPoli() {
        return HttpService.send("/simulator/financial/getElencoPoli")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getIVAWithFilter(ivaFornitori, ivaClienti, idProdotto) {
        var input = {
          getIvaFornitori: ivaFornitori,
          getIvaClienti: ivaClienti,
          getIdProdotto: idProdotto,
        };
        return HttpService.send("/simulator/getIVAWithFilter", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getCondizioniAggiuntive(cdProdotto, ndg) {
        var input = {
          cdProdotto: cdProdotto,
          ndg: ndg,
        };

        return HttpService.get(
          "/simulator/financial/getCondizioniAggiuntive",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function validateRating(financialModel) {
        var input = {
          confermaPrestoLeasing: financialModel.leasingData.preventivo.confermaPrestoLeasing,
          ratingCgs: financialModel.leasingData.preventivo.ratingCgs,
        };

        return HttpService.send("/user/validateRating", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkIdentificazione(input) {
        return HttpService.send("/simulator/checkIdentificazione", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getGarToNotify(documenti, notifyGaranti, idPratica) {
        var input = {
          documents: documenti,
          notificheGaranti: notifyGaranti,
          idPractice: idPratica
        };

        return HttpService.send("/simulator/getGarToNotify", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function notifyGar(documenti, notifyGaranti, idPratica) {
        var input = {
          documents: documenti,
          notificheGaranti: notifyGaranti,
          idPractice: idPratica,
        };

        return HttpService.send("/simulator/notifyGar", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function saveIdentificazione(input) {
        return HttpService.send("/simulator/saveIdentificazione", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getContattiCliente(riUserG, id) {
        var input = {
          cf: riUserG.cf,
          piva: riUserG.piva,
          idPractice: id
        };
        return HttpService.send("/user/getContattiCliente", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getSegnalatori(id) {
        var input = {
          idPratica: id,
        };
        return HttpService.get("/user/getSegnalatori", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getContatti(ndg) {
        var input = {
          ndg: ndg
        };
        return HttpService.get("/user/getContatti", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getContattiAra(ndg) {
        var input = {
          ndg: ndg,
        };
        return HttpService.get("/user/getContatti", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function saveUpdateContacts(contatti) {
        return HttpService.send("/user/saveUpdateContacts", contatti)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkQuestNpl(financialModel, type, onlyLocal, onlyCheck) {
        var dto = WorkflowDto.build({
          type: (type && type) || "WF_LEASING",
          financialModel: financialModel,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
          onlyCheck: onlyCheck || false,
        });

        return HttpService.send("/simulator/preventive/checkQuestNpl", dto)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (err) {
            return $q.reject(err);
          });
      }

      function deleteFileList(listElementDeleted) {
        var input = {
          refused: listElementDeleted,
        };
        return HttpService.send("/uni/deleteFileList", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getElencoGaranzieBene(ndgVenditore, cdProdotto) {
        var input = {
          ndgVenditore: ndgVenditore,
          cdProdotto: cdProdotto,
        };
        return HttpService.get("/uni/getElencoGaranzieBene", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function percentualeGarBanca(numeroContratto, modulo) {
        var input = {
          numeroContratto: numeroContratto,
          modulo: modulo,
        };

        return HttpService.get(
          "/simulator/financial/percentualeGarBanca",
          input
        ).then(function (response) {
          return $q.resolve(response);
        });
      }

      function getFirstDeadline(ndg) {
        var input = {
          ndg: ndg,
        };
        return HttpService.send("/simulator/preventive/getFirstDeadline", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getAdvanceType(ndg) {
        var input = {
          ndg: ndg,
        };
        return HttpService.send("/simulator/preventive/getAdvanceType", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function transformModelForSummary(financialModel) {
        return HttpService.send(
          "/simulator/financial/transformModelForSummary",
          financialModel
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function logDownloadZipSetCtr(idPratica) {
        var input = {
          id: idPratica,
        };
        return HttpService.send("/simulator/logDownloadZipSetCtr", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (erro) {
            return $q.reject(error);
          });
      }

      function reopenRequestPv(id) {
        var input = {
          id: id,
        };

        return HttpService.send("/arc/reopenRequestPV", input)
          .then(function (response) {
            var model = RichiestePostVendita.build(response);
            return $q.resolve(model);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function lavoraRichiestaPv(id, confirm) {
        var input = {
          id: id,
          confirm: confirm,
        };
        return HttpService.get("/arc/lavoraRichiestaPv", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getInfoAlbo(formaGiuridica, cdAteco, showAlbo) {
        var input = {
          formaGiuridica: formaGiuridica,
          cdAteco: cdAteco,
          showAlbo: showAlbo
        };
        return HttpService.get("/simulator/getInfoAlbo", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getAccountListGerarchia() {
        return HttpService.get("/simulator/preventive/getAccountListGerarchia")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function setNdgAccount(idPratica, ndg) {
        var input =
        {
          idPratica: idPratica,
          operatore: {
            ndg: ndg
          }
        }

        return HttpService.send("/simulator/preventive/setNdgAccount", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function insertPlafond(appConvenzionePlafond, idOP) {
        var input = {
          appConvenzionePlafond: appConvenzionePlafond,
          idOP: idOP
        }

        return HttpService.send("/user/insertPlafond", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function uploadDocStatSocOnAdv(input) {
        return HttpService.sendMultipart("/uni/uploadDocStatSocOnAdv", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);

          });
      }

      return {
        /**
         *  Home page
         */
        progressBar: progressBar,
        deleteFileList: deleteFileList,
        /**
         * Page vendor search
         */
        getVendor: getVendor,
        vendorDetail: vendorDetail,
        getBanks: getBanks,
        vendorGetDetail: vendorGetDetail,
        getAllAbi: getAllAbi,
        getAllCab: getAllCab,

        /**
         * Page customer search
         */
        getCustomerByFilter: getCustomerByFilter,
        getSearchRiUserG: getSearchRiUserG,
        getInsertAppPracticeDigital: getInsertAppPracticeDigital,
        getCurrentDetail: getCurrentDetail,
        getSearchNsilUserG: getSearchNsilUserG,
        getRelatedPersonByNsil: getRelatedPersonByNsil,

        /**
         * Page client data
         */
        getSaveAppCustomer: getSaveAppCustomer,

        /**
         * Page leasing hypothesis
         */
        getPlafond: getPlafond,
        getFacilitations: getFacilitations,
        getConventions: getConventions,
        getlistOfCarBrands: getlistOfCarBrands,
        getPaymentModes: getPaymentModes,
        getMyProduct: getMyProduct,
        productConfigurations: productConfigurations,
        uploadPreventiveDigital: uploadPreventiveDigital,
        getAllClientManager: getAllClientManager,
        checkDeroga: checkDeroga,
        checkSovrapposizioni: checkSovrapposizioni,
        getListini: getListini,
        getSegnalatori: getSegnalatori,

        /** 
        PAG 10
        */
        indiciPrelocazione: indiciPrelocazione,
        getBaseValidations: getBaseValidations,
        submitRichiestaPreventivo: submitRichiestaPreventivo,
        getDocAttesiForPerson: getDocAttesiForPerson,
        startMobileCaptureDigital: startMobileCaptureDigital,
        startMobileCaptureAdv: startMobileCaptureAdv,
        startMobileCaptureAdv: startMobileCaptureAdv,
        updatePersonalActivityDigital: updatePersonalActivityDigital,
        /**
         *  Page Plafond
         */
        validationsByProducts: validationsByProducts,
        sendAccept: sendAccept,

        /**
         *  Page Plafond
         */
        submitRichiestaPlafond: submitRichiestaPlafond,
        triggerStampaNsil: triggerStampaNsil,
        getRischioInCorso: getRischioInCorso,
        getPrivacyEnrollment: getPrivacyEnrollment,
        checkRichiestaDigital: checkRichiestaDigital,
        generateChecklistDocs: generateChecklistDocs,
        getRatingCgs: getRatingCgs,
        getQuestionarioNpl: getQuestionarioNpl,
        insertPlafond: insertPlafond,
        /** 
        PAG goodManagement / financialRequest
        */
        searchSubject: searchSubject,
        providerPaymentModes: providerPaymentModes,
        submitLoadContract: submitLoadContract,
        getAssicurazioni: getAssicurazioni,
        completeChecklist: completeChecklist,
        checkAssicurazioni: checkAssicurazioni,
        retrieveCdu: retrieveCdu,
        filterQccOptions: filterQccOptions,
        poteriDeroga: poteriDeroga,
        uploadDocOnDigital: uploadDocOnDigital,
        uploadDocOnRichPrev: uploadDocOnRichPrev,
        uploadDocOnPv: uploadDocOnPv,
        uploadDocOnBacheca: uploadDocOnBacheca,
        currentDetail: currentDetail,
        getGuarantee: getGuarantee,
        getGuaranteeDetails: getGuaranteeDetails,
        splitPdf: splitPdf,
        getWizardConfig: getWizardConfig,
        getAssegnatari: getAssegnatari,
        multiAssignToUser: multiAssignToUser,
        confirmContractChecklist: confirmContractChecklist,
        checkOwnership: checkOwnership,
        getIdentityDocument: getIdentityDocument,
        getIva: getIva,
        getDelega: getDelega,
        setDelega: setDelega,
        removeDelega: removeDelega,
        richiestePostVendita: richiestePostVendita,
        dettaglioRichiestaPv: dettaglioRichiestaPv,
        reopenRequestPv: reopenRequestPv,
        checkIban: checkIban,
        searchAddress: searchAddress,
        getAlertForUser: getAlertForUser,
        getDeleghe: getDeleghe,
        switchAraUser: switchAraUser,
        getElencoPoli: getElencoPoli,
        getIVAWithFilter: getIVAWithFilter,
        getCondizioniAggiuntive: getCondizioniAggiuntive,
        getContattiCliente: getContattiCliente,
        takePractice: takePractice,
        getContatti: getContatti,
        getContattiAra: getContattiAra,
        saveUpdateContacts: saveUpdateContacts,
        getElencoGaranzieBene: getElencoGaranzieBene,
        lavoraRichiestaPv: lavoraRichiestaPv,
        getAccountListGerarchia: getAccountListGerarchia,
        setNdgAccount: setNdgAccount,

        /** 
        PAG FAQ
        */
        searchFaq: searchFaq,

        /* 
         ViewDocument
        */
        getPrintedDocs: getPrintedDocs,
        getUploadedDocs: getUploadedDocs,
        checkIdentificazione: checkIdentificazione,
        getGarToNotify: getGarToNotify,
        notifyGar: notifyGar,
        saveIdentificazione: saveIdentificazione,
        validateRating: validateRating,
        checkQuestNpl: checkQuestNpl,
        percentualeGarBanca: percentualeGarBanca,
        getFirstDeadline: getFirstDeadline,
        getAdvanceType: getAdvanceType,
        transformModelForSummary: transformModelForSummary,
        logDownloadZipSetCtr: logDownloadZipSetCtr,
        getInfoAlbo: getInfoAlbo,
        uploadDocStatSocOnAdv: uploadDocStatSocOnAdv
      };
    }
  )

  .factory("$istatService", function ($q, HttpService) {
    function getComuni() {
      return HttpService.get("/uni/getAppComuniIstat")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getComuniNsil() {
      return HttpService.get("/uni/getAppComuniNsil")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getNazioni() {
      return HttpService.get("/uni/getNazioni")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getNazioniUpper() {
      return HttpService.get("/uni/getNazioniUpper")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    return {
      getComuni: getComuni,
      getComuniNsil: getComuniNsil,
      getNazioni: getNazioni,
      getNazioniUpper: getNazioniUpper
    };
  })

  .factory("$arcService", function (
    HttpService,
    $q,
    WorkflowDtoPostVendita,
    RichiestePostVendita
  ) {
    function getContracts(filter) {
      return HttpService.get("/arc/contratti", filter, false)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getDocuments(filter) {
      return HttpService.send("/arc/document", filter, false)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function updateProfileUser(appUser) {
      return HttpService.send("/arc/updateProfileUser", appUser)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getDettaglioContratto(appContract) {
      return HttpService.get("/arc/dettaglioContratto", appContract, false)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getLatestActivities(filter) {
      return HttpService.get("/arc/latestActivities", filter, false)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getElencoBeni(appContract) {
      return HttpService.get("/arc/elencoBeni", appContract)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getFattData() {
      return HttpService.get("/arc/fatturazione")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getDropDownRequestsPv(
      level,
      functionId,
      categoria,
      withProfileFilter,
      filterProfile
    ) {
      var input = {
        level: level,
        functionId: functionId,
        previousSelections: categoria ? [categoria] : undefined,
        withProfileFilter: withProfileFilter,
        filterProfile: filterProfile,
      };

      return HttpService.send("/arc/getDropDownRequestsPv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function startRequestPv(categoria, tipoRichiesta, message, listaContratti) {
      var input = {
        type: categoria,
        subtype: tipoRichiesta,
        metadata: {
          message: message ? message : "",
        },
        ctrRichiestaList: listaContratti,
      };

      return HttpService.send("/arc/startRequestPv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getDropDownSubmittedRequestsPv(category) {
      var input = {
        category: category,
      };

      return HttpService.send("/arc/getDropDownSubmittedRequestsPv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function startUserSignature(dossierId, cfCustomer) {
      var input = {
        dossierId: dossierId,
        cfCustomer: cfCustomer,
      };

      return HttpService.send("/arc/startUserSignature", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function practiceListHome(filter) {
      return HttpService.get("/arc/practiceListHome", filter)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getContractsForVarTargato() {
      return HttpService.get("/arc/contratti/targati")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function setFattData(fatturazione) {
      input = {
        fatturazione: fatturazione,
      };

      return HttpService.send("/arc/setFatturazione", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getImmContracts() {
      return HttpService.get("/arc/contratti/immobiliari/reddito")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getReddito() {
      return HttpService.get("/arc/contratti/reddito")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function aggiornaRichiestaBO(dettaglio) {
      return HttpService.send("/arc/aggiornaRichiestaBO", dettaglio)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function sospendiRichiestaBO(dettaglio) {
      if (dettaglio.metadata.variazioneAnagrafica) {
        if (dettaglio.metadata.variazioneAnagrafica.sedeLegale) {
          dettaglio.metadata.variazioneAnagrafica.sedeLegale.stato =
            dettaglio.metadata.variazioneAnagrafica.sedeLegale.stato.name;
        }
        if (dettaglio.metadata.variazioneAnagrafica.sedeConsegna) {
          dettaglio.metadata.variazioneAnagrafica.sedeConsegna.stato =
            dettaglio.metadata.variazioneAnagrafica.sedeConsegna.stato.name;
        }
        if (dettaglio.metadata.variazioneAnagrafica.sedeFatturazione) {
          dettaglio.metadata.variazioneAnagrafica.sedeFatturazione.stato =
            dettaglio.metadata.variazioneAnagrafica.sedeFatturazione.stato.name;
        }
      }
      return HttpService.send("/arc/sospendiRichiestaBO", dettaglio)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function exportRichiestePV(filter) {
      return HttpService.get("/arc/exportRichiestePV", filter)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getVehicles(contratti) {
      var input = {
        contratti: contratti,
      };
      return HttpService.send("/arc/dettaglio/contratto/targato", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function downloadDocumentationRichiestaPostVendita(model) {
      cleanPvModel(model.metadata, model.applicationName);
      return HttpService.send("/arc/downloadDocumentation", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function uploadDocumentationRichiestaPostVendita(model) {
      cleanPvModel(model.metadata, model.applicationName);
      return HttpService.send("/arc/uploadDocumentation", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getDettaglioReddito(numContratto, numModulo) {
      var input = {
        numeroContratto: numContratto,
        numeroModulo: numModulo,
      };
      return HttpService.get(
        "/arc/dettaglio/contratto/immobiliare/reddito",
        input
      )
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getContrattiMoratoria(ndg) {
      var input = {
        ndg: ndg,
      };
      return HttpService.get("/arc/contratti/moratoria", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function submitMoratoria(listaContratti, ndg) {
      var input = {
        listContratti: listaContratti,
        ndg: ndg,
      };
      return HttpService.send("/arc/contratti/submitMoratoria", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function tipiRichiesta(contratti) {
      return HttpService.send("/arc/tipiRichiesta", contratti)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getIrap(filter) {
      return HttpService.get("/arc/contratti/irap", filter)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function requestIrap(ctrRichiestaList) {
      var input = {
        ctrRichiestaList: ctrRichiestaList,
      };
      return HttpService.send("/arc/startRequestIrap", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getIrapYears() {
      return HttpService.get("/arc/contratti/irap/anni")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    function getLinkedPersonDocScaduto() {

      return HttpService.send('/arc/getLinkedPersonDocScaduto', {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function deletePersonDocIdentita(person, id) {
      var input = {
        person: person,
        id: id
      }
      return HttpService.send("/arc/deletePersonDocIdentita", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })

    }

    function getLinkedPersonAdv() {

      return HttpService.send('/arc/getLinkedPersonAdv', {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function checkPersonsPvAdv(input) {

      return HttpService.send("/arc/checkPersonsPvAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function updateAdv(aggiornamentoAdv, id, viewIndex, applicationName, typeWf) {
      var input = {
        aggiornamentoAdv: aggiornamentoAdv,
        id: id,
        viewIndex: viewIndex,
        applicationName: applicationName,
        typeWf: typeWf,
      };

      return HttpService.send("/arc/submitRequestPV/updateAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function completeAdv(aggiornamentoAdv, id, viewIndex, applicationName, typeWf) {
      var input = {
        aggiornamentoAdv: aggiornamentoAdv,
        id: id,
        viewIndex: viewIndex,
        applicationName: applicationName,
        typeWf: typeWf,
      };

      return HttpService.send("/arc/submitRequestPV/completeAdv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getKeyPrevEstinzione(model) {
      cleanPvModel(model.metadata, model.applicationName);
      return HttpService.send("/arc/getKeyPrevEstinzione", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getSintesiEstinzione(model) {
      cleanPvModel(model.metadata, model.applicationName);
      return HttpService.send("/arc/getSintesiEstinzione", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getAllDocumentsPv(idWf) {

      var input = {
        idWf: idWf
      }

      return HttpService.send("/arc/getAllDocumentsPv", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function declinaRiscatto(model) {
      var input = model;
      return HttpService.send("/arc/declinaRiscatto", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getSignSelectionInfo(id) {

      var input = {
        id: id
      }

      return HttpService.send("/arc/getSignSelectionInfo ", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function getStepInfoDetails(model) {
      cleanPvModel(model.metadata, model.applicationName);
      return HttpService.send("/arc/getStepInfoDetails", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function deleteSubjectSelection(cf, id) {
      var input = {
        cfSoggetto: cf,
        idPratica: id
      }

      return HttpService.send("/arc/deleteSubjectSelection", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function dettaglioCanone(numContratto, modulo) {
      var appContract = {
        numeroContratto: numContratto,
        modulo: modulo
      }

      return HttpService.send("/arc/contratti/dettaglioCanone", appContract)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function tipiRichiestaGroup(contratti) {
      return HttpService.send("/arc/tipiRichiestaGroup", contratti)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getListTypeUserGestUser() {
      return HttpService.get("/arc/getListTypeUserGestUser")
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function uploadDocStartRiscAnt(model) {
      return HttpService.send("/arc/uploadDocStartRiscAnt", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function getSignerPv(cf, id) {
      var input = {
        cf: cf,
        id: id
      }

      return HttpService.send("/arc/search/getSignerPv", input)
        .then(function (response) {
          return $q.resolve(response && response.appCustomerUser);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function ibanRiscAnt(id) {
      var input = {

        id: id
      }

      return HttpService.send("/arc/infoRequestPV/ibanRiscAnt", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function customerNaturaAdv() {

      return HttpService.send("/arc/customerNaturaAdv", {})
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getContractsLight() {
      return HttpService.get("/arc/contrattiLight",)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    function archiveToRead(filter) {

      var input = filter;

      return HttpService.get("/arc/document/archiveToRead", filter)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function getMessagesPvAg(idPratica) {
      var input = {
        id: idPratica
      }
      return HttpService.send("/arc/getMessagesPvAg", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function setMessagePvToAg(practiceId, conversationId, message) {
      var input = {
        practiceId: practiceId,
        conversationId: conversationId,
        message: message
      }
      return HttpService.send("/arc/setMessagePvToAg", input)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function checklistPv(model) {
      cleanPvModel(model.metadata, model.applicationName);
      return HttpService.send("/arc/checklistPv", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function acceptRiscTermine(
      richiestaPostVendita,
      type,
      applicationName,
      onlyLocal
    ) {
      var dto = WorkflowDtoPostVendita.build({
        type: type,
        applicationName: applicationName,
        richiestaPostVendita: richiestaPostVendita,
      });
      Object.assign(dto, {
        onlyLocal: onlyLocal || false,
      });

      return HttpService.send("/arc/acceptRiscTermine", dto)
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function getLinkedNewRespUtenza() {

      return HttpService.send('/arc/getLinkedNewRespUtenza', {})
        .then(function (response) {
          var modelTemp = JSON.parse(response.workflowSoapPojo.wfInstance.listWfSnapshot[0].metadata)
          var model = modelTemp.dynamicInputPojo
          Object.assign(model, {
            targetWizard: response.targetWizard,
            frontEndOptions: response.frontEndOptions
          })
          return $q.resolve(model);
        })
        .catch(function (error) {
          return $q.reject(error);
        })
    }

    function checklistPvConferma(model) {
      cleanPvModel(model.metadata, model.applicationName);
      return HttpService.send("/arc/checklistPvConferma", model)
        .then(function (response) {
          return $q.resolve(response);
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }


    function getIpt(id, provinciaImmatricolazione, riscattoTerzo) {

      var input = {
        id: id,
        provinciaImmatricolazione: provinciaImmatricolazione,
        riscattoTerzo: riscattoTerzo
      }

      return HttpService.send("/arc/getIpt", input)
        .then(function (response) {
          return $q.resolve(response)
        })
        .catch(function (error) {
          return $q.reject(error)
        })
    }

    function getSpeseLogged(id) {

      var input = {
        id: id
      }
      return HttpService.send("/arc/getSpeseLogged", input)
        .then((response) => {
          return $q.resolve(response)
        })
        .catch((error) => {
          return $q.reject(error)
        })
    }

    function confirmSpese(input) {

      return HttpService.send("/arc/confirmSpese", input)
        .then((response) => {
          return $q.resolve(response)
        })
        .catch((error) => {
          return $q.reject(error)
        })
    }

    function copyRequestPv(listaContratti, id, categoria, tipoRichiesta) {
      var input = {
        ctrRichiestaList: listaContratti,
        id: id,
        type: categoria,
        subtype: tipoRichiesta,
      };
      return HttpService.send("/arc/copyRequestPv", input)
        .then(function (response) {
          var snapshot =
            response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
          var metadata = JSON.parse(snapshot.metadata);
          Object.assign(metadata.dynamicInputPojo, {
            route: snapshot.route,
          });
          var model = RichiestePostVendita.build(metadata.dynamicInputPojo);
          if (model && !model.applicationName) {
            model.applicationName = snapshot.applicationName
          }

          if (response.frontEndOptions) {
            Object.assign(model, {
              frontEndOptions: response.frontEndOptions,
            });
          }

          if (response.workflowSoapPojo.wfInstance.insertUser) {
            Object.assign(model, {
              insertUser: response.workflowSoapPojo.wfInstance.insertUser,
            });
          }

          return $q.resolve(model);

        })
        .catch(function (error) {
          return $q.reject(error);

        });
    }


    return {
      getContracts: getContracts,
      getDocuments: getDocuments,
      updateProfileUser: updateProfileUser,
      getLatestActivities: getLatestActivities,
      getFattData: getFattData,
      getDettaglioContratto: getDettaglioContratto,
      getElencoBeni: getElencoBeni,
      getDropDownRequestsPv: getDropDownRequestsPv,
      startRequestPv: startRequestPv,
      getDropDownSubmittedRequestsPv: getDropDownSubmittedRequestsPv,
      startUserSignature: startUserSignature,
      practiceListHome: practiceListHome,
      getContractsForVarTargato: getContractsForVarTargato,
      setFattData: setFattData,
      getImmContracts: getImmContracts,
      aggiornaRichiestaBO: aggiornaRichiestaBO,
      sospendiRichiestaBO: sospendiRichiestaBO,
      exportRichiestePV: exportRichiestePV,
      getVehicles: getVehicles,
      downloadDocumentationRichiestaPostVendita: downloadDocumentationRichiestaPostVendita,
      uploadDocumentationRichiestaPostVendita: uploadDocumentationRichiestaPostVendita,
      getDettaglioReddito: getDettaglioReddito,
      getContrattiMoratoria: getContrattiMoratoria,
      submitMoratoria: submitMoratoria,
      getReddito: getReddito,
      tipiRichiesta: tipiRichiesta,
      getIrap: getIrap,
      requestIrap: requestIrap,
      getIrapYears: getIrapYears,
      getLinkedPersonDocScaduto: getLinkedPersonDocScaduto,
      deletePersonDocIdentita: deletePersonDocIdentita,
      getLinkedPersonAdv: getLinkedPersonAdv,
      checkPersonsPvAdv: checkPersonsPvAdv,
      updateAdv: updateAdv,
      completeAdv: completeAdv,
      getKeyPrevEstinzione: getKeyPrevEstinzione,
      getSintesiEstinzione: getSintesiEstinzione,
      getAllDocumentsPv: getAllDocumentsPv,
      declinaRiscatto: declinaRiscatto,
      getSignSelectionInfo: getSignSelectionInfo,
      getStepInfoDetails: getStepInfoDetails,
      deleteSubjectSelection: deleteSubjectSelection,
      dettaglioCanone: dettaglioCanone,
      tipiRichiestaGroup: tipiRichiestaGroup,
      getListTypeUserGestUser: getListTypeUserGestUser,
      uploadDocStartRiscAnt: uploadDocStartRiscAnt,
      getSignerPv: getSignerPv,
      ibanRiscAnt: ibanRiscAnt,
      customerNaturaAdv: customerNaturaAdv,
      getContractsLight: getContractsLight,
      archiveToRead: archiveToRead,
      getMessagesPvAg: getMessagesPvAg,
      setMessagePvToAg: setMessagePvToAg,
      checklistPv: checklistPv,
      acceptRiscTermine: acceptRiscTermine,
      getLinkedNewRespUtenza: getLinkedNewRespUtenza,
      checklistPvConferma: checklistPvConferma,
      getIpt: getIpt,
      getSpeseLogged: getSpeseLogged,
      confirmSpese: confirmSpese,
      copyRequestPv: copyRequestPv
    };
  })

  .factory(
    "$RichiestePostVenditaService",
    function (
      HttpService,
      $q,
      RichiestePostVendita,
      WorkflowDtoPostVendita,
      Certificate
    ) {
      var loading = false;

      var self = this;

      self.details = {};
      self.responseCheckRichiestaIL = {};

      function getMetadata(response) {
        var snapshot =
          response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
        var metadata = JSON.parse(snapshot.metadata);
        return metadata;
      }

      function nextStep(
        richiestaPostVendita,
        type,
        applicationName,
        onlyLocal
      ) {
        var dto = WorkflowDtoPostVendita.build({
          type: type,
          applicationName: applicationName,
          richiestaPostVendita: richiestaPostVendita,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        return HttpService.send("/uni/workflow/nextStep", dto).then(function (
          response
        ) {
          if (response) {
            var snapshot =
              response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
            var metadata = JSON.parse(snapshot.metadata);

            // Update view index
            metadata.dynamicInputPojo.viewIndex =
              parseInt(metadata.dynamicInputPojo.viewIndex) + 1;

            // Rebuild the model looking at the new viewIndex (++1)
            var model = metadata.dynamicInputPojo;

            return $q.resolve(model);
          } else {
            console.log(
              "$workflowService::nextStep::then:: success false! ",
              response
            );
          }
        });
      }

      function backStep(
        richiestaPostVendita,
        type,
        applicationName,
        onlyLocal
      ) {
        var dto = WorkflowDtoPostVendita.build({
          type: type,
          applicationName: applicationName,
          richiestaPostVendita: richiestaPostVendita,
        });

        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });

        return HttpService.send("/uni/workflow/backToPreviousStep", dto).then(
          function (response) {
            if (response.success) {
              console.log(
                "$workflowService::backToPreviousStep::then" + response
              );

              var snapshot =
                response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
              var metadata = JSON.parse(snapshot.metadata);
              metadata.dynamicInputPojo.viewIndex =
                metadata.dynamicInputPojo.viewIndex - 1;
              var model = metadata.dynamicInputPojo;

              return $q.resolve(model);
            } else {
              console.log(
                "$workflowService::backToPreviousStep::then:: success false!" +
                response
              );
            }
          }
        );
      }

      function backStepPv(
        richiestaPostVendita,
        type,
        applicationName,
        onlyLocal
      ) {
        var dto = WorkflowDtoPostVendita.build({
          type: type,
          applicationName: applicationName,
          richiestaPostVendita: richiestaPostVendita,
        });

        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });

        return HttpService.send("/arc/pv/backToPreviousStep", dto).then(
          function (response) {
            if (response.success) {
              console.log(
                "$workflowService::backToPreviousStep::then" + response
              );

              var snapshot =
                response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
              var metadata = JSON.parse(snapshot.metadata);
              var model = metadata.dynamicInputPojo;
              if (response.frontEndOptions) {
                Object.assign(model, {
                  frontEndOptions: response.frontEndOptions,
                });
              }

              return $q.resolve(model);
            } else {
              console.log(
                "$workflowService::backToPreviousStep::then:: success false!" +
                response
              );
            }
          }
        );
      }

      function resumeInstance(idWfInstance, type, applicationName) {
        var dto = WorkflowDtoPostVendita.build({
          idWf: idWfInstance,
          type: type,
          applicationName: applicationName,
        });

        return HttpService.send("/uni/workflow/resumeInstance", dto, true).then(
          function (response) {
            var snapshot =
              response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
            var metadata = JSON.parse(snapshot.metadata);
            Object.assign(metadata.dynamicInputPojo, {
              route: snapshot.route,
            });

            var model = RichiestePostVendita.build(metadata.dynamicInputPojo);
            if (model && !model.applicationName) {
              model.applicationName = snapshot.applicationName
            }

            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }

            if (response.workflowSoapPojo.wfInstance.insertUser) {
              Object.assign(model, {
                insertUser: response.workflowSoapPojo.wfInstance.insertUser,
              });
            }

            return $q.resolve(model);
          }
        );
      }

      function suspendInstance(
        richiestaPostVendita,
        type,
        applicationName,
        onlyLocal
      ) {
        var dto = WorkflowDtoPostVendita.build({
          type: type,
          applicationName: applicationName,
          richiestaPostVendita: richiestaPostVendita,
        });

        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });

        return HttpService.send("/uni/workflow/draftInstance", dto).then(
          function (response) {
            if (response) {
              if (response.success == true) {
                return $q.resolve(response.success);
              } else {
                return $q.reject(response.success);
              }
            }
          }
        );
      }

      function nextStepPv(
        richiestaPostVendita,
        type,
        applicationName,
        onlyLocal
      ) {
        var dto = WorkflowDtoPostVendita.build({
          type: type,
          applicationName: applicationName,
          richiestaPostVendita: richiestaPostVendita,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        return HttpService.send("/arc/pv/nextStep", dto).then(function (
          response
        ) {
          if (response) {
            var snapshot =
              response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
            var metadata = JSON.parse(snapshot.metadata);

            // Rebuild the model looking at the new viewIndex (++1)
            var model = metadata.dynamicInputPojo;

            if (response.frontEndOptions) {
              Object.assign(model, {
                frontEndOptions: response.frontEndOptions,
              });
            }

            Object.assign(model, {
              goHome: response.goHome,
            });

            return $q.resolve(model);
          } else {
            console.log(
              "$workflowService::nextStep::then:: success false! ",
              response
            );
          }
        });
      }

      function cessioneVoltura(
        cessioneVoltura,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          cessioneVoltura: cessioneVoltura,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/cessioneVoltura", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function updateDocIdentita(
        aggiornamentoDocumenti,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          aggiornamentoDocumenti: aggiornamentoDocumenti,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/updateDocIdentita", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitAutComunale(
        autComunaleModel,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          autorizzazioneComunale: autComunaleModel,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send(
          "/arc/submitRequestPV/autorizzazioneComunale",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function variazioneIban(
        coordinateBancarie,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          coordinateBancarie: coordinateBancarie,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/variazioneIban", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function updateIndBene(varAnagrafica, id, viewIndex) {
        var input = {
          variazioneAnagrafica: varAnagrafica,
          id: id,
          viewIndex: viewIndex,
        };

        return HttpService.send("/arc/submitRequestPV/updateIndBene", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function delegheComCat(delega, id, viewIndex, applicationName, typeWf) {
        var input = {
          delega: delega,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/delegheComCat", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function variazioneAnagSoc(
        variazioneAnagrafica,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          variazioneAnagrafica: variazioneAnagrafica,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/variazioneAnagSoc", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitVariaTar(
        contrattoTargato,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          contrattoTargato: contrattoTargato,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/variazioneTargato", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitSotDocCat(
        sottoscrizioneCatastale,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          sottoscrizioneCatastale: sottoscrizioneCatastale,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/sotDocCat", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function generateDocumentsPv(model) {
        var input = model;
        return HttpService.send("/arc/generateDocumentsPv", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitriscattoATermine(
        riscattoTermine,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          riscattoATermine: riscattoTermine,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/riscattoATermine", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function subprocessList(type, subtype, cluster, codProdotto) {
        var input = {
          type: type,
          subtype: subtype,
          cluster: cluster,
          codProdotto: codProdotto
        };

        return HttpService.send("/arc/subprocessList", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getNazioniWithFilters(incluse, escluse) {
        var input = {
          areaToBeRetrieved: incluse,
          areaToBeExcluded: escluse,
        };
        return HttpService.get("/uni/getNazioniWithFilters", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function updatePersonalActivityPv(idTransaction, ocrIdentityDocument) {
        var input = {
          idTransaction: idTransaction,
          ocrResponse: ocrIdentityDocument,
        };

        return HttpService.send("/simulator/il/updatePersonalActivityPv", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitriscattoAnticipato(
        riscattoAnticipato,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          riscattoAnticipato: riscattoAnticipato,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send(
          "/arc/submitRequestPV/riscattoAnticipato",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitCedente(
        cessioneVoltura,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          cessioneVoltura: cessioneVoltura,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/cedente", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getListQvaData(appContracts, idRichiesta) {
        var input = {
          appContracts: appContracts,
          idRichiesta: idRichiesta,
        };

        return HttpService.send("/user/getListQvaData", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitCessionario(
        cessioneVoltura,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          cessioneVoltura: cessioneVoltura,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/submitRequestPV/cessionario", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function validateQvaPv(
        domande,
        codQuestionario,
        prodotto,
        numeroContratto,
        modulo,
        idRichiesta
      ) {
        var input = {
          domande: domande,
          codQuestionario: codQuestionario,
          prodotto: prodotto,
          contratto: numeroContratto,
          modulo: modulo,
          idRichiesta: idRichiesta,
        };

        return HttpService.send("/user/qva/validate/pv", input, true)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            console.log("ERROR: ", error);
            return $q.reject(error);
          })
          .finally(function () {
            console.log("questionario mandato");
          });
      }

      function getElencoBeniFromList(appContractList) {
        var input = {
          appContractList: appContractList,
        };

        return HttpService.send("/arc/contratti/elencoBeni", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getStepInfo(id, viewIndex) {
        var input = {
          id: id,
          viewIndex: viewIndex,
        };

        return HttpService.send("/arc/getStepInfo", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function startMobileCapturePv(
        persons,
        mobile,
        practiceId,
        identifierCustomer,
        documentsConfig
      ) {
        var input = {
          persons: persons,
          mobile: mobile,
          practiceId: practiceId,
          identifierCustomer: identifierCustomer,
          documentsConfig: documentsConfig,
        };

        return HttpService.send("/uni/startMobileCapturePv", input)
          .then(function (response) {
            console.log(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function deletePracticePv(idPratica) {
        var input = {
          id: idPratica,
          deleted: true
        };

        return HttpService.send("/arc/pv/deleted", input)
          .then(function (response) {
            console.log(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function annullaPracticePv(idPratica) {
        var filter = {
          id: idPratica,
          status: propMap['STATO_PV_ANNULLATO'],
          deleted: false
        };

        return HttpService.send("/arc/pv/deleted", filter)
          .then(function (response) {
            console.log(response);
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getContractsLpf() {
        return HttpService.get("/arc/contrattiLpf")
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function getDocumentsLpf(filters) {
        return HttpService.send("/arc/documentLpf", filters)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitRequestLpf(
        richiestaPostVendita
      ) {
        return HttpService.send("/arc/submitRichiestaLpf", richiestaPostVendita)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function showSpesaLpf(
        richiestePostVendita
      ) {
        return HttpService.send("/arc/showSpesaLpf", richiestePostVendita)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function submitriscattoAnticipatoTerzo(
        riscattoAnticipato,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          riscattoAnticipato: riscattoAnticipato,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send(
          "/arc/submitRequestPV/riscattoAnticipatoTerzo",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function generateAllegatiPv(model) {
        var input = model;
        return HttpService.send("/arc/generateAllegatiPv", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitSublocazioneNoleggio(
        sublocazioneNoleggio,
        id,
        viewIndex,
        applicationName,
        typeWf,
        ctrRichiestaList
      ) {
        var input = {
          sublocazioneNoleggio: sublocazioneNoleggio,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
          ctrRichiestaList: ctrRichiestaList
        };

        return HttpService.send(
          "/arc/submitRequestPV/sublocazioneNoleggio",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function acceptRiscattoAnticipato(
        richiestaPostVendita,
        type,
        applicationName,
        onlyLocal
      ) {
        var dto = WorkflowDtoPostVendita.build({
          type: type,
          applicationName: applicationName,
          richiestaPostVendita: richiestaPostVendita,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        return HttpService.send("/arc/preventive/accept/riscattoAnticipato", dto).then(function (
          response
        ) {
          if (response) {
            if (response.goHome) {
              return $q.resolve(response);
            } else {
              var snapshot =
                response.workflowSoapPojo.wfInstance.listWfSnapshot.pop();
              var metadata = JSON.parse(snapshot.metadata);

              // Rebuild the model looking at the new viewIndex (++1)
              var model = metadata.dynamicInputPojo;

              if (response.frontEndOptions) {
                Object.assign(model, {
                  frontEndOptions: response.frontEndOptions,
                });
              }

              Object.assign(model, {
                goHome: response.goHome,
              });

              return $q.resolve(model);
            }


          } else {
            console.log(
              "$workflowService::nextStep::then:: success false! ",
              response
            );
          }
        });
      }

      function preSubmitRiscAnt(
        riscattoAnticipato,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          riscattoAnticipato: riscattoAnticipato,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send(
          "/arc/submitRequestPV/preSubmitRiscAnt",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function preStartRiscAnt(
        riscattoAnticipato,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          riscattoAnticipato: riscattoAnticipato,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send(
          "/arc/submitRequestPV/preStartRiscAnt",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function checkRespUtenza(responsabileUtenzaPv, id, stato) {
        var input = {
          status: stato,
          id: id,
          metadata: {
            responsabileUtenzaPv: responsabileUtenzaPv,
          },
        };
        return HttpService.send("/arc/checkRespUtenza", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitRequestPvNuovoRespUtenza(id) {
        var input = {
          id: id,
        };
        return HttpService.send("/arc/submitRequestPV/nuovoRespUtenza", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function preAcceptRiscAnt(
        richiestaPostVendita,
        type,
        applicationName,
        onlyLocal
      ) {
        var dto = WorkflowDtoPostVendita.build({
          type: type,
          applicationName: applicationName,
          richiestaPostVendita: richiestaPostVendita,
        });
        Object.assign(dto, {
          onlyLocal: onlyLocal || false,
        });
        return HttpService.send("/arc/preventive/preAcceptRiscAnt", dto)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function submitriscattoAnticipatoImmConf(
        riscattoAnticipato,
        id,
        viewIndex,
        applicationName,
        typeWf
      ) {
        var input = {
          riscattoAnticipato: riscattoAnticipato,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send(
          "/arc/submitRequestPV/riscattoAnticipatoImmConf",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function saveVerbale(gestioneVerbale, id, viewIndex, applicationName, typeWf) {

        var input = {
          gestioneVerbale: gestioneVerbale,
          id: id,
          viewIndex: viewIndex,
          applicationName: applicationName,
          typeWf: typeWf,
        };

        return HttpService.send("/arc/saveVerbale", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function showSpesaIrap(
        richiestePostVendita
      ) {
        return HttpService.send("/arc/showSpesaIrap", richiestePostVendita)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function preStartCessione(
        ctrRichiestaList,
        message,
        subtype,
        type
      ) {
        var input = {
          type: type,
          subtype: subtype,
          metadata: {
            message: message ? message : "",
          },
          ctrRichiestaList: ctrRichiestaList,
        };

        return HttpService.send(
          "/arc/submitRequestPV/preStartCessione",
          input
        )
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      function showSpesaVba(
        richiestePostVendita
      ) {
        return HttpService.send("/arc/showSpesaVba", richiestePostVendita)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          })
      }

      function getFlagPagobolloCessVolt(model) {
        var input = model;
        return HttpService.send("/arc/getFlagPagobolloCessVolt", input)
          .then(function (response) {
            return $q.resolve(response);
          })
          .catch(function (error) {
            return $q.reject(error);
          });
      }

      return {
        nextStep: nextStep,
        backStep: backStep,
        backStepPv: backStepPv,
        resumeInstance: resumeInstance,
        suspendInstance: suspendInstance,
        nextStepPv: nextStepPv,
        submitAutComunale: submitAutComunale,
        updateIndBene: updateIndBene,
        delegheComCat: delegheComCat,
        submitSotDocCat: submitSotDocCat,
        submitriscattoATermine: submitriscattoATermine,
        generateDocumentsPv: generateDocumentsPv,
        submitVariaTar: submitVariaTar,
        variazioneAnagSoc: variazioneAnagSoc,
        variazioneIban: variazioneIban,
        cessioneVoltura: cessioneVoltura,
        updateDocIdentita: updateDocIdentita,
        subprocessList: subprocessList,
        getNazioniWithFilters: getNazioniWithFilters,
        updatePersonalActivityPv: updatePersonalActivityPv,
        submitriscattoAnticipato: submitriscattoAnticipato,
        submitCedente: submitCedente,
        getListQvaData: getListQvaData,
        validateQvaPv: validateQvaPv,
        submitCessionario: submitCessionario,
        getElencoBeniFromList: getElencoBeniFromList,
        getStepInfo: getStepInfo,
        startMobileCapturePv: startMobileCapturePv,
        deletePracticePv: deletePracticePv,
        annullaPracticePv: annullaPracticePv,
        getContractsLpf: getContractsLpf,
        getDocumentsLpf: getDocumentsLpf,
        submitRequestLpf: submitRequestLpf,
        showSpesaLpf: showSpesaLpf,
        submitriscattoAnticipatoTerzo: submitriscattoAnticipatoTerzo,
        generateAllegatiPv: generateAllegatiPv,
        submitSublocazioneNoleggio: submitSublocazioneNoleggio,
        acceptRiscattoAnticipato: acceptRiscattoAnticipato,
        preSubmitRiscAnt: preSubmitRiscAnt,
        preStartRiscAnt: preStartRiscAnt,
        checkRespUtenza: checkRespUtenza,
        submitRequestPvNuovoRespUtenza: submitRequestPvNuovoRespUtenza,
        preAcceptRiscAnt: preAcceptRiscAnt,
        submitriscattoAnticipatoImmConf: submitriscattoAnticipatoImmConf,
        saveVerbale: saveVerbale,
        preStartCessione: preStartCessione,
        showSpesaIrap: showSpesaIrap,
        showSpesaVba: showSpesaVba,
        getFlagPagobolloCessVolt: getFlagPagobolloCessVolt
      };
    }
  );